import axiosInstance from './axiosInstance';
import {
  API_BASE_URL,
  PINCODE_API_BASE_URL,
  APPLICATION_API_BASE_URL,
  USERMANAGEMENT_API_BASE_URL,
  DOCGENERATION_API_BASE_URL,
  LIVEFEED_API_BASE_URL
} from '../configuration/config';
// import generateLandPayload from '../../../utils/generateLandPayload';
// import generateProjectPayload from '../../../utils/generateProjectPayload';
import generateBlockNames from '../../../utils/generateBlockNames';
import { isOperationsDashboardPriorityType } from '../../../utils/operationsDailyTaskTypes';
import { getHeaders, getFileHeaders, getExcelHeaders } from '../../../utils/getToken';
import mixpanelErrorTracker from '../../../utils/mixpanelErrorTracker';
import { buildDrawingDeletePayload } from '../../../utils/accommodationDrawingUtils';
const loadash = require('lodash');

/** Dev guard: list page shorter than meta.total means silent truncation risk. */
function warnIfListTruncated(fnName, rows, meta, { page, limit } = {}) {
  const total = Number(meta?.total);
  const len = Array.isArray(rows) ? rows.length : 0;
  if (
    process.env.NODE_ENV !== 'production' &&
    Number.isFinite(total) &&
    total > len
  ) {
    console.warn(
      `[list-truncation] ${fnName} showing ${len} of ${total}` +
        (page != null ? ` (page=${page}, limit=${limit})` : '')
    );
  }
}

/* 
 GET
*/
export async function getFileRequests() {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/fileRequest`,
      headers
    );
    return response.data;
  } catch (err) {
    console.error(`Error loading file requests: ${err}`);
    mixpanelErrorTracker.trackError('server error - getFileRequests', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getFileRequests',
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function getManagementTasks(projectId) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/task?limit=500`,
      headers
    );
    return response.data;
  } catch (err) {
    console.error(`Error loading management tasks: ${err}`);
    mixpanelErrorTracker.trackError('server error - getManagementTasks', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getManagementTasks',
      project_id: projectId,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function getManagementTaskById(taskId) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/task/${taskId}`,
      headers
    );
    return response.data;
  } catch (err) {
    console.error(`Error loading management task by ID: ${err}`);
    mixpanelErrorTracker.trackError('server error - getManagementTaskById', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getManagementTaskById',
      task_id: taskId,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function updateManagementTask(id, payload) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.put(
      `${APPLICATION_API_BASE_URL}/task/${id}`,
      payload,
      headers
    );
    return response.data;
  } catch (err) {
    console.error(`Error updating management task: ${err}`);
    mixpanelErrorTracker.trackError('server error - updateManagementTask', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'updateManagementTask',
      task_id: id,
      payload: payload,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function createManagementTask(payload) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/task`,
      payload,
      headers
    );
    return response.data;
  } catch (err) {
    console.error(`Error creating management task: ${err}`);
    mixpanelErrorTracker.trackError('server error - createManagementTask', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'createManagementTask',
      payload: payload,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function updateManagementSubTask(id, payload) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.put(
      `${APPLICATION_API_BASE_URL}/task/subtask/${id}`,
      payload,
      headers
    );
    return response.data;
  } catch (err) {
    console.error(`Error updating management subtask: ${err}`);
    mixpanelErrorTracker.trackError('server error - updateManagementSubTask', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'updateManagementSubTask',
      subtask_id: id,
      payload: payload,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function getServiceProviders() {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.get(
      `${USERMANAGEMENT_API_BASE_URL}/serviceprovider/mySp?page=1&limit=500`,
      headers
    );
    return response.data;
  } catch (err) {
    console.error(`Error loading service providers: ${err}`);
    mixpanelErrorTracker.trackError('server error - getServiceProviders', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getServiceProviders',
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function createSubTaskExpense(payload) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/task/expense`,
      payload,
      headers
    );
    return response.data;
  } catch (err) {
    console.error(`Error creating subtask expense: ${err}`);
    mixpanelErrorTracker.trackError('server error - createSubTaskExpense', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'createSubTaskExpense',
      payload: payload,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function getSubTaskExpenses(subTaskId) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/task/expense?subTask_id=${subTaskId}`,
      headers
    );
    return response.data;
  } catch (err) {
    console.error(`Error loading subtask expenses: ${err}`);
    mixpanelErrorTracker.trackError('server error - getSubTaskExpenses', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getSubTaskExpenses',
      subTaskId: subTaskId,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function uploadFileToS3(file) {
  try {
    const headers = await getHeaders();
    const formData = new FormData();
    formData.append('files', file);

    const response = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/s3/upload`,
      formData,
      {
        headers: headers.headers
      }
    );
    return response.data;
  } catch (err) {
    console.error(`Error uploading file to S3: ${err}`);
    mixpanelErrorTracker.trackError('server error - uploadFileToS3', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'uploadFileToS3',
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function approveFileRequest(id, payload) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.put(
      `${APPLICATION_API_BASE_URL}/fileRequest/${id}`,
      payload,
      headers
    );
    return response.data;
  } catch (err) {
    console.error(`Error approving file request: ${err}`);
    mixpanelErrorTracker.trackError('server error - approveFileRequest', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'approveFileRequest',
      id: id,
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export async function getAllCompanies() {
  const headers = await getHeaders();
  const response = await axiosInstance.get(
    `${APPLICATION_API_BASE_URL}/company?limit=500`,
    headers
  );
  return response.data.data;
}

export async function getPreLeadLists() {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/preLeads/lists`,
      headers
    );
    const raw = response.data?.data;
    const overall = raw?.overall ?? raw?.overallCount ?? null;
    const preLeadList = Array.isArray(raw?.preLeadList) ? raw.preLeadList : (Array.isArray(raw) ? raw : []);
    return { overall, preLeadList };
  } catch (err) {
    console.error(`Error loading prelead lists: ${err}`);
    mixpanelErrorTracker.trackError('server error - getPreLeadLists', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getPreLeadLists',
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function createPreLeadList(payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/preLeads/lists`,
      payload,
      headers
    );
    return data.data?.data ?? data.data;
  } catch (err) {
    console.error(`Error creating prelead list: ${err}`);
    mixpanelErrorTracker.trackError('server error - createPreLeadList', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'createPreLeadList',
      payload: payload,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

/** PUT /preLeads/lists/:id — link or unlink WhatsApp flow */
export async function updatePreLeadList(listId, payload) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.put(
      `${APPLICATION_API_BASE_URL}/preLeads/lists/${encodeURIComponent(listId)}`,
      payload,
      headers
    );
    return response.data?.data ?? response.data;
  } catch (err) {
    console.error(`Error updating prelead list: ${err}`);
    mixpanelErrorTracker.trackError('server error - updatePreLeadList', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'updatePreLeadList',
      list_id: listId,
      payload,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

/** DELETE /preLeads/lists/:id */
export async function deletePreLeadList(listId) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.delete(
      `${APPLICATION_API_BASE_URL}/preLeads/lists/${encodeURIComponent(listId)}`,
      headers
    );
    return response.data?.data ?? response.data;
  } catch (err) {
    console.error(`Error deleting prelead list: ${err}`);
    mixpanelErrorTracker.trackError('server error - deletePreLeadList', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'deletePreLeadList',
      list_id: listId,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

/** GET preleads for a list — /preLeads?pre_lead_list_id= */
export async function getPreLeadsByListId({
  preLeadListId,
  page = 1,
  limit = 20,
  state,
  is_disqualified,
  converted_to_lead,
  search
} = {}) {
  try {
    const headers = await getHeaders();
    const query = new URLSearchParams({
      pre_lead_list_id: String(preLeadListId),
      page: String(page),
      limit: String(limit)
    });
    if (state !== undefined && state !== null && String(state).trim() !== '') {
      query.set('state', String(state));
    }
    if (typeof is_disqualified === 'boolean') {
      query.set('is_disqualified', String(is_disqualified));
    }
    if (typeof converted_to_lead === 'boolean') {
      query.set('converted_to_lead', String(converted_to_lead));
    }
    if (search !== undefined && search !== null && String(search).trim() !== '') {
      query.set('search', String(search).trim());
    }
    const response = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/preLeads?${query.toString()}`,
      headers
    );
    const raw = response.data?.data;
    const overall = raw?.overall ?? raw?.overallCount ?? null;
    const preLeads = Array.isArray(raw?.preLeads) ? raw.preLeads : Array.isArray(raw) ? raw : [];
    const responseMeta = response.data?.meta ?? raw?.meta ?? {};
    const filteredTotal = Number(raw?.total ?? responseMeta?.total ?? preLeads.length);
    const resolvedLimit = Number(responseMeta?.limit ?? limit);
    const meta = {
      page: Number(responseMeta?.page ?? page),
      limit: resolvedLimit,
      total: filteredTotal,
      totalPages: Number(
        responseMeta?.totalPages ??
          (filteredTotal > 0 ? Math.ceil(filteredTotal / resolvedLimit) : 1)
      )
    };
    const project_id = raw?.list?.project_id ?? raw?.project_id ?? null;
    const project_name = raw?.list?.project_name ?? raw?.project_name ?? null;
    const list = raw?.list ?? null;
    return { overall, preLeads, meta, project_id, project_name, list };
  } catch (err) {
    console.error(`Error loading preleads for list: ${err}`);
    mixpanelErrorTracker.trackError('server error - getPreLeadsByListId', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getPreLeadsByListId',
      pre_lead_list_id: preLeadListId,
      payload: { page, limit, state, is_disqualified, converted_to_lead, search },
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

/** GET all preleads — /preLeads/all */
export async function getPreLeads({
  page = 1,
  limit = 10,
  id = '',
  is_disqualified,
  state,
  converted_to_lead,
  search
} = {}) {
  try {
    const headers = await getHeaders();
    const query = new URLSearchParams({
      page: String(page),
      limit: String(limit)
    });
    if (id !== undefined && id !== null && String(id).trim() !== '') {
      query.set('id', String(id));
    }
    if (typeof converted_to_lead === 'boolean') {
      query.set('converted_to_lead', String(converted_to_lead));
    }
    if (typeof is_disqualified === 'boolean') {
      query.set('is_disqualified', String(is_disqualified));
    }
    if (state !== undefined && state !== null && String(state).trim() !== '') {
      query.set('state', String(state));
    }
    if (search !== undefined && search !== null && String(search).trim() !== '') {
      query.set('search', String(search).trim());
    }
    const response = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/preLeads/all?${query.toString()}`,
      headers
    );

    const raw = response.data?.data;
    const preLeads = Array.isArray(raw?.preLeads)
      ? raw.preLeads
      : Array.isArray(raw)
        ? raw
        : [];
    const overall = raw?.overall ?? raw?.overallCount ?? null;
    const meta = response.data?.meta ?? raw?.meta ?? { page, limit, totalPages: 1, total: preLeads.length };

    return { overall, preLeads, meta };
  } catch (err) {
    console.error(`Error loading all preleads: ${err}`);
    mixpanelErrorTracker.trackError('server error - getPreLeads', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getPreLeads',
      payload: { page, limit, id, is_disqualified, state, converted_to_lead, search },
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

/**
 * Fan-out contact lookup across leads + preleads.
 * Does not replace list-page search params — used only by SalesGlobalContactSearch.
 */
export async function searchGlobalContacts(query, { limit = 8 } = {}) {
  const q = String(query || '').trim();
  if (q.length < 2) {
    return { leads: [], preleads: [] };
  }

  const [leadsResult, preleadsResult] = await Promise.allSettled([
    getLeadsByStatusAndProject(
      null,
      null,
      null,
      1,
      limit,
      q,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null
    ),
    getPreLeads({ page: 1, limit, search: q })
  ]);

  const leads =
    leadsResult.status === 'fulfilled' && Array.isArray(leadsResult.value?.data)
      ? leadsResult.value.data
      : [];
  const preleads =
    preleadsResult.status === 'fulfilled' && Array.isArray(preleadsResult.value?.preLeads)
      ? preleadsResult.value.preLeads
      : [];

  if (leadsResult.status === 'rejected') {
    console.error('searchGlobalContacts leads failed:', leadsResult.reason);
  }
  if (preleadsResult.status === 'rejected') {
    console.error('searchGlobalContacts preleads failed:', preleadsResult.reason);
  }

  return { leads, preleads };
}

/** GET pending telecalling — /preLeads/pending-telecalling */
export async function getPendingTelecalling({
  company_id,
  page = 1,
  limit = 20,
  search = ''
} = {}) {
  try {
    const headers = await getHeaders();
    const query = new URLSearchParams({
      company_id: String(company_id),
      page: String(page),
      limit: String(limit)
    });
    if (search !== undefined && search !== null && String(search).trim() !== '') {
      query.set('search', String(search).trim());
    }
    const response = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/preLeads/pending-telecalling?${query.toString()}`,
      headers
    );
    const raw = response.data?.data;
    const preLeads = Array.isArray(raw?.preLeads)
      ? raw.preLeads
      : Array.isArray(raw)
        ? raw
        : [];
    const responseMeta = response.data?.meta ?? raw?.meta ?? {};
    const total = Number(raw?.total ?? responseMeta?.total ?? preLeads.length);
    const resolvedLimit = Number(responseMeta?.limit ?? limit);
    const meta = {
      page: Number(responseMeta?.page ?? page),
      limit: resolvedLimit,
      total,
      totalPages: Number(
        responseMeta?.totalPages ?? (total > 0 ? Math.ceil(total / resolvedLimit) : 1)
      )
    };
    return { preLeads, meta, total };
  } catch (err) {
    console.error(`Error loading pending telecalling: ${err}`);
    mixpanelErrorTracker.trackError('server error - getPendingTelecalling', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getPendingTelecalling',
      payload: { company_id, page, limit, search },
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

/** POST bulk assign sales — /preLeads/assign-bulk { pre_lead_ids, sales_id } */
export async function bulkAssignPreLeads({ pre_lead_ids, sales_id }) {
  const payload = {
    pre_lead_ids: Array.from(
      new Set(
        (Array.isArray(pre_lead_ids) ? pre_lead_ids : [])
          .map((id) => Number(id))
          .filter((id) => Number.isFinite(id) && id > 0)
      )
    ).slice(0, 100),
    sales_id: Number(sales_id)
  };
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/preLeads/assign-bulk`,
      payload,
      headers
    );
    return response.data?.data ?? response.data;
  } catch (err) {
    console.error(`Error bulk assigning preleads: ${err}`);
    mixpanelErrorTracker.trackError('server error - bulkAssignPreLeads', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'bulkAssignPreLeads',
      payload,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

/** PUT mark unqualified — /preLeads/:id { is_disqualified, reason } (separate from log) */
export async function markPreLeadAsUnqualified(preLeadId, reason) {
  const trimmedReason = String(reason ?? '').trim();
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.put(
      `${APPLICATION_API_BASE_URL}/preLeads/${preLeadId}`,
      { is_disqualified: true, reason: trimmedReason },
      headers
    );
    return response.data?.data ?? response.data;
  } catch (err) {
    console.error(`Error marking prelead as unqualified: ${err}`);
    mixpanelErrorTracker.trackError('server error - markPreLeadAsUnqualified', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'markPreLeadAsUnqualified',
      pre_lead_id: preLeadId,
      payload: { is_disqualified: true, reason: trimmedReason },
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

/** PUT prelead note — /preLeads/:id { log } (legacy, separate from unqualified) */
export async function addPreLeadLog(preLeadId, log) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.put(
      `${APPLICATION_API_BASE_URL}/preLeads/${preLeadId}`,
      { log: String(log ?? '').trim() },
      headers
    );
    return response.data?.data ?? response.data;
  } catch (err) {
    console.error(`Error adding prelead log: ${err}`);
    mixpanelErrorTracker.trackError('server error - addPreLeadLog', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'addPreLeadLog',
      pre_lead_id: preLeadId,
      payload: { log },
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

/** GET prelead notes — /preLeads/:id/notes */
export async function getPreLeadNotes(preLeadId, { page = 1, limit = 20 } = {}) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/preLeads/${preLeadId}/notes?page=${page}&limit=${limit}`,
      headers
    );
    return response.data?.data ?? response.data;
  } catch (err) {
    console.error(`Error fetching prelead notes: ${err}`);
    mixpanelErrorTracker.trackError('server error - getPreLeadNotes', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getPreLeadNotes',
      pre_lead_id: preLeadId,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

/** POST prelead note — /preLeads/:id/notes */
export async function addPreLeadNote(preLeadId, note) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/preLeads/${preLeadId}/notes`,
      { note: String(note ?? '').trim() },
      headers
    );
    return response.data?.data ?? response.data;
  } catch (err) {
    console.error(`Error adding prelead note: ${err}`);
    mixpanelErrorTracker.trackError('server error - addPreLeadNote', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'addPreLeadNote',
      pre_lead_id: preLeadId,
      payload: { note },
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

/** GET Facebook lead form fields — /preLeads/:id/meta-fields */
export async function getPreLeadMetaFields(preLeadId) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/preLeads/${preLeadId}/meta-fields`,
      headers
    );
    return response.data?.data ?? response.data;
  } catch (err) {
    console.error(`Error loading prelead meta fields: ${err}`);
    mixpanelErrorTracker.trackError('server error - getPreLeadMetaFields', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getPreLeadMetaFields',
      pre_lead_id: preLeadId,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

/** GET Google Ads lead form fields — /preLeads/:id/google-ads-fields */
export async function getPreLeadGoogleAdsFields(preLeadId) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/preLeads/${preLeadId}/google-ads-fields`,
      headers
    );
    return response.data?.data ?? response.data;
  } catch (err) {
    console.error(`Error loading prelead Google Ads fields: ${err}`);
    throw err;
  }
}

/** GET Website/Framer form fields — /preLeads/:id/website-form-fields */
export async function getPreLeadWebsiteFormFields(preLeadId) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/preLeads/${preLeadId}/website-form-fields`,
      headers
    );
    return response.data?.data ?? response.data;
  } catch (err) {
    console.error(`Error loading prelead website form fields: ${err}`);
    mixpanelErrorTracker.trackError('server error - getPreLeadWebsiteFormFields', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getPreLeadWebsiteFormFields',
      pre_lead_id: preLeadId,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A'
    });
    throw err;
  }
}

export async function pollGoogleAdsLeads(companyId) {
  try {
    const headers = await getHeaders();
    const { data } = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/googleAds/leads/poll`,
      companyId ? { company_id: companyId } : {},
      headers
    );
    return data?.data;
  } catch (err) {
    console.error(`Error polling Google Ads leads: ${err}`);
    throw err;
  }
}

export async function downloadPreLeadTemplate(preLeadListId) {
  try {
    const headers = await getHeaders();
    const url = `${APPLICATION_API_BASE_URL}/preLeads/download/template?pre_lead_list_id=${preLeadListId}`;
    const response = await axiosInstance.get(url, {
      ...headers,
      responseType: 'arraybuffer'
    });
    return response.data;
  } catch (err) {
    console.error(`Error downloading prelead template: ${err}`);
    mixpanelErrorTracker.trackError('server error - downloadPreLeadTemplate', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'downloadPreLeadTemplate',
      pre_lead_list_id: preLeadListId,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function uploadPreLeadTemplate(preLeadListId, formData) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/preLeads/upload/template?pre_lead_list_id=${preLeadListId}`,
      formData,
      headers
    );
    return data.data;
  } catch (err) {
    console.error(`Error uploading prelead template: ${err}`);
    mixpanelErrorTracker.trackError('server error - uploadPreLeadTemplate', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'uploadPreLeadTemplate',
      pre_lead_list_id: preLeadListId,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function handleCheckCompanyDelete(id) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/company/checkDelete/${id}`,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error checking company: ${err}`);
    mixpanelErrorTracker.trackError('server error - handleCheckCompanyDelete', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'handleCheckCompanyDelete',
      company_id: id,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err; // throw new Error('Error checking company');
  }
}

export async function deleteCompany(payload) {
  try {
    const headers = await getHeaders(); // contains { headers: { Authorization: '...' } }

    const response = await axiosInstance.delete(`${APPLICATION_API_BASE_URL}/company/delete`, {
      ...headers,
      data: payload
    });

    return response.data.data;
  } catch (err) {
    console.error('Error deleting company:', err?.response || err);
    mixpanelErrorTracker.trackError('server error - deleteCompany', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'deleteCompany',
      payload: payload,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err; // throw new Error('Error deleting company');
  }
}

export async function getAllFBPages(id) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.get(`${APPLICATION_API_BASE_URL}/fb/pages/${id}`, headers);
    return response.data.data;
  } catch (err) {
    console.error(`Error loading FB pages: ${err}`);
    mixpanelErrorTracker.trackError('server error - getAllFBPages', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getAllFBPages',
      fb_page_id: id,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function createFBPage(payload) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/fb/pages`,
      payload,
      headers
    );
    return response.data.data;
  } catch (err) {
    console.error(`Error creating FB page: ${err}`);
    mixpanelErrorTracker.trackError('server error - createFBPage', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'createFBPage',
      payload: payload,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function getPageById(id) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/fb/pagesId/${id}`,
      headers
    );
    return response.data.data;
  } catch (err) {
    console.error(`Error getting page by ID: ${err}`);
    mixpanelErrorTracker.trackError('server error - getPageById', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getPageById',
      page_id: id,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function getForms(payload) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/fb/forms`,
      payload,
      headers
    );
    return response.data.data;
  } catch (err) {
    console.error(`Error getting forms: ${err}`);
    mixpanelErrorTracker.trackError('server error - getForms', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getForms',
      payload: payload,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function updateForm(id, payload) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.put(
      `${APPLICATION_API_BASE_URL}/fb/form/${id}`,
      payload,
      headers
    );
    return response.data.data;
  } catch (err) {
    console.error(`Error updating form: ${err}`);
    mixpanelErrorTracker.trackError('server error - updateForm', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'updateForm',
      form_id: id,
      payload: payload,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function subscribe(payload) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/fb/webhookSubscribe`,
      payload,
      headers
    );
    return response.data.data;
  } catch (err) {
    console.error(`Error subscribing webhook: ${err}`);
    mixpanelErrorTracker.trackError('server error - subscribe', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'subscribe',
      payload: payload,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function faceBookCallBack(payload) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/fb/token`,
      payload,
      headers
    );
    return response.data.data;
  } catch (err) {
    console.error(`Error in Facebook callback: ${err}`);
    mixpanelErrorTracker.trackError('server error - faceBookCallBack', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'faceBookCallBack',
      payload: payload,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

/** GET /fb/ad-accounts?company_id= — returns { accounts, selected } */
export async function getFbAdAccounts(companyId) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/fb/ad-accounts?company_id=${companyId}`,
      headers
    );
    return response.data.data;
  } catch (err) {
    console.error(`Error loading FB ad accounts: ${err}`);
    mixpanelErrorTracker.trackError('server error - getFbAdAccounts', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getFbAdAccounts',
      company_id: companyId,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

/** POST /fb/ad-account — body: { company_id, meta_ad_account_id, name?, currency? } */
export async function saveFbAdAccount(payload) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/fb/ad-account`,
      payload,
      headers
    );
    return response.data.data;
  } catch (err) {
    console.error(`Error saving FB ad account: ${err}`);
    mixpanelErrorTracker.trackError('server error - saveFbAdAccount', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'saveFbAdAccount',
      payload,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

/** GET /fb/meta-campaigns?company_id= — no sync on load */
export async function getFbMetaCampaigns(companyId) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/fb/meta-campaigns?company_id=${companyId}`,
      headers
    );
    return response.data.data;
  } catch (err) {
    console.error(`Error loading FB meta campaigns: ${err}`);
    mixpanelErrorTracker.trackError('server error - getFbMetaCampaigns', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getFbMetaCampaigns',
      company_id: companyId,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

/** POST /fb/meta-campaigns/sync — body: { company_id } */
export async function syncFbMetaCampaigns(payload) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/fb/meta-campaigns/sync`,
      payload,
      headers
    );
    return response.data.data;
  } catch (err) {
    console.error(`Error syncing FB meta campaigns: ${err}`);
    mixpanelErrorTracker.trackError('server error - syncFbMetaCampaigns', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'syncFbMetaCampaigns',
      payload,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

/** PUT /fb/meta-campaigns/:id/map — advanced/manual Instant Form override only */
export async function mapFbMetaCampaign(campaignId, payload) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.put(
      `${APPLICATION_API_BASE_URL}/fb/meta-campaigns/${campaignId}/map`,
      payload,
      headers
    );
    return response.data.data;
  } catch (err) {
    console.error(`Error mapping FB meta campaign: ${err}`);
    mixpanelErrorTracker.trackError('server error - mapFbMetaCampaign', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'mapFbMetaCampaign',
      campaign_id: campaignId,
      payload,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

/**
 * PUT /fb/meta-campaigns/:id/setup — link campaign to project (+ optional sales).
 * Body: { company_id, project_id, sales_ids? }
 */
export async function setupFbMetaCampaign(campaignId, payload) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.put(
      `${APPLICATION_API_BASE_URL}/fb/meta-campaigns/${campaignId}/setup`,
      payload,
      headers
    );
    return response.data.data;
  } catch (err) {
    console.error(`Error setting up FB meta campaign: ${err}`);
    mixpanelErrorTracker.trackError('server error - setupFbMetaCampaign', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'setupFbMetaCampaign',
      campaign_id: campaignId,
      payload,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

/** GET /marketing/campaigns/:id/summary — card metrics for a meta campaign */
export async function getMarketingCampaignSummary(campaignId) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/marketing/campaigns/${campaignId}/summary`,
      headers
    );
    return response.data.data;
  } catch (err) {
    console.error(`Error loading marketing campaign summary: ${err}`);
    mixpanelErrorTracker.trackError('server error - getMarketingCampaignSummary', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getMarketingCampaignSummary',
      campaign_id: campaignId,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

/** GET /marketing/campaigns/:id/breakdown?range=last_7d|all or ?from=&to= (YYYY-MM-DD) */
export async function getMarketingCampaignBreakdown(campaignId, params = 'last_7d') {
  try {
    const headers = await getHeaders();
    const query =
      typeof params === 'string'
        ? `range=${encodeURIComponent(params)}`
        : params?.from && params?.to
          ? `from=${encodeURIComponent(params.from)}&to=${encodeURIComponent(params.to)}`
          : `range=${encodeURIComponent(params?.range || 'last_7d')}`;
    const response = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/marketing/campaigns/${campaignId}/breakdown?${query}`,
      headers
    );
    return response.data.data;
  } catch (err) {
    console.error(`Error loading marketing campaign breakdown: ${err}`);
    mixpanelErrorTracker.trackError('server error - getMarketingCampaignBreakdown', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getMarketingCampaignBreakdown',
      campaign_id: campaignId,
      params,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function getCompanyByID(companyId) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/company/${companyId}?limit=500`,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - getCompanyByID', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getCompanyByID',
      company_id: companyId,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err; // throw new Error('company data not loaded');
  }
}



export async function addCompanySecret(payload) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/company/secret`,
      payload,
      headers
    );
    return response.data.data;
  } catch (err) {
    console.error(`Error adding company secret: ${err}`);
    mixpanelErrorTracker.trackError('server error - addCompanySecret', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'addCompanySecret',
      payload: payload,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function checkCompanySMTP(companyId) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/company/smtp/${companyId}`,
      headers
    );
    return response.data;
  } catch (err) {
    console.error(`Error checking company SMTP: ${err}`);
    return null;
  }
}

export async function getCompanyAddresses(companyId) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/company/address?company_id=${companyId}`,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error loading company addresses: ${err}`);
    mixpanelErrorTracker.trackError('server error - getCompanyAddresses', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getCompanyAddresses',
      company_id: companyId,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err; // throw new Error('company addresses not loaded');
  }
}

export async function getStateAndCity(pincode) {
  try {
    const data = await axiosInstance.get(`${PINCODE_API_BASE_URL}/${pincode}`);
    return data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - getStateAndCity', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getStateAndCity',
      pincode: pincode,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err; // throw new Error('getStateAndCity data not loaded');
  }
}

/* 
 POST
*/
export async function createCompany(newCompany) {
  newCompany = {
    ...newCompany,
    pan: newCompany?.pan?.toUpperCase(),
    gst: newCompany?.gst?.toUpperCase()
  };

  try {
    const headers = await getHeaders();
    const data = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/company`,
      newCompany,
      headers
    );
    return data.data.data;
  } catch (err) {
    if (err.response && err.response.data && err.response.data.message) {
      err.message = err.response.data.message;
    } else {
      err.message = 'New company not created';
    }

    mixpanelErrorTracker.trackError('server error - createCompany', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'createCompany',
      company_data: newCompany,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });

    throw err; // Re-throw the full error object for further handling
  }
}

/* 
  PUT
*/
export async function updateCompany(updatedCompany, companyId) {
  console.log({ updatedCompany });
  Object.keys(updatedCompany).forEach((key) => {
    if (updatedCompany[key] === '') {
      delete updatedCompany[key];
    }
  });

  try {
    const headers = await getHeaders();
    const data = await axiosInstance.put(
      `${APPLICATION_API_BASE_URL}/company/${companyId}`,
      {
        ...updatedCompany
      },
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error updating company: ${err}`);
    mixpanelErrorTracker.trackError('server error - updateCompany', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'updateCompany',
      company_id: companyId,
      updated_data: updatedCompany,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err; // throw new Error('Company update failed');
  }
}

// Add Acccommodation's Add_Independent function
export async function addIndependentStatic(independent, setIndependent, postData) {
  try {
    setIndependent([...independent, postData]);
    return postData;
  } catch (err) {
    console.error(`Error adding independent: ${err}`);
    mixpanelErrorTracker.trackError('server error - addIndependentStatic', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'addIndependentStatic',
      post_data: postData,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err; // throw new Error('Error adding new independent');
  }
}

// Add Acccommodation's Add_Group function
export async function addGroupStatic(group, setGroup, postData) {
  try {
    setGroup([...group, postData]);
    return postData;
  } catch (err) {
    console.error(`Error adding group: ${err}`);
    mixpanelErrorTracker.trackError('server error - addGroupStatic', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'addGroupStatic',
      post_data: postData,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err; // throw new Error('Error adding new group');
  }
}

// Add Acccommodation's Add_Parking function
export async function addParkingStatic(parking, setParking, postData) {
  try {
    setParking([...parking, postData]);
    return postData;
  } catch (err) {
    console.error(`Error adding parking: ${err}`);
    mixpanelErrorTracker.trackError('server error - addParkingStatic', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'addParkingStatic',
      post_data: postData,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err; // throw new Error('Error adding new parking');
  }
}

export async function addAccommodationStatic(id, postData) {
  try {
    let selectedData = postData.filter((item) => item.id === id);
    return selectedData[0];
  } catch (err) {
    console.error(`Error adding parking: ${err}`);
    mixpanelErrorTracker.trackError('server error - addAccommodationStatic', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'addAccommodationStatic',
      id: id,
      post_data: postData,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err; // throw new Error('Error adding new parking');
  }
}

// Add Project function
export async function addProjectStatic(project, setProject, postData) {
  try {
    setProject([...project, postData]);
    return postData;
  } catch (err) {
    console.error(`Error adding Project: ${err}`);
    mixpanelErrorTracker.trackError('server error - addProjectStatic', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'addProjectStatic',
      post_data: postData,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}



export const addProject = async (newProject) => {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/project`,
      newProject,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error('Add Project Error', err);
    mixpanelErrorTracker.trackError('server error - addProject', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'addProject',
      project_data: newProject,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err; // Properly throw the error for React Query to handle
  }
};

export function getIdProjectStatic(id, postData) {
  try {
    let selectedData = postData.filter((item) => item.id === id);
    return selectedData[0];
  } catch (err) {
    console.error(`Error adding getidProject: ${err}`);
    mixpanelErrorTracker.trackError('server error - getIdProjectStatic', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getIdProjectStatic',
      id: id,
      post_data: postData,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err; // throw new Error('Error adding new getidProject');
  }
}

///////////////////////////////////////
/// Users API's
export async function getAllUsers(page = 1, limit = 20000, search = '') {
  try {
    const headers = await getHeaders();
    let url = `${USERMANAGEMENT_API_BASE_URL}/users?page=${page}&limit=${limit}`;
    if (search) {
      url += `&search=${encodeURIComponent(search)}`;
    }
    const data = await axiosInstance.get(url, headers);
    return data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - getAllUsers', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getAllUsers',
      page: page,
      limit: limit,
      search: search,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err; // throw new Error('Users data not loaded');
  }
}

/**
 * Fetch user profile. Default is lite (role/designation/company/project mappings).
 * Pass { full: true } for permissions, managers/reportees, and vendor tree
 * (UserDetails, EditUser, View Manager / View Team).
 */
export async function getUserById(userId, options = {}) {
  try {
    const headers = await getHeaders();
    const full = options?.full === true;
    const url = full
      ? `${USERMANAGEMENT_API_BASE_URL}/users/${userId}?full=1`
      : `${USERMANAGEMENT_API_BASE_URL}/users/${userId}`;
    const data = await axiosInstance.get(url, headers);
    return data.data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - getUserById', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getUserById',
      user_id: userId,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err; // throw new Error('User data not loaded');
  }
}

/** Company ids from lite/full user payload (mapping or legacy companies array). */
export function getUserCompanyIds(user) {
  if (!user) return [];
  const fromMapping = (user.userCompanyMapping || [])
    .map((m) => m?.company?.id ?? m?.company_id)
    .filter((id) => id != null);
  if (fromMapping.length) return fromMapping.map(Number);
  const fromCompanies = (user.companies || [])
    .map((c) => (typeof c === 'object' ? c?.id : c))
    .filter((id) => id != null);
  return fromCompanies.map(Number);
}

export async function handleCheckUserDelete(id) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/users/checkDelete/${id}`,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error checking users to delete: ${err}`);
    mixpanelErrorTracker.trackError('server error - handleCheckUserDelete', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'handleCheckUserDelete',
      user_id: id,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err; // throw new Error('Error checking users to delete');
  }
}

export async function deleteUser(payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.delete(`${APPLICATION_API_BASE_URL}/users/delete/`, {
      ...headers,
      data: payload
    });

    return data.data.data;
  } catch (err) {
    console.error(`Error deleting users: ${err}`);
    mixpanelErrorTracker.trackError('server error - deleteUser', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'deleteUser',
      payload: payload,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err; // throw new Error('Error deleting users');
  }
}

export async function getTaskComments(subTaskId) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/task/comment?subTask_id=${subTaskId}`,
      headers
    );
    return response.data;
  } catch (err) {
    console.error(`Error loading task comments: ${err}`);
    mixpanelErrorTracker.trackError('server error - getTaskComments', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getTaskComments',
      sub_task_id: subTaskId,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function createSubTaskComment(payload) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/task/comment`,
      payload,
      headers
    );
    return response.data;
  } catch (err) {
    console.error(`Error creating subtask comment: ${err}`);
    mixpanelErrorTracker.trackError('server error - createSubTaskComment', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'createSubTaskComment',
      payload: payload,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function getTaskLogs(subTaskId) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/task/logs?subTask_id=${subTaskId}`,
      headers
    );
    return response.data;
  } catch (err) {
    console.error(`Error loading task logs: ${err}`);
    mixpanelErrorTracker.trackError('server error - getTaskLogs', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getTaskLogs',
      sub_task_id: subTaskId,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function createSubTaskLog(payload) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/task/logs`,
      payload,
      headers
    );
    return response.data;
  } catch (err) {
    console.error(`Error creating subtask log: ${err}`);
    mixpanelErrorTracker.trackError('server error - createSubTaskLog', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'createSubTaskLog',
      payload: payload,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function createUser(newUser) {
  // newUser = { ...newUser, role_id: 1, project_id: 1 };

  try {
    const headers = await getHeaders();
    const data = await axiosInstance.post(`${USERMANAGEMENT_API_BASE_URL}/users`, newUser, headers);
    return data.data.data;
  } catch (err) {
    console.error(`Error creating new user: ${err}`);
    mixpanelErrorTracker.trackError('server error - createUser', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'createUser',
      user_data: newUser,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function deleteUserById(userId) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.delete(
      `${USERMANAGEMENT_API_BASE_URL}/users/${userId}`,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error deleting new user: ${err}`);
    mixpanelErrorTracker.trackError('server error - deleteUserById', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'deleteUserById',
      user_id: userId,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err; // throw new Error('User not deleted');
  }
}

export async function updateUserById(userId, updatedUser) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.put(
      `${USERMANAGEMENT_API_BASE_URL}/users/${userId}`,
      updatedUser,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error updating user: ${err}`);
    mixpanelErrorTracker.trackError('server error - updateUserById', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'updateUserById',
      user_id: userId,
      updated_data: updatedUser,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

// User Permission Api

export async function editPermission(payload) {
  try {
    const headers = await getHeaders();
    const { data } = await axiosInstance.put(
      `${USERMANAGEMENT_API_BASE_URL}/permissions/bulk`,
      payload,
      headers
    );
    return data.data;
  } catch (err) {
    console.error(`Error editPermission user: ${err}`);
    mixpanelErrorTracker.trackError('server error - editPermission', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'editPermission',
      payload: payload,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    // Pass through the entire error object so the caller can access the response
    throw err;
  }
}

///////////////////////////////////////
/// Roles API's
export async function getAllRoles() {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(`${APPLICATION_API_BASE_URL}/roles?limit=100`, headers);
    return data.data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - getAllRoles', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getAllRoles',
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err; // throw new Error('Roles data not loaded');
  }
}

export async function getAllDesignations() {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/designations?limit=50`,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error designations data: ${err}`);
    mixpanelErrorTracker.trackError('server error - getAllDesignations', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getAllDesignations',
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err; // throw new Error('Designations data not loaded');
  }
}

// Add Land API for static data
export function getIdLandsStatic(id, postData) {
  try {
    let selectedData = postData.filter((item) => item.id === parseInt(id));
    return selectedData[0];
  } catch (err) {
    console.error(`Error adding getidLand: ${err}`);
    mixpanelErrorTracker.trackError('server error - getIdLandsStatic', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getIdLandsStatic',
      id: id,
      post_data: postData,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err; // throw new Error('Error adding new getIdLands');
  }
}

// Add PLC for Unit API for static data
export function addUnitPLC(Unit, setUnit, postData) {
  try {
    setUnit([...Unit, postData]);
    return postData;
  } catch (err) {
    console.error(`Error adding Unit: ${err}`);
    mixpanelErrorTracker.trackError('server error - addUnitPLC', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'addUnitPLC',
      Unit: Unit,
      setUnit: setUnit,
      post_data: postData,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err; // throw new Error('Error adding new Unit');
  }
}


// Add PLC for List API for static data
export function addListPLC(List, setList, postData) {
  try {
    setList([...List, postData]);
    return postData;
  } catch (err) {
    console.error(`Error adding List: ${err}`);
    mixpanelErrorTracker.trackError('server error - addListPLC', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'addListPLC',
      List: List,
      setList: setList,
      post_data: postData
    });
    throw err; // throw new Error('Error adding new List');
  }
}

export async function createLand(newLand) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.post(`${APPLICATION_API_BASE_URL}/land`, newLand, headers);
    return data.data.data;
  } catch (err) {
    console.error(`Error creating company: ${err}`);
    mixpanelErrorTracker.trackError('server error - createLand', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'createLand',
      land_data: newLand,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err; // throw new Error('New company not created');
  }
}

export async function getAllLands() {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(`${APPLICATION_API_BASE_URL}/land?limit=200`, headers);
    return data.data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - getAllLands', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getAllLands',
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err; // throw new Error('Lands data not loaded');
  }
}

export async function getLandById(id) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(`${APPLICATION_API_BASE_URL}/land/${id}`, headers);
    return data.data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - getLandById', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getLandById',
      land_id: id,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err; // throw new Error('Land data not loaded');
  }
}

export async function handleCheckLandDelete(id) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/land/checkDelete/${id}`,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error checking isDelete: ${err}`);
    mixpanelErrorTracker.trackError('server error - handleCheckLandDelete', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'handleCheckLandDelete',
      land_id: id,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err; // throw new Error('Error checking isDelete');
  }
}

export async function deleteLand(payload) {
  try {
    const headers = await getHeaders(); // contains { headers: { Authorization: '...' } }

    const response = await axiosInstance.delete(`${APPLICATION_API_BASE_URL}/land/delete`, {
      ...headers,
      data: payload
    });

    return response.data.data;
  } catch (err) {
    console.error('Error deleting land:', err?.response || err);
    mixpanelErrorTracker.trackError('server error - deleteLand', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'deleteLand',
      payload: payload,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err; // throw new Error('Error deleting land');
  }
}

export async function editLandById(id, payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.put(
      `${APPLICATION_API_BASE_URL}/land/${id}`,
      payload,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error editing lands: ${err}`);
    mixpanelErrorTracker.trackError('server error - editLandById', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'editLandById',
      land_id: id,
      payload: payload,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

// Project Stats api
export async function getProjectStats(id) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/project/project_stats?company_id=${id}`,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - getProjectStats', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getProjectStats',
      company_id: id,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function handleCheckProjectDelete(id) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/project/checkDelete/${id}`,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error checking project to delete: ${err}`);
    mixpanelErrorTracker.trackError('server error - handleCheckProjectDelete', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'handleCheckProjectDelete',
      project_id: id,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function deleteProject(payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.delete(`${APPLICATION_API_BASE_URL}/project/delete/`, {
      ...headers,
      data: payload
    });

    return data.data.data;
  } catch (err) {
    console.error(`Error deleting project: ${err}`);
    mixpanelErrorTracker.trackError('server error - deleteProject', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'deleteProject',
      payload: payload,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

//////////////////////////////////////////
/// PROJECTS API's
export async function createProject(newProject) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/project`,
      newProject,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error creating project: ${err}`);
    mixpanelErrorTracker.trackError('server error - createProject', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'createProject',
      project_data: newProject,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err; // throw new Error('New project not created');
  }
}

export async function payManagementTaskExpense(id) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.put(
      `${APPLICATION_API_BASE_URL}/accountPriorities/${id}`,
      {},
      headers
    );
    return response.data;
  } catch (err) {
    console.error(`Error paying management task expense: ${err}`);
    mixpanelErrorTracker.trackError('server error - payManagementTaskExpense', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'payManagementTaskExpense',
      id: id,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}


export async function getAllProjects() {
  try {
    const headers = await getHeaders();
    // summary=1: shell/dropdown fields without docs/land/khasra/accommodations N+1
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/project?limit=500&summary=1`,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - getAllProjects', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getAllProjects',
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err; // throw new Error('Projects data not loaded');
  }
}

/////////////////////
// CAMPAIGNS API

export async function getMarketingDashBoardData(id, year) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/campaign/stats/${id}?year=${year}`,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error loading stats: ${err}`);
    mixpanelErrorTracker.trackError('server error - getMarketingDashBoardData', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getMarketingDashBoardData',
      id: id,
      year: year,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Stats not loaded');
  }
}

export async function createCampaignTemplate(payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/marketingTemplate`,
      payload,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error creating campaign template: ${err}`);
    mixpanelErrorTracker.trackError('server error - createCampaignTemplate', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'createCampaignTemplate',
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // Properly throw the error for React Query to handle
  }
}

export async function getCampaignTemplate(id) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/marketingTemplate?project_id=${id}`,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error getting campaign template: ${err}`);
    mixpanelErrorTracker.trackError('server error - getCampaignTemplate', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getCampaignTemplate',
      id: id,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // Properly throw the error for React Query to handle
  }
}

export async function updateCampaignTemplate(id, payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.put(
      `${APPLICATION_API_BASE_URL}/marketingTemplate/${id}`,
      payload,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error updating campaign template: ${err}`);
    mixpanelErrorTracker.trackError('server error - updateCampaignTemplate', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'updateCampaignTemplate',
      id: id,
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // Properly throw the error for React Query to handle
  }
}

export async function getAllCampaigns(id) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/campaign?project_id=${id}&limit=10000`,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - getAllCampaigns', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getAllCampaigns',
      id: id,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Campaigns data not loaded');
  }
}

export async function getCampaignById(id) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(`${APPLICATION_API_BASE_URL}/campaign/${id}`, headers);
    return data.data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - getCampaignById', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getCampaignById',
      id: id,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Campaign data not loaded');
  }
}

/*
  WhatsApp Inbox (agent-facing) — base path: /whatsapp/inbox
  All responses are wrapped as { status, message, data, meta }; these helpers return `data`.
*/
const WHATSAPP_INBOX_BASE = `${APPLICATION_API_BASE_URL}/whatsapp/inbox`;

/**
 * GET /whatsapp/inbox/conversations
 * @param {{ search?: string, unread_only?: boolean, has_inbound?: boolean,
 *   state?: 'interested'|'not_interested'|'pending', campaign_id?: number|string,
 *   project_id?: number|string, pre_lead_list_id?: number|string,
 *   updated_after?: string, page?: number, limit?: number }} params
 */
export async function getInboxConversations(params = {}) {
  try {
    const headers = await getHeaders();
    const query = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        query.append(key, value);
      }
    });
    const qs = query.toString();
    const response = await axiosInstance.get(
      `${WHATSAPP_INBOX_BASE}/conversations${qs ? `?${qs}` : ''}`,
      headers
    );
    return response.data.data;
  } catch (err) {
    console.error(`Error loading inbox conversations: ${err}`);
    mixpanelErrorTracker.trackError('server error - getInboxConversations', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getInboxConversations',
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

/**
 * GET /whatsapp/inbox/conversations/:phone/messages
 * Messages come newest-first per page; reverse to oldest→newest for display.
 * @param {string} phoneNumber conversation phone_number (e.g. 917709551702)
 * @param {{ page?: number, limit?: number }} options limit max 100
 */
export async function getInboxMessages(phoneNumber, { page = 1, limit = 50 } = {}) {
  try {
    const headers = await getHeaders();
    const phone = encodeURIComponent(String(phoneNumber));
    const response = await axiosInstance.get(
      `${WHATSAPP_INBOX_BASE}/conversations/${phone}/messages?page=${page}&limit=${limit}`,
      headers
    );
    return response.data.data;
  } catch (err) {
    console.error(`Error loading inbox messages: ${err}`);
    mixpanelErrorTracker.trackError('server error - getInboxMessages', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getInboxMessages',
      phone_number: phoneNumber,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

/**
 * POST /whatsapp/inbox/conversations/:phone/read
 * Call when the agent opens a conversation. Returns { phone_number, unread_count: 0, last_read_at }.
 * @param {string} phoneNumber
 */
export async function markInboxConversationRead(phoneNumber) {
  try {
    const headers = await getHeaders();
    const phone = encodeURIComponent(String(phoneNumber));
    const response = await axiosInstance.post(
      `${WHATSAPP_INBOX_BASE}/conversations/${phone}/read`,
      {},
      headers
    );
    return response.data.data;
  } catch (err) {
    console.error(`Error marking inbox conversation read: ${err}`);
    mixpanelErrorTracker.trackError('server error - markInboxConversationRead', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'markInboxConversationRead',
      phone_number: phoneNumber,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

/**
 * POST /whatsapp/inbox/conversations/:phone/messages
 * Success (201): { sent: true, messageId, phone_number, message: {…saved row} }
 * 400 errors surface as toasts (integration/vendor not configured, 24h session, etc.).
 * @param {string} phoneNumber
 * @param {string} text
 */
export async function sendInboxMessage(phoneNumber, text) {
  try {
    const headers = await getHeaders();
    const phone = encodeURIComponent(String(phoneNumber));
    const response = await axiosInstance.post(
      `${WHATSAPP_INBOX_BASE}/conversations/${phone}/messages`,
      { text },
      headers
    );
    return response.data.data;
  } catch (err) {
    console.error(`Error sending inbox message: ${err}`);
    mixpanelErrorTracker.trackError('server error - sendInboxMessage', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'sendInboxMessage',
      phone_number: phoneNumber,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

/**
 * POST /whatsapp/inbox/conversations/:phone/media
 * multipart/form-data: file (required), type (optional).
 * Do NOT set Content-Type manually — axios adds the multipart boundary.
 * Success (201): { sent: true, messageId, phone_number, message: {…saved row} }
 * @param {string} phoneNumber
 * @param {{ file: File, type?: 'image'|'video'|'document'|'audio' }} payload
 */
export async function sendInboxMedia(phoneNumber, { file, type } = {}) {
  try {
    const headers = await getHeaders();
    const phone = encodeURIComponent(String(phoneNumber));
    const formData = new FormData();
    formData.append('file', file);
    if (type) formData.append('type', type);

    const response = await axiosInstance.post(
      `${WHATSAPP_INBOX_BASE}/conversations/${phone}/media`,
      formData,
      { headers: headers.headers }
    );
    return response.data.data;
  } catch (err) {
    console.error(`Error sending inbox media: ${err}`);
    mixpanelErrorTracker.trackError('server error - sendInboxMedia', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'sendInboxMedia',
      phone_number: phoneNumber,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function getWhatsAppCampaigns(projectId) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/whatsappCampaign`,
      headers
    );
    return response.data.data;
  } catch (err) {
    console.error(`Error loading WhatsApp campaigns: ${err}`);
    mixpanelErrorTracker.trackError('server error - getWhatsAppCampaigns', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getWhatsAppCampaigns',
      project_id: projectId,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function createWhatsAppCampaign(payload) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/whatsappCampaign`,
      payload,
      headers
    );
    return response.data.data;
  } catch (err) {
    console.error(`Error creating WhatsApp campaign: ${err}`);
    mixpanelErrorTracker.trackError('server error - createWhatsAppCampaign', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'createWhatsAppCampaign',
      payload: payload,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

/**
 * POST /WhatsAppCampaign/:id/start
 * @param {number|string} whatsappCampaignId
 * @param {{ pre_lead_list_id: number, whatsapp_template_id: number, pre_lead_ids: number[] }} body
 */
export async function startWhatsAppCampaign(whatsappCampaignId, body) {
  try {
    const headers = await getHeaders();
    const id = encodeURIComponent(String(whatsappCampaignId));
    const response = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/WhatsAppCampaign/${id}/start`,
      body,
      headers
    );
    return response.data?.data ?? response.data;
  } catch (err) {
    console.error(`Error starting WhatsApp campaign: ${err}`);
    mixpanelErrorTracker.trackError('server error - startWhatsAppCampaign', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'startWhatsAppCampaign',
      whatsapp_campaign_id: whatsappCampaignId,
      payload: body,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

/**
 * GET /whatsappCampaign/:id/runs
 * @param {number|string} whatsappCampaignId
 */
export async function getWhatsAppCampaignRuns(whatsappCampaignId) {
  try {
    const headers = await getHeaders();
    const id = encodeURIComponent(String(whatsappCampaignId));
    const response = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/whatsappCampaign/${id}/runs`,
      headers
    );
    const data = response.data?.data;
    return Array.isArray(data) ? data : [];
  } catch (err) {
    console.error(`Error loading WhatsApp campaign runs: ${err}`);
    mixpanelErrorTracker.trackError('server error - getWhatsAppCampaignRuns', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getWhatsAppCampaignRuns',
      whatsapp_campaign_id: whatsappCampaignId,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function createWhatsAppTemplate(payload) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/whatsappTemplates`,
      payload,
      headers
    );
    return response.data?.data ?? response.data;
  } catch (err) {
    console.error(`Error creating WhatsApp template: ${err}`);
    mixpanelErrorTracker.trackError('server error - createWhatsAppTemplate', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'createWhatsAppTemplate',
      payload,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function getWhatsAppTemplates(whatsappCampaignId) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/whatsappTemplates?whatsapp_campaign_id=${encodeURIComponent(
        whatsappCampaignId
      )}`,
      headers
    );
    const raw = response.data?.data;
    return Array.isArray(raw) ? raw : [];
  } catch (err) {
    console.error(`Error loading WhatsApp templates: ${err}`);
    mixpanelErrorTracker.trackError('server error - getWhatsAppTemplates', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getWhatsAppTemplates',
      whatsapp_campaign_id: whatsappCampaignId,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function getWhatsAppFlows(projectId) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/whatsappFlows?project_id=${encodeURIComponent(projectId)}`,
      headers
    );
    const raw = response.data?.data;
    return Array.isArray(raw) ? raw : [];
  } catch (err) {
    console.error(`Error loading WhatsApp flows: ${err}`);
    mixpanelErrorTracker.trackError('server error - getWhatsAppFlows', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getWhatsAppFlows',
      project_id: projectId,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

/** GET /whatsappFlows/placeholders */
export async function getWhatsAppFlowPlaceholders() {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/whatsappFlows/placeholders`,
      headers
    );
    const raw = response.data?.data?.placeholders;
    return Array.isArray(raw) ? raw : [];
  } catch (err) {
    console.error(`Error loading WhatsApp flow placeholders: ${err}`);
    mixpanelErrorTracker.trackError('server error - getWhatsAppFlowPlaceholders', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getWhatsAppFlowPlaceholders',
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

/** GET /whatsappFlows/:id */
export async function getWhatsAppFlowById(flowId) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/whatsappFlows/${encodeURIComponent(flowId)}`,
      headers
    );
    return response.data?.data ?? response.data;
  } catch (err) {
    console.error(`Error loading WhatsApp flow: ${err}`);
    mixpanelErrorTracker.trackError('server error - getWhatsAppFlowById', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getWhatsAppFlowById',
      flow_id: flowId,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

/**
 * POST /whatsappFlows
 * @param {{ project_id: number, name: string, slug: string, description?: string, vertical?: string }} payload
 */
export async function createWhatsAppFlow(payload) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/whatsappFlows`,
      payload,
      headers
    );
    return response.data?.data ?? response.data;
  } catch (err) {
    console.error(`Error creating WhatsApp flow: ${err}`);
    mixpanelErrorTracker.trackError('server error - createWhatsAppFlow', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'createWhatsAppFlow',
      payload,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

/**
 * PATCH /whatsappFlows/:id
 * Update metadata only: name, description, vertical
 * @param {string|number} flowId
 * @param {{ project_id?: number, name?: string, description?: string, vertical?: string }} payload
 */
export async function patchWhatsAppFlowMetadata(flowId, payload) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.patch(
      `${APPLICATION_API_BASE_URL}/whatsappFlows/${encodeURIComponent(flowId)}`,
      payload,
      headers
    );
    return response.data?.data ?? response.data;
  } catch (err) {
    console.error(`Error patching WhatsApp flow metadata: ${err}`);
    mixpanelErrorTracker.trackError('server error - patchWhatsAppFlowMetadata', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'patchWhatsAppFlowMetadata',
      flow_id: flowId,
      payload,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

/** PUT /whatsappFlows/:id */
export async function updateWhatsAppFlow(flowId, payload) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.put(
      `${APPLICATION_API_BASE_URL}/whatsappFlows/${encodeURIComponent(flowId)}`,
      payload,
      headers
    );
    return response.data?.data ?? response.data;
  } catch (err) {
    console.error(`Error updating WhatsApp flow: ${err}`);
    mixpanelErrorTracker.trackError('server error - updateWhatsAppFlow', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'updateWhatsAppFlow',
      flow_id: flowId,
      payload,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

/** POST /whatsappFlows/:id/submit-template */
export async function submitWhatsAppFlowTemplate(flowId) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/whatsappFlows/${encodeURIComponent(flowId)}/submit-template`,
      {},
      headers
    );
    return response.data?.data ?? response.data;
  } catch (err) {
    console.error(`Error submitting WhatsApp flow template: ${err}`);
    mixpanelErrorTracker.trackError('server error - submitWhatsAppFlowTemplate', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'submitWhatsAppFlowTemplate',
      flow_id: flowId,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

/** POST /whatsappFlows/sync-template-status?project_id= */
export async function syncWhatsAppFlowTemplateStatus(projectId) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/whatsappFlows/sync-template-status?project_id=${encodeURIComponent(
        projectId
      )}`,
      {},
      headers
    );
    return response.data?.data ?? response.data;
  } catch (err) {
    console.error(`Error syncing WhatsApp flow template status: ${err}`);
    mixpanelErrorTracker.trackError('server error - syncWhatsAppFlowTemplateStatus', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'syncWhatsAppFlowTemplateStatus',
      project_id: projectId,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

/** POST /whatsappFlows/:id/send */
export async function sendWhatsAppFlow(flowId, payload) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/whatsappFlows/${encodeURIComponent(flowId)}/send`,
      payload,
      headers
    );
    return response.data?.data ?? response.data;
  } catch (err) {
    console.error(`Error sending WhatsApp flow: ${err}`);
    mixpanelErrorTracker.trackError('server error - sendWhatsAppFlow', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'sendWhatsAppFlow',
      flow_id: flowId,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

/** GET /builderWhatsapp/templates?project_id=&search= — approved Pinggo WA templates */
export async function getApprovedWhatsAppTemplates(projectId, options = {}) {
  try {
    const headers = await getHeaders();
    const params = new URLSearchParams();
    params.set('project_id', String(projectId));
    const search = typeof options.search === 'string' ? options.search.trim() : '';
    if (search) params.set('search', search);
    if (options.maxPages != null && Number(options.maxPages) > 0) {
      params.set('max_pages', String(options.maxPages));
    }
    const response = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/builderWhatsapp/templates?${params.toString()}`,
      headers
    );
    return response.data?.data ?? response.data;
  } catch (err) {
    console.error(`Error loading approved WhatsApp templates: ${err}`);
    mixpanelErrorTracker.trackError('server error - getApprovedWhatsAppTemplates', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getApprovedWhatsAppTemplates',
      project_id: projectId,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

/**
 * POST /builderWhatsapp/templates/send
 * @param {{ projectId: number, leadIds: number[], templateName: string, nameField?: string }} payload
 */
export async function sendWhatsAppTemplateToLeads({
  projectId,
  leadIds,
  templateName,
  nameField
}) {
  try {
    const headers = await getHeaders();
    const body = {
      project_id: projectId,
      lead_ids: leadIds,
      template_name: templateName
    };
    if (nameField) body.name_field = nameField;
    const response = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/builderWhatsapp/templates/send`,
      body,
      headers
    );
    return response.data?.data ?? response.data;
  } catch (err) {
    console.error(`Error sending WhatsApp template: ${err}`);
    mixpanelErrorTracker.trackError('server error - sendWhatsAppTemplateToLeads', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'sendWhatsAppTemplateToLeads',
      project_id: projectId,
      template_name: templateName,
      lead_count: Array.isArray(leadIds) ? leadIds.length : 0,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function getCampaignMediaLibrary(projectId) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/campaignMediaLibrary?project_id=${encodeURIComponent(
        projectId
      )}`,
      headers
    );
    const raw = response.data?.data;
    return Array.isArray(raw) ? raw : [];
  } catch (err) {
    console.error(`Error loading campaign media library: ${err}`);
    mixpanelErrorTracker.trackError('server error - getCampaignMediaLibrary', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getCampaignMediaLibrary',
      project_id: projectId,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function createCampaignMediaLibrary(payload) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/campaignMediaLibrary`,
      payload,
      headers
    );
    return response.data?.data ?? response.data;
  } catch (err) {
    console.error(`Error creating campaign media library item: ${err}`);
    mixpanelErrorTracker.trackError('server error - createCampaignMediaLibrary', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'createCampaignMediaLibrary',
      payload,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function deleteCampaignMediaLibrary(mediaId) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.delete(
      `${APPLICATION_API_BASE_URL}/campaignMediaLibrary/${encodeURIComponent(mediaId)}`,
      headers
    );
    return response.data?.data ?? response.data;
  } catch (err) {
    console.error(`Error deleting campaign media library item: ${err}`);
    mixpanelErrorTracker.trackError('server error - deleteCampaignMediaLibrary', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'deleteCampaignMediaLibrary',
      media_id: mediaId,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function createWhatsAppQuestions(payload) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/whatsappQuestions`,
      payload,
      headers
    );
    return response.data?.data ?? response.data;
  } catch (err) {
    console.error(`Error saving WhatsApp questions: ${err}`);
    mixpanelErrorTracker.trackError('server error - createWhatsAppQuestions', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'createWhatsAppQuestions',
      payload,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function updateWhatsAppQuestions(payload) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.put(
      `${APPLICATION_API_BASE_URL}/whatsappQuestions/bulk`,
      payload,
      headers
    );
    return response.data?.data ?? response.data;
  } catch (err) {
    console.error(`Error updating WhatsApp questions: ${err}`);
    mixpanelErrorTracker.trackError('server error - updateWhatsAppQuestions', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'updateWhatsAppQuestions',
      payload,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

/** @returns {{ questions: any[], category: string | null }} */
export async function getWhatsAppQuestions(whatsappCampaignId) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/whatsappQuestions?whatsapp_campaign_id=${encodeURIComponent(
        whatsappCampaignId
      )}`,
      headers
    );
    const raw = response.data?.data;
    let questions = [];
    let category = null;
    if (Array.isArray(raw)) {
      questions = raw;
    } else if (raw && typeof raw === 'object' && Array.isArray(raw.questions)) {
      questions = raw.questions;
      category = raw.category != null ? String(raw.category) : null;
    } else if (Array.isArray(response.data?.questions)) {
      questions = response.data.questions;
      category =
        response.data.category != null ? String(response.data.category) : null;
    }
    return { questions, category: category && category.trim() ? category.trim() : null };
  } catch (err) {
    console.error(`Error loading WhatsApp questions: ${err}`);
    mixpanelErrorTracker.trackError('server error - getWhatsAppQuestions', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getWhatsAppQuestions',
      whatsapp_campaign_id: whatsappCampaignId,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function updateCampaign(id, payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.put(
      `${APPLICATION_API_BASE_URL}/campaign/${id}`,
      payload,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error upating campaign: ${err}`);
    mixpanelErrorTracker.trackError('server error - updateCampaign', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'updateCampaign',
      id: id,
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Campaign not updated');
  }
}

export async function createCampaign(payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.post(`${APPLICATION_API_BASE_URL}/campaign`, payload, headers);
    return data.data.data;
  } catch (err) {
    console.error(`Error creating campaign: ${err}`);
    mixpanelErrorTracker.trackError('server error - createCampaign', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'createCampaign',
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Campaign not created');
  }
}

export async function getCampaignLeads(id) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(`${APPLICATION_API_BASE_URL}/campaignLead/${id}`, headers);
    return data.data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - getCampaignLeads', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getCampaignLeads',
      id: id,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Leads data not loaded');
  }
}

export async function addCampaignLead(payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/campaignLead`,
      payload,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error adding lead: ${err}`);
    mixpanelErrorTracker.trackError('server error - addCampaignLead', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'addCampaignLead',
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Leads not added');
  }
}

export async function addVisitor(payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/campaignVisitor`,
      payload,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error adding visitor: ${err}`);
    mixpanelErrorTracker.trackError('server error - addVisitor', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'addVisitor',
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Visitor not added');
  }
}

export async function bulkTransferCampaignLead(payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/campaignLead/bulk/transfer`,
      payload,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error tranfering lead: ${err}`);
    mixpanelErrorTracker.trackError('server error - bulkTransferCampaignLead', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'bulkTransferCampaignLead',
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Lead not tranferred');
  }
}

export async function getCampaignLeadsStats(id) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/campaignLead/stats/${id}`,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - getCampaignLeadsStats', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getCampaignLeadsStats',
      id: id,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Leads stats data not loaded');
  }
}

export async function getAllQuestions(id) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(`${APPLICATION_API_BASE_URL}/questions/${id}`, headers);
    return data.data.data;
  } catch (err) {
    console.error(`Error loading questions: ${err}`);
    mixpanelErrorTracker.trackError('server error - getAllQuestions', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getAllQuestions',
      id: id,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Questions not loaded');
  }
}

/////////////////////
// LIVE TASKS API

export async function addSection(payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/liveTask/addSection`,
      payload,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error adding sections: ${err}`);
    mixpanelErrorTracker.trackError('server error - addSection', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'addSection',
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Section not created');
  }
}

export async function getAllWorkTypes() {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(`${APPLICATION_API_BASE_URL}/workType`, headers);
    return data.data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - getAllWorkTypes', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getAllWorkTypes',
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err; // throw new Error('WorkTypes not loaded');
  }
}

export async function getWorkTypesByType(type) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.get(`${APPLICATION_API_BASE_URL}/workType`, {
      ...headers,
      params: { type }
    });
    return response.data?.data ?? [];
  } catch (err) {
    console.error(`Error loading work types by type: ${err}`);
    mixpanelErrorTracker.trackError('server error - getWorkTypesByType', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getWorkTypesByType',
      type,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function deleteTaskTemplate(id) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.delete(
      `${APPLICATION_API_BASE_URL}/taskTemplate/${id}`,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error deleting task: ${err}`);
    mixpanelErrorTracker.trackError('server error - deleteTaskTemplate', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'deleteTaskTemplate',
      template_id: id,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err; // throw new Error(err?.response?.data?.message);
  }
}

export async function getAllCommonLiveTask(id, workTypeId, sectionId) {
  try {
    const headers = await getHeaders();

    // Construct query params dynamically
    let queryParams = `project_id=${id}&workType_id=${workTypeId}&page=1&limit=10000`;
    if (sectionId) {
      queryParams += `&section_id=${sectionId}`;
    }

    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/liveTask/common?${queryParams}`,
      headers
    );

    return data.data;
  } catch (err) {
    console.error(`Error fetching tasks: ${err}`);
    mixpanelErrorTracker.trackError('server error - getAllCommonLiveTask', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getAllCommonLiveTask',
      id: id,
      workTypeId: workTypeId,
      sectionId: sectionId,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('New tasks not fetched');
  }
}

export async function getCommonLiveTasks(projectId, workTypeId) {
  try {
    const headers = await getHeaders();
    let queryParams = `project_id=${projectId}&page=1&limit=10000`;
    if (workTypeId) {
      queryParams += `&workType_id=${workTypeId}`;
    }
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/liveTask/common?${queryParams}`,
      headers
    );
    return data.data;
  } catch (err) {
    console.error(`Error fetching common live tasks: ${err}`);
    mixpanelErrorTracker.trackError('server error - getCommonLiveTasks', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getCommonLiveTasks',
      project_id: projectId,
      workType_id: workTypeId,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

/** Paginated common live tasks (e.g. /liveTask/common?project_id=&page=&limit=&status=) */
export async function getCommonLiveTasksPaged({
  projectId,
  page = 1,
  limit = 50,
  workTypeId,
  status
} = {}) {
  try {
    const headers = await getHeaders();
    const params = new URLSearchParams();
    if (projectId != null && projectId !== '') {
      params.set('project_id', String(projectId));
    }
    if (workTypeId != null && workTypeId !== '') {
      params.set('workType_id', String(workTypeId));
    }
    if (status != null && String(status).trim() !== '') {
      params.set('status', String(status).trim());
    }
    params.set('page', String(page));
    params.set('limit', String(limit));
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/liveTask/common?${params.toString()}`,
      headers
    );
    return data.data;
  } catch (err) {
    console.error(`Error getting paginated common live tasks: ${err}`);
    mixpanelErrorTracker.trackError('server error - getCommonLiveTasksPaged', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getCommonLiveTasksPaged',
      project_id: projectId,
      page,
      limit,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export async function getIndependentLiveTasks(projectId, workTypeId) {
  try {
    const headers = await getHeaders();
    let queryParams = `project_id=${projectId}&page=1&limit=50000`;
    if (workTypeId) {
      queryParams += `&workType_id=${workTypeId}`;
    }
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/liveTask/independent?${queryParams}`,
      headers
    );
    return data.data;
  } catch (err) {
    console.error(`Error fetching independent live tasks: ${err}`);
    mixpanelErrorTracker.trackError('server error - getIndependentLiveTasks', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getIndependentLiveTasks',
      project_id: projectId,
      workType_id: workTypeId,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

/** Paginated independent live tasks (e.g. /liveTask/independent?project_id=&page=&limit=&workType_id=&unit_id=&status=) */
export async function getIndependentLiveTasksPaged({
  projectId,
  page = 1,
  limit = 50,
  workTypeId,
  unitId,
  status
} = {}) {
  try {
    const headers = await getHeaders();
    const params = new URLSearchParams();
    if (projectId != null && projectId !== '') {
      params.set('project_id', String(projectId));
    }
    if (workTypeId != null && workTypeId !== '') {
      params.set('workType_id', String(workTypeId));
    }
    if (unitId != null && unitId !== '') {
      params.set('unit_id', String(unitId));
    }
    if (status != null && String(status).trim() !== '') {
      params.set('status', String(status).trim());
    }
    params.set('page', String(page));
    params.set('limit', String(limit));
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/liveTask/independent?${params.toString()}`,
      headers
    );
    return data.data;
  } catch (err) {
    console.error(`Error getting paginated independent live tasks: ${err}`);
    mixpanelErrorTracker.trackError('server error - getIndependentLiveTasksPaged', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getIndependentLiveTasksPaged',
      project_id: projectId,
      page,
      limit,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export async function getSingleCommonLiveTask(id) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/liveTask/common/${id}`,
      headers
    );
    return data.data;
  } catch (err) {
    console.error(`Error fetching tasks: ${err}`);
    mixpanelErrorTracker.trackError('server error - getSingleCommonLiveTask', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getSingleCommonLiveTask',
      id: id,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('New tasks not fetched');
  }
}

export async function getSingleLiveTaskUpdates(id) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/taskupdates?task_id=${id}`,
      headers
    );
    return data.data;
  } catch (err) {
    console.error(`Error fetching task Updates: ${err}`);
    mixpanelErrorTracker.trackError('server error - getSingleLiveTaskUpdates', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getSingleLiveTaskUpdates',
      id: id,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Tasks updates not fetched');
  }
}

export async function addTaskUpdate(payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/taskupdates`,
      payload,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error adding task update: ${err}`);
    mixpanelErrorTracker.trackError('server error - addTaskUpdate', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'addTaskUpdate',
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Task update not added');
  }
}

export async function getAllTaskComments(id) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(`${APPLICATION_API_BASE_URL}/taskComment/${id}`, headers);
    return data.data;
  } catch (err) {
    console.error(`Error fetching task comments: ${err}`);
    mixpanelErrorTracker.trackError('server error - getAllTaskComments', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getAllTaskComments',
      id: id,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Task comments are not fetched');
  }
}

export async function createTaskComment(payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/taskComment`,
      payload,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error creating task comment: ${err}`);
    mixpanelErrorTracker.trackError('server error - createTaskComment', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'createTaskComment',
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Task comment not created');
  }
}

export async function createIndependentLiveTasks(payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/liveTask/independent`,
      payload,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error creating independent live tasks: ${err}`);
    mixpanelErrorTracker.trackError('server error - createIndependentLiveTasks', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'createIndependentLiveTasks',
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Independent Live tasks are not created');
  }
}

export async function getSingleIndependentLiveTask(id) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/liveTask/independent/${id}`,
      headers
    );
    return data.data;
  } catch (err) {
    console.error(`Error fetching tasks: ${err}`);
    mixpanelErrorTracker.trackError('server error - getSingleIndependentLiveTask', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getSingleIndependentLiveTask',
      id: id,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('New tasks not fetched');
  }
}

export async function getSingleGroupLiveTask(id) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/liveTask/group/${id}`,
      headers
    );
    return data.data;
  } catch (err) {
    console.error(`Error fetching tasks: ${err}`);
    mixpanelErrorTracker.trackError('server error - getSingleGroupLiveTask', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getSingleGroupLiveTask',
      id: id,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('New tasks not fetched');
  }
}

export async function getAllIndependentLiveTask(projectID, unitID, page = 1, limit = 50000) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/liveTask/independent?project_id=${projectID}&unit_id=${unitID}&page=${page}&limit=${limit}`,
      headers
    );
    return data.data; // Return full response to access meta
  } catch (err) {
    console.error(`Error getting independent live tasks: ${err}`);
    mixpanelErrorTracker.trackError('server error - getAllIndependentLiveTask', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getAllIndependentLiveTask',
      projectID: projectID,
      unitID: unitID,
      page: page,
      limit: limit,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Independent Live tasks are not fetched');
  }
}

export async function addAccIndependentLiveTasks(payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/liveTask/add/independent`,
      payload,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error adding tasks: ${err}`);
    mixpanelErrorTracker.trackError('server error - addAccIndependentLiveTasks', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'addAccIndependentLiveTasks',
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Task not added');
  }
}

export async function getAllGroupLiveTask(id, page = 1, limit = 50000) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/liveTask/group?block_id=${id}&page=${page}&limit=${limit}`,
      headers
    );
    return data.data; // Return full response to access meta
  } catch (err) {
    console.error(`Error getting group live tasks: ${err}`);
    mixpanelErrorTracker.trackError('server error - getAllGroupLiveTask', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getAllGroupLiveTask',
      id: id,
      page: page,
      limit: limit,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Group Live tasks are not fetched');
  }
}

/** Paginated group live tasks (e.g. /liveTask/group?project_id=&block_id=&workType_id=&status=&page=&limit=) */
export async function getGroupLiveTasksPaged({
  projectId,
  blockId,
  page = 1,
  limit = 50,
  workTypeId,
  status
} = {}) {
  try {
    const headers = await getHeaders();
    const params = new URLSearchParams();
    if (projectId != null && projectId !== '') {
      params.set('project_id', String(projectId));
    }
    if (blockId != null && blockId !== '') {
      params.set('block_id', String(blockId));
    }
    if (workTypeId != null && workTypeId !== '') {
      params.set('workType_id', String(workTypeId));
    }
    if (status != null && String(status).trim() !== '') {
      params.set('status', String(status).trim());
    }
    params.set('page', String(page));
    params.set('limit', String(limit));
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/liveTask/group?${params.toString()}`,
      headers
    );
    return data.data;
  } catch (err) {
    console.error(`Error getting paginated group live tasks: ${err}`);
    mixpanelErrorTracker.trackError('server error - getGroupLiveTasksPaged', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getGroupLiveTasksPaged',
      project_id: projectId,
      block_id: blockId,
      page,
      limit,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export async function updateLiveTask(id, payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.put(
      `${APPLICATION_API_BASE_URL}/liveTask/${id}`,
      payload,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error updating tasks: ${err}`);
    mixpanelErrorTracker.trackError('server error - updateLiveTask', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'updateLiveTask',
      id: id,
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Task not updated');
  }
}

export async function updateTask(taskId, payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.put(
      `${APPLICATION_API_BASE_URL}/liveTask/${taskId}`,
      payload,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error updating task: ${err}`);
    mixpanelErrorTracker.trackError('server error - updateTask', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'updateTask',
      taskId: taskId,
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export async function updateTaskForTomorrow(dailyTaskId, payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.put(
      `${APPLICATION_API_BASE_URL}/dailyTask/${dailyTaskId}`,
      payload,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error updating task for tomorrow: ${err}`);
    mixpanelErrorTracker.trackError('server error - updateTaskForTomorrow', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'updateTaskForTomorrow',
      dailyTaskId: dailyTaskId,
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export async function bulkCompleteTasks(payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.put(
      `${APPLICATION_API_BASE_URL}/liveTask/early/update`,
      payload,
      headers
    );
    return data.data;
  } catch (err) {
    console.error(`Error bulk completing tasks: ${err}`);
    mixpanelErrorTracker.trackError('server error - bulkCompleteTasks', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'bulkCompleteTasks',
      task_ids: payload.taskIds,
      work_type_id: payload.workType_id,
      project_id: payload.project_id,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export async function updateAllTaskUsers(payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.put(
      `${APPLICATION_API_BASE_URL}/liveTask/assignEmployees`,
      payload,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error updating tasks: ${err}`);
    mixpanelErrorTracker.trackError('server error - updateAllTaskUsers', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'updateAllTaskUsers',
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Task not updated');
  }
}

export async function updateAllTaskSPs(payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.put(
      `${APPLICATION_API_BASE_URL}/liveTask/assignSp`,
      payload,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error updating tasks: ${err}`);
    mixpanelErrorTracker.trackError('server error - updateAllTaskSPs', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'updateAllTaskSPs',
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Task not updated');
  }
}

export async function updateAllGroupTaskSPs(payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.put(
      `${APPLICATION_API_BASE_URL}/liveTask/assignSpGroup`,
      payload,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error updating tasks: ${err}`);
    mixpanelErrorTracker.trackError('server error - updateAllGroupTaskSPs', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'updateAllGroupTaskSPs',
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Task not updated');
  }
}

export async function addCommonLiveTasks(payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/liveTask/add/common`,
      payload,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error adding tasks: ${err}`);
    mixpanelErrorTracker.trackError('server error - addCommonLiveTasks', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'addCommonLiveTasks',
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Task not added');
  }
}

export async function checkLiveTaskDelete(id) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/liveTask/checkDelete/${id}`,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error checking isDelete: ${err}`);
    mixpanelErrorTracker.trackError('server error - checkLiveTaskDelete', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'checkLiveTaskDelete',
      id: id,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Error checking isDelete');
  }
}

export async function deleteLiveTask(payload) {
  try {
    const headers = await getHeaders(); // contains { headers: { Authorization: '...' } }

    const response = await axiosInstance.delete(`${APPLICATION_API_BASE_URL}/liveTask/delete`, {
      ...headers,
      data: payload
    });

    return response.data.data;
  } catch (err) {
    console.error('Error deleting task:', err?.response || err);
    mixpanelErrorTracker.trackError('server error - deleteLiveTask', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'deleteLiveTask',
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Error deleting task');
  }
}

export async function bulkDeleteLiveTask(payload) {
  try {
    const headers = await getHeaders(); // contains { headers: { Authorization: '...' } }

    const response = await axiosInstance.delete(`${APPLICATION_API_BASE_URL}/liveTask/bulkDelete`, {
      ...headers,
      data: payload
    });

    return response.data.data;
  } catch (err) {
    console.error('Error deleting task:', err?.response || err);
    mixpanelErrorTracker.trackError('server error - bulkDeleteLiveTask', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'bulkDeleteLiveTask',
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Error deleting task');
  }
}

export async function createCommonLiveTasks(payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/liveTask/common`,
      payload,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error creating common live tasks: ${err}`);
    mixpanelErrorTracker.trackError('server error - createCommonLiveTasks', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'createCommonLiveTasks',
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Common Live tasks are not created');
  }
}

export async function makePreviewFalse(payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.put(
      `${APPLICATION_API_BASE_URL}/liveTask/task/preview`,
      payload,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error making preview false: ${err}`);
    mixpanelErrorTracker.trackError('server error - makePreviewFalse', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'makePreviewFalse',
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Error making preview false');
  }
}

export async function createGroupLiveTasks(payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/liveTask/group`,
      payload,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error creating group live tasks: ${err}`);
    mixpanelErrorTracker.trackError('server error - createGroupLiveTasks', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'createGroupLiveTasks',
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Group Live tasks are not created');
  }
}

export async function addAccGroupLiveTasks(payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/liveTask/add/group`,
      payload,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error adding tasks: ${err}`);
    mixpanelErrorTracker.trackError('server error - addAccGroupLiveTasks', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'addAccGroupLiveTasks',
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Task not added');
  }
}

export async function createWorkType(payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.post(`${APPLICATION_API_BASE_URL}/workType`, payload, headers);
    return data.data.data;
  } catch (err) {
    console.error(`Error creating independent live tasks: ${err}`);
    mixpanelErrorTracker.trackError('server error - createWorkType', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'createWorkType',
      payload: payload,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err; // throw new Error('Independent live tasks are not created');
  }
}

export async function updateWorkType(id, payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.put(
      `${APPLICATION_API_BASE_URL}/workType/${id}`,
      payload,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error updating work type: ${err}`);
    mixpanelErrorTracker.trackError('server error - updateWorkType', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'updateWorkType',
      id: id,
      payload: payload,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function handleCheckWorkTypeDelete(id) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/workType/checkDelete/${id}`,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error checking work type to delete: ${err}`);
    mixpanelErrorTracker.trackError('server error - handleCheckWorkTypeDelete', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'handleCheckWorkTypeDelete',
      id: id,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Error checking work type to delete');
  }
}

export async function deleteWorkType(payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.delete(`${APPLICATION_API_BASE_URL}/workType/delete`, {
      ...headers,
      data: payload
    });
    return data.data.data;
  } catch (err) {
    console.error(`Error deleting work type: ${err}`);
    mixpanelErrorTracker.trackError('server error - deleteWorkType', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'deleteWorkType',
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function getAllSections(id, pid) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/liveTask/common/sections/${id}?project_id=${pid}`,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - getAllSections', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getAllSections',
      id: id,
      pid: pid,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('sections not loaded');
  }
}

export async function getAllSectionsByProject(pid) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/liveTask/get/all/sections/${pid}`,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - getAllSectionsByProject', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getAllSectionsByProject',
      pid: pid,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('sections not loaded');
  }
}

// Get Project by Company Id
export async function getProjectsByCompanyId(id) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/project?company_id=${id}&limit=500&summary=1`,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - getProjectsByCompanyId', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getProjectsByCompanyId',
      id: id,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Projects data not loaded');
  }
}

export async function getProjectByID(id) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(`${APPLICATION_API_BASE_URL}/project/${id}`, headers);
    return data.data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - getProjectByID', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getProjectByID',
      id: id,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Project data not loaded');
  }
}

export async function getProjectImages(projectId, page = 1, limit = 100) {
  try {
    const headers = await getHeaders();
    const url = projectId
      ? `${APPLICATION_API_BASE_URL}/projectImages?project_id=${projectId}&page=${page}&limit=${limit}`
      : `${APPLICATION_API_BASE_URL}/projectImages?page=${page}&limit=${limit}`;
    const response = await axiosInstance.get(url, headers);
    return response.data;
  } catch (err) {
    console.error(`Error loading project images: ${err}`);
    mixpanelErrorTracker.trackError('server error - getProjectImages', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getProjectImages',
      project_id: projectId,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

/**
 * Create unit/project images. Payload shape:
 * { images: [{ name, url, project_id, block_id, unit_id?, visibility: "public"|"private" }] }
 */
export async function postUnitProjectImages(payload) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/projectImages`,
      payload,
      headers
    );
    return response.data;
  } catch (err) {
    console.error(`Error creating project images: ${err}`);
    mixpanelErrorTracker.trackError('server error - postUnitProjectImages', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'postUnitProjectImages',
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function postProjectImagesBulkUpdate(payload) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/projectImages/bulkUpdate`,
      payload,
      headers
    );
    return response.data;
  } catch (err) {
    console.error(`Error bulk updating project images: ${err}`);
    mixpanelErrorTracker.trackError('server error - postProjectImagesBulkUpdate', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'postProjectImagesBulkUpdate',
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function editProject(id, payload) {
  // Object.keys(payload).forEach((key) => {
  //   if (payload[key] === '') {
  //     delete payload[key];
  //   } else if (
  //     typeof payload[key] === 'object' &&
  //     !Array.isArray(payload[key]) &&
  //     Object.keys(payload[key]).length === 0
  //   ) {
  //     delete payload[key];
  //   }
  // });
  console.log({ payload });

  try {
    const headers = await getHeaders();
    const data = await axiosInstance.put(
      `${APPLICATION_API_BASE_URL}/project/${id}`,
      payload,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error editing project: ${err}`);
    mixpanelErrorTracker.trackError('server error - editProject', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'editProject',
      id: id,
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Project data not edited');
  }
}

//////////////////////////////////////////
/// ACCOMMODATION API's
export async function createAccommodation(payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/accomodation`,
      payload,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error creating accommodation: ${err}`);
    mixpanelErrorTracker.trackError('server error - createAccommodation', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'createAccommodation',
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export async function getAllAccommodations() {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/accomodation?limit=500`,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - getAllAccommodations', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getAllAccommodations',
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Accommodation data not loaded');
  }
}

export async function getAllAccommodationsByProject(id, queryParams = '') {
  try {
    const headers = await getHeaders();
    let url = `${APPLICATION_API_BASE_URL}/accomodation?projectId=${id}&limit=500`;
    if (queryParams) {
      url += `&${queryParams}`;
    }
    const data = await axiosInstance.get(url, headers);
    return data.data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - getAllAccommodationsByProject', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getAllAccommodationsByProject',
      id: id,
      queryParams: queryParams,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Accommodation data not loaded');
  }
}

export async function editAccommodation(id, payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.put(
      `${APPLICATION_API_BASE_URL}/accomodation/${id}?limit=500`,
      payload,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error updated accommodation: ${err}`);
    mixpanelErrorTracker.trackError('server error - editAccommodation', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'editAccommodation',
      id: id,
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export async function handleCheckAccomodationDelete(id) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/accomodation/checkDelete/${id}`,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error checking accomodation to delete: ${err}`);
    mixpanelErrorTracker.trackError('server error - handleCheckAccomodationDelete', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'handleCheckAccomodationDelete',
      id: id,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Error checking accomodation to delete');
  }
}

export async function deleteAccomodation(payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.delete(`${APPLICATION_API_BASE_URL}/accomodation/delete/`, {
      ...headers,
      data: payload
    });

    return data.data.data;
  } catch (err) {
    console.error(`Error deleting accomodation: ${err}`);
    mixpanelErrorTracker.trackError('server error - deleteAccomodation', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'deleteAccomodation',
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Error deleting accomodation');
  }
}

export async function getAccommodationDrawingTypes(accommodationId) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/accomodation/${accommodationId}/drawing-types`,
      headers
    );
    return data.data?.data ?? data.data;
  } catch (err) {
    console.error(`Error loading accommodation drawing types: ${err}`);
    mixpanelErrorTracker.trackError('server error - getAccommodationDrawingTypes', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getAccommodationDrawingTypes',
      accommodationId,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export async function getAccommodationDrawings(accommodationId) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/accomodation/${accommodationId}/drawings`,
      headers
    );
    return data.data?.data ?? data.data;
  } catch (err) {
    console.error(`Error loading accommodation drawings: ${err}`);
    mixpanelErrorTracker.trackError('server error - getAccommodationDrawings', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getAccommodationDrawings',
      accommodationId,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export async function uploadAccommodationDrawings(accommodationId, formData) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/accomodation/${accommodationId}/drawings`,
      formData,
      headers
    );
    return data.data;
  } catch (err) {
    console.error(`Error uploading accommodation drawings: ${err}`);
    mixpanelErrorTracker.trackError('server error - uploadAccommodationDrawings', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'uploadAccommodationDrawings',
      accommodationId,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export async function deleteAccommodationDrawing(accommodationId, drawing) {
  try {
    const headers = await getHeaders();
    const { drawing_type, file_key } = buildDrawingDeletePayload(drawing);

    const response = await axiosInstance.delete(
      `${APPLICATION_API_BASE_URL}/accomodation/${accommodationId}/drawings`,
      {
        ...headers,
        data: { drawing_type, file_key }
      }
    );
    return response.data?.data ?? response.data;
  } catch (err) {
    console.error(`Error deleting accommodation drawing: ${err}`);
    mixpanelErrorTracker.trackError('server error - deleteAccommodationDrawing', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'deleteAccommodationDrawing',
      accommodationId,
      drawing,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

// Extra charges APIs
// Create Extra Charges
export async function createExtraCharges(payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/extraChargesAccomodation`,
      payload,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error creating extra charges: ${err}`);
    mixpanelErrorTracker.trackError('server error - createExtraCharges', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'createExtraCharges',
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('New extra charges not created');
  }
}

// Get All Extra Charges
export async function getAllExtraCharges(queryParams = '') {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/extraChargesAccomodation?${queryParams}&limit=10000`,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error fetching extra charges: ${err}`);
    mixpanelErrorTracker.trackError('server error - getAllExtraCharges', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getAllExtraCharges',
      queryParams: queryParams,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Error fetching extra charges');
  }
}

// Update Extra Charges
export async function updateExtraCharges(id, payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.put(
      `${APPLICATION_API_BASE_URL}/extraChargesAccomodation/${id}`,
      payload,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error updating extra charges: ${err}`);
    mixpanelErrorTracker.trackError('server error - updateExtraCharges', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'updateExtraCharges',
      id: id,
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Error updating extra charges');
  }
}

export async function handleCheckExtraChargeDelete(id) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/extraChargesAccomodation/checkDelete/${id}`,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error checking extraChargesAccomodation: ${err}`);
    mixpanelErrorTracker.trackError('server error - handleCheckExtraChargeDelete', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'handleCheckExtraChargeDelete',
      id: id,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Error checking extraChargesAccomodation');
  }
}

export async function deleteExtraCharge(payload) {
  try {
    const headers = await getHeaders(); // contains { headers: { Authorization: '...' } }

    const response = await axiosInstance.delete(
      `${APPLICATION_API_BASE_URL}/extraChargesAccomodation/delete`,
      {
        ...headers,
        data: payload
      }
    );

    return response.data.data;
  } catch (err) {
    console.error('Error deleting extraChargesAccomodation:', err?.response || err);
    mixpanelErrorTracker.trackError('server error - deleteExtraCharge', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'deleteExtraCharge',
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Error deleting extraChargesAccomodation');
  }
}

//////////////////////////////////////////
/// BLOCK API's
export async function createBLock(payload) {
  // payload.area = parseInt(payload.area);
  // payload.levels = generateBlockNames(payload.number_of_levels);
  // payload.project_id = parseInt(payload.project_id);
  // payload.number_of_levels = parseInt(payload.number_of_levels);

  try {
    const headers = await getHeaders();
    const data = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/block?limit=500`,
      payload,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error creating block: ${err}`);
    mixpanelErrorTracker.trackError('server error - createBLock', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'createBLock',
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('New block not created');
  }
}

export async function getAllBlocks(project_id) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/block?projectId=${project_id}&limit=500`,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error fetching blocks: ${err}`);
    mixpanelErrorTracker.trackError('server error - getAllBlocks', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getAllBlocks',
      project_id: project_id,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Error fetching blocks');
  }
}

export async function getEveryBlocks() {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(`${APPLICATION_API_BASE_URL}/block?limit=3000`, headers);
    return data.data.data;
  } catch (err) {
    console.error(`Error fetching blocks: ${err}`);
    mixpanelErrorTracker.trackError('server error - getEveryBlocks', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getEveryBlocks',
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Error fetching blocks');
  }
}

export async function getBlockByID(blockId) {
  if (!blockId) return;

  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/block/${blockId}?limit=500`,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error fetching block: ${err}`);
    mixpanelErrorTracker.trackError('server error - getBlockByID', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getBlockByID',
      blockId: blockId,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Error fetching blocks');
  }
}

export async function getBlockDrawingTypes() {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/block/drawing-types`,
      headers
    );
    return data.data?.data ?? data.data;
  } catch (err) {
    console.error(`Error loading block drawing types: ${err}`);
    mixpanelErrorTracker.trackError('server error - getBlockDrawingTypes', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getBlockDrawingTypes',
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export async function uploadBlockDrawings(blockId, formData) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/block/${blockId}/drawings`,
      formData,
      headers
    );
    return data.data;
  } catch (err) {
    console.error(`Error uploading block drawings: ${err}`);
    mixpanelErrorTracker.trackError('server error - uploadBlockDrawings', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'uploadBlockDrawings',
      blockId,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export async function getBlockDrawings(blockId) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/block/${blockId}/drawings`,
      headers
    );
    return data.data?.data ?? data.data;
  } catch (err) {
    console.error(`Error loading block drawings: ${err}`);
    mixpanelErrorTracker.trackError('server error - getBlockDrawings', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getBlockDrawings',
      blockId,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export async function deleteBlockDrawing(blockId, drawing) {
  try {
    const headers = await getHeaders();
    const { drawing_type, file_key } = buildDrawingDeletePayload(drawing);

    const response = await axiosInstance.delete(
      `${APPLICATION_API_BASE_URL}/block/${blockId}/drawings`,
      {
        ...headers,
        data: { drawing_type, file_key }
      }
    );
    return response.data?.data ?? response.data;
  } catch (err) {
    console.error(`Error deleting block drawing: ${err}`);
    mixpanelErrorTracker.trackError('server error - deleteBlockDrawing', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'deleteBlockDrawing',
      blockId,
      drawing,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export async function getAllBlocksByProject(projectId) {
  if (!projectId) return;

  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/block?projectId=${projectId}&limit=500`,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error fetching block: ${err}`);
    mixpanelErrorTracker.trackError('server error - getAllBlocksByProject', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getAllBlocksByProject',
      projectId: projectId,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Error fetching blocks');
  }
}

export async function handleCheckBlockDelete(id) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/block/checkDelete/${id}`,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error checking block to delete: ${err}`);
    mixpanelErrorTracker.trackError('server error - handleCheckBlockDelete', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'handleCheckBlockDelete',
      id: id,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Error checking block to delete');
  }
}

export async function deleteBlock(payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.delete(`${APPLICATION_API_BASE_URL}/block/delete/`, {
      ...headers,
      data: payload
    });

    return data.data.data;
  } catch (err) {
    console.error(`Error deleting block: ${err}`);
    mixpanelErrorTracker.trackError('server error - deleteBlock', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'deleteBlock',
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Error deleting block');
  }
}

export async function handleCheckLevelDelete(id) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/level/checkDelete/${id}`,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error checking level to delete: ${err}`);
    mixpanelErrorTracker.trackError('server error - handleCheckLevelDelete', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'handleCheckLevelDelete',
      id: id,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Error checking level to delete');
  }
}

export async function deleteLevel(payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.delete(`${APPLICATION_API_BASE_URL}/level/delete/`, {
      ...headers,
      data: payload
    });

    return data.data.data;
  } catch (err) {
    console.error(`Error deleting level: ${err}`);
    mixpanelErrorTracker.trackError('server error - deleteLevel', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'deleteLevel',
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Error deleting level');
  }
}

export async function handleCheckUnitDelete(id) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/unit/checkDelete/${id}`,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error checking unit to delete: ${err}`);
    mixpanelErrorTracker.trackError('server error - handleCheckUnitDelete', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'handleCheckUnitDelete',
      id: id,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Error checking unit to delete');
  }
}

export async function deleteUnit(payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.delete(`${APPLICATION_API_BASE_URL}/unit/delete/`, {
      ...headers,
      data: payload
    });

    return data.data.data;
  } catch (err) {
    console.error(`Error deleting unit: ${err}`);
    mixpanelErrorTracker.trackError('server error - deleteUnit', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'deleteUnit',
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Error deleting unit');
  }
}

export async function addPaymentStatic(blocks, setBlocks, newBlock) {
  setBlocks([...blocks, newBlock]);
  return newBlock;
}

// Edit Block
export async function editBlock(id, payload) {
  payload.area = parseFloat(payload?.area);
  // Convert building_id to integer if present
  if (payload.building_id) {
    payload.building_id = parseInt(payload.building_id);
  }
  if (payload.operations_manager_id) {
    payload.operations_manager_id = parseInt(payload.operations_manager_id);
  }

  try {
    const headers = await getHeaders();
    const data = await axiosInstance.put(
      `${APPLICATION_API_BASE_URL}/block/${id}`,
      payload,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error updating block: ${err}`);
    mixpanelErrorTracker.trackError('server error - editBlock', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'editBlock',
      id: id,
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Block not updated');
  }
}

// Edit Levels
export async function editLevel(id, payload) {
  payload = loadash.omit(payload, ['noOfUnits']);

  try {
    const headers = await getHeaders();
    const data = await axiosInstance.put(
      `${APPLICATION_API_BASE_URL}/level/${id}`,
      payload,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error updating level: ${err}`);
    mixpanelErrorTracker.trackError('server error - editLevel', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'editLevel',
      id: id,
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Level not updated');
  }
}

// Edit Basement
export async function editUnits(id, payload) {
  const body = { ...payload };
  if (body.area !== undefined && body.area !== null && body.area !== '') {
    body.area = parseInt(body.area, 10);
  } else {
    delete body.area;
  }
  if (body.sales_manager_id !== undefined && body.sales_manager_id !== null && body.sales_manager_id !== '') {
    body.sales_manager_id = parseInt(body.sales_manager_id, 10);
  } else {
    delete body.sales_manager_id;
  }
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.put(
      `${APPLICATION_API_BASE_URL}/unit/${id}`,
      body,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error updating unit: ${err}`);
    mixpanelErrorTracker.trackError('server error - editUnits', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'editUnits',
      id: id,
      payload: body,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Unit not updated');
  }
}

export async function getAvailableParkingUnits(projectId, flatUnitId = null, kind = 'all') {
  try {
    const headers = await getHeaders();
    const params = new URLSearchParams({
      project_id: String(projectId),
      kind: kind || 'all'
    });
    if (flatUnitId) params.set('flat_unit_id', String(flatUnitId));
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/unit/parking/available?${params.toString()}`,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error fetching available parking: ${err}`);
    mixpanelErrorTracker.trackError('server error - getAvailableParkingUnits', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getAvailableParkingUnits',
      projectId,
      flatUnitId,
      kind,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export async function getUnitParkingLinks(unitId) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/unit/${unitId}/parking-links`,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error fetching unit parking links: ${err}`);
    mixpanelErrorTracker.trackError('server error - getUnitParkingLinks', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getUnitParkingLinks',
      unitId,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export async function setUnitParkingLinks(unitId, payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.put(
      `${APPLICATION_API_BASE_URL}/unit/${unitId}/parking-links`,
      payload,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error setting unit parking links: ${err}`);
    mixpanelErrorTracker.trackError('server error - setUnitParkingLinks', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'setUnitParkingLinks',
      unitId,
      payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export async function unlinkUnitParking(unitId, parkingUnitId) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.delete(
      `${APPLICATION_API_BASE_URL}/unit/${unitId}/parking-links/${parkingUnitId}`,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error unlinking parking: ${err}`);
    mixpanelErrorTracker.trackError('server error - unlinkUnitParking', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'unlinkUnitParking',
      unitId,
      parkingUnitId,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export async function createLevel(payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.post(`${APPLICATION_API_BASE_URL}/level`, payload, headers);
    return data.data.data;
  } catch (err) {
    console.error(`Error creating level: ${err}`);
    mixpanelErrorTracker.trackError('server error - createLevel', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'createLevel',
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('New level not created');
  }
}

export async function getLevelById(levelId) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(`${APPLICATION_API_BASE_URL}/level/${levelId}`, headers);
    return data.data.data;
  } catch (err) {
    console.error(`Error getting level: ${err}`);
    mixpanelErrorTracker.trackError('server error - getLevelById', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getLevelById',
      levelId: levelId,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Level data not fetched');
  }
}

export async function cretaeUnit(payload) {
  payload.project_id = parseInt(payload?.project_id);

  try {
    const headers = await getHeaders();
    const data = await axiosInstance.post(`${APPLICATION_API_BASE_URL}/unit`, payload, headers);
    return data.data.data;
  } catch (err) {
    console.error(`Error creating unit: ${err}`);
    mixpanelErrorTracker.trackError('server error - cretaeUnit', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'cretaeUnit',
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Unit data not created');
  }
}

// PLC APIs
export async function createPLCList(payload) {
  const priceNum =
    payload.price != null && payload.price !== ''
      ? Number(payload.price)
      : 0;
  const body = {
    name: payload.name,
    description: payload.description,
    mode: payload.mode,
    associated_unit_ids: payload.associated_unit_ids,
    block_ids: payload.block_ids,
    price: Number.isFinite(priceNum) ? priceNum : 0,
    ...(payload.universal_measurement_id
      ? { universal_measurement_id: payload.universal_measurement_id }
      : {})
  };
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/plc/with-units`,
      body,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error('Error in PLC List', err);
    mixpanelErrorTracker.trackError('server error - createPLCList', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'createPLCList',
      payload: body,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('No PLC list');
  }
}

export async function getPlcbyBlockId(id) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/unit?block_id=${id}&limit=500`,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error('Error in PLC by block id', err);
    mixpanelErrorTracker.trackError('server error - getPlcbyBlockId', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getPlcbyBlockId',
      id: id,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('No PLC list by block id');
  }
}

export async function getUnitsById(id, blockId) {
  console.log(id);

  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/unit/${id}?limit=500`,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error('Error in PLC by Units id', err);
    mixpanelErrorTracker.trackError('server error - getUnitsById', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getUnitsById',
      id: id,
      blockId: blockId,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Units by id');
  }
}

export async function getUnitsByProjectId(id) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/unit?project_id=${id}&limit=500&summary=1`,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error('Error getting units by project id', err);
    mixpanelErrorTracker.trackError('server error - getUnitsByProjectId', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getUnitsByProjectId',
      id: id,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Error getting units by project id');
  }
}

export async function getPlcbyId(id) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/plc/${id}?limit=500`,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error('Error in PLC by block id', err);
    mixpanelErrorTracker.trackError('server error - getPlcbyId', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getPlcbyId',
      id: id,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('No PLC list by  id');
  }
}

// update plc (with units — mode is not sent; pricing mode is fixed on the server)

export async function updateplc(id, payload) {
  const priceNum =
    payload.price != null && payload.price !== ''
      ? Number(payload.price)
      : 0;
  const body = {
    name: payload.name,
    description: payload.description,
    mode: payload.mode,
    associated_unit_ids: payload.associated_unit_ids,
    block_ids: payload.block_ids,
    price: Number.isFinite(priceNum) ? priceNum : 0,
    ...(payload.universal_measurement_id
      ? { universal_measurement_id: payload.universal_measurement_id }
      : {})
  };
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.put(
      `${APPLICATION_API_BASE_URL}/plc/with-units/${id}`,
      body,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error('Error in plc update', err);
    mixpanelErrorTracker.trackError('server error - updateplc', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'updateplc',
      id: id,
      payload: body,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('No PLC plc update');
  }
}

export async function getPlcbyAssociatedBlockId(id) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/block/${id}?limit=500`,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error('Error in PLC by block id', err);
    mixpanelErrorTracker.trackError('server error - getPlcbyAssociatedBlockId', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getPlcbyAssociatedBlockId',
      id: id,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('No PLC list by block id');
  }
}

export async function getCommonPLC() {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/common-entity/common-entities?limit=500`,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error('Error in PLC by block id', err);
    mixpanelErrorTracker.trackError('server error - getCommonPLC', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getCommonPLC',
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('No PLC list by block id');
  }
}

export async function getPlc() {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(`${APPLICATION_API_BASE_URL}/plc?limit=10000`, headers);
    return data.data.data;
  } catch (err) {
    console.error('Error in PLC ', err);
    mixpanelErrorTracker.trackError('server error - getPlc', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getPlc',
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('No PLC list');
  }
}

export async function getPlcsbyBlockId(id) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/plc?block_id=${id}&limit=500`,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error('Error in PLC ', err);
    mixpanelErrorTracker.trackError('server error - getPlcsbyBlockId', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getPlcsbyBlockId',
      id: id,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('No PLC list');
  }
}

export async function handleCheckPLCDelete(id) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/plc/checkDelete/${id}`,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error checking PLC to delete: ${err}`);
    mixpanelErrorTracker.trackError('server error - handleCheckPLCDelete', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'handleCheckPLCDelete',
      id: id,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Error checking PLC to delete');
  }
}

export async function deletePLC(id) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.delete(`${APPLICATION_API_BASE_URL}/plc/with-units/${id}`, headers);

    return data.data.data;
  } catch (err) {
    console.error(`Error deleting PLC: ${err}`);
    mixpanelErrorTracker.trackError('server error - deletePLC', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'deletePLC',
      id: id,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Error deleting PLC');
  }
}

// export async function getPlcByProjectId() {
//   try {
//     const headers = await getHeaders();
//     const data = await axiosInstance.get(`${API_BASE_URL}/plc?`, headers);
//     return data.data.data;
//   } catch (err) {
//     console.error('Error in PLC ', err);
//     throw err; // throw new Error('No PLC list');
//   }
// }

export async function createPLCUnit(payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.post(`${APPLICATION_API_BASE_URL}/unitplc`, payload, headers);
    return data.data.data;
  } catch (err) {
    console.error('Error in PLC List', err);
    mixpanelErrorTracker.trackError('server error - createPLCUnit', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'createPLCUnit',
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('No PLC list');
  }
}

//////////////////////////////////////////
/// PRICING API's
export async function createPricing(payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/unit/pricing`,
      payload,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error creating pricing: ${err}`);
    mixpanelErrorTracker.trackError('server error - createPricing', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'createPricing',
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Pricing data not created');
  }
}

export async function getAllPricingByProjectId(projectId) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/unitpricing?project_id=${projectId}&limit=100`,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error('Error in Pricing by project id', err);
    mixpanelErrorTracker.trackError('server error - getAllPricingByProjectId', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getAllPricingByProjectId',
      projectId: projectId,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('No Pricing list by project id');
  }
}

export async function editPricing(id, payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/unit/pricing`,
      { data: Array.isArray(payload) ? payload : [payload] },
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error updating pricing: ${err}`);
    mixpanelErrorTracker.trackError('server error - editPricing', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'editPricing',
      id: id,
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Pricing not updated');
  }
}

export async function getSinglePricingById(pricingId, projectId) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/unitpricing/${pricingId}`,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error getting pricing: ${err}`);
    mixpanelErrorTracker.trackError('server error - getSinglePricingById', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getSinglePricingById',
      pricingId: pricingId,
      projectId: projectId,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Pricing data not fetched');
  }
}

export async function updatePLCPricing(updatedPLCPricing) {
  // Create a new object excluding empty values
  const cleanedPLCPricing = Object.fromEntries(
    Object.entries(updatedPLCPricing).filter(([_, value]) => value !== '')
  );

  try {
    const headers = await getHeaders();
    const response = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/plc/pricing`,
      cleanedPLCPricing,
      headers // Ensure headers are correctly passed inside an object
    );
    return response.data.data;
  } catch (err) {
    console.error(`Error updating PLC pricing: ${err.message}`, err);
    mixpanelErrorTracker.trackError('server error - updatePLCPricing', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'updatePLCPricing',
      updatedPLCPricing: updatedPLCPricing,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Failed to update PLC pricing');
  }
}

export async function getUnitPricingByBlockId(blockId, page = 1, limit = 50, status = null) {
  try {
    // limit>500 requires export=1 (BE LIST_MAX_LIMIT); prefer page/limit instead
    // sort=block_unit: Tower-A → unit 1… across pages (not id DESC)
    let url = `${APPLICATION_API_BASE_URL}/unit?block_id=${blockId}&page=${page}&limit=${limit}&sort=block_unit`;
    if (limit > 500) {
      url += `&export=1`;
    }
    if (status && status !== 'Select Status') {
      url += `&status=${encodeURIComponent(status)}`;
    }
    const headers = await getHeaders();
    const response = await axiosInstance.get(url, headers);
    warnIfListTruncated('getUnitPricingByBlockId', response.data?.data, response.data?.meta, {
      page,
      limit
    });
    return response.data;
  } catch (err) {
    console.error('Error in Pricing by block id', err);
    mixpanelErrorTracker.trackError('server error - getUnitPricingByBlockId', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getUnitPricingByBlockId',
      blockId: blockId,
      page: page,
      limit: limit,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('No Pricing list by block id');
  }
}

export async function getUnitPricingByProjectId(projectId, page = 1, limit = 50, status = null) {
  try {
    let url = `${APPLICATION_API_BASE_URL}/unit?project_id=${projectId}&page=${page}&limit=${limit}&sort=block_unit`;
    if (limit > 500) {
      url += `&export=1`;
    }
    if (status && status !== 'Select Status') {
      url += `&status=${encodeURIComponent(status)}`;
    }
    const headers = await getHeaders();
    const response = await axiosInstance.get(url, headers);
    warnIfListTruncated('getUnitPricingByProjectId', response.data?.data, response.data?.meta, {
      page,
      limit
    });
    return response.data;
  } catch (err) {
    console.error('Error in Pricing by project id', err);
    mixpanelErrorTracker.trackError('server error - getUnitPricingByProjectId', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getUnitPricingByProjectId',
      projectId: projectId,
      page: page,
      limit: limit,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

//get all unit status api
export async function getUnitStatus() {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(`${APPLICATION_API_BASE_URL}/status/units`, headers);
    return data.data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - getUnitStatus', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getUnitStatus',
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Unit status data not loaded');
  }
}

//update unit status api
export async function updateUnitStatus(selectedUnitId, payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.put(
      `${APPLICATION_API_BASE_URL}/unit/${selectedUnitId}`,
      payload,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error updating unit status: ${err}`);
    mixpanelErrorTracker.trackError('server error - updateUnitStatus', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'updateUnitStatus',
      selectedUnitId: selectedUnitId,
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Unit status not updated');
  }
}

//////////////////////////////////////////
/// SALES API's
export async function getAllLead(page = 1, limit = 200) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/leads?page=${page}&limit=${limit}`,
      headers
    );
    return data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - getAllLead', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getAllLead',
      page: page,
      limit: limit,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err; // throw new Error('Leads data not loaded');
  }
}

export async function deleteLead(payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.delete(`${APPLICATION_API_BASE_URL}/leads/delete`, {
      ...headers,
      data: payload
    });

    return data.data;
  } catch (err) {
    console.error(`Error deleting lead: ${err}`);
    mixpanelErrorTracker.trackError('server error - deleteLead', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'deleteLead',
      payload: payload,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err; // throw new Error('Leads data not loaded');
  }
}

export async function getAllLeadForProject(page = 1, limit = 200) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/leads?page=${page}&limit=${limit}`,
      headers
    );
    return data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - getAllLeadForProject', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getAllLeadForProject',
      page: page,
      limit: limit,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Leads data not loaded');
  }
}

/**
 * Lightweight lead picker for Select Lead / Close Deal / UC modals.
 * Uses ?picker=1 (max 500) + server search; never megafetch limit=200000.
 * excludeDeal / excludeUc match previous client-side filters so options stay correct.
 */
export async function getLeadsForPicker({
  page = 1,
  limit = 100,
  search = '',
  excludeDeal = true,
  excludeUc = false,
  projectId = null
} = {}) {
  try {
    const headers = await getHeaders();
    const params = new URLSearchParams();
    params.set('picker', '1');
    params.set('page', String(page));
    params.set('limit', String(limit));
    if (excludeDeal) params.set('exclude_deal', '1');
    if (excludeUc) params.set('exclude_uc', '1');
    if (search && String(search).trim()) {
      params.set('search', String(search).trim());
    }
    if (projectId != null && projectId !== '') {
      params.set('project_id', String(projectId));
    }
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/leads?${params.toString()}`,
      headers
    );
    return data.data;
  } catch (err) {
    console.error(`Error loading picker leads: ${err}`);
    mixpanelErrorTracker.trackError('server error - getLeadsForPicker', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getLeadsForPicker',
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export async function getAllLeadForSalesId(id) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/leads?sales_id=${id}&page=1&limit=500`,
      headers
    );
    return data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - getAllLeadForSalesId', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getAllLeadForSalesId',
      id: id,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Leads data not loaded');
  }
}

// Create Lead API
export async function createLead(payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.post(`${APPLICATION_API_BASE_URL}/leads`, payload, headers);
    return data.data.data;
  } catch (err) {
    console.error(`Error creating lead: ${err}`);
    mixpanelErrorTracker.trackError('server error - createLead', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'createLead',
      payload: payload,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err; // throw new Error('New lead not created');
  }
}

// Update lead By ID
export async function updateLeadById(id, payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.put(
      `${APPLICATION_API_BASE_URL}/leads/transfer/${id}`,
      payload,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - updateLeadById', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'updateLeadById',
      lead_id: id,
      payload: payload,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err; // throw new Error('Lead data not loaded');
  }
}

/** POST /leads/bulk/transfer — sales managers / management */
export async function bulkTransferLeads({ lead_ids, sales_id }) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/leads/bulk/transfer`,
      { lead_ids, sales_id },
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error bulk transferring leads: ${err}`);
    mixpanelErrorTracker.trackError('server error - bulkTransferLeads', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'bulkTransferLeads',
      payload: { lead_ids, sales_id },
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function updateLead(id, payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.put(
      `${APPLICATION_API_BASE_URL}/leads/${id}`,
      payload,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - updateLead', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'updateLead',
      lead_id: id,
      payload: payload,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err; // throw new Error('Lead data not loaded');
  }
}

// Clone Lead API
export async function cloneLead(id, payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.put(
      `${APPLICATION_API_BASE_URL}/leads/clone/${id}`,
      payload,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error cloning lead: ${err}`);
    mixpanelErrorTracker.trackError('server error - cloneLead', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'cloneLead',
      lead_id: id,
      payload: payload,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err; // throw new Error('Lead not cloned');
  }
}

export async function getUnderConsideration(page = 1, limit = 200) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/underConsideration?page=${page}&limit=${limit}`,
      headers
    );
    return data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - getUnderConsideration', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getUnderConsideration',
      page: page,
      limit: limit,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Leads data not loaded');
  }
}

export async function getUnderConsiderationById(id) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/underConsideration?id=${id}`,
      headers
    );
    return data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - getUnderConsiderationById', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getUnderConsiderationById',
      id: id,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Leads data not loaded');
  }
}

export async function getUnderConsiderationByProjectID(
  id,
  page = 1,
  limit = 200,
  searchQuery,
  approved = null
) {
  try {
    const headers = await getHeaders();

    let url = `${APPLICATION_API_BASE_URL}/underConsideration?`;

    if (id) {
      url += `project_id=${id}&`;
    }

    url += `page=${page}&limit=${limit}`;

    if (searchQuery) {
      url += `&search=${searchQuery}`;
    }

    if (approved !== null) {
      url += `&approved=${approved}`;
    }

    const data = await axiosInstance.get(url, headers);
    return data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - getUnderConsiderationByProjectID', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getUnderConsiderationByProjectID',
      id: id,
      page: page,
      limit: limit,
      approved: approved,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Leads data not loaded');
  }
}

export async function handleCheckUCDelete(id) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/underConsideration/checkDelete/${id}`,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error checking under consideration: ${err}`);
    mixpanelErrorTracker.trackError('server error - handleCheckUCDelete', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'handleCheckUCDelete',
      id: id,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Error checking under consideration');
  }
}

export async function deleteUnderConsideration(payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.delete(
      `${APPLICATION_API_BASE_URL}/underConsideration/delete`,
      {
        ...headers,
        data: payload
      }
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error deleting under consideration: ${err}`);
    mixpanelErrorTracker.trackError('server error - deleteUnderConsideration', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'deleteUnderConsideration',
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export async function approveUnderConsideration(id, payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.put(
      `${APPLICATION_API_BASE_URL}/underConsideration/${id}`,
      payload,
      headers
    );
    return data.data;
  } catch (err) {
    console.error(`Error approving: ${err}`);
    mixpanelErrorTracker.trackError('server error - approveUnderConsideration', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'approveUnderConsideration',
      id: id,
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Error Approving ');
  }
}

export async function createUnderConsideration(payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/underConsideration`,
      payload,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error creating under consideration: ${err}`);
    mixpanelErrorTracker.trackError('server error - createUnderConsideration', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'createUnderConsideration',
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Error creating under consideration');
  }
}

export async function handleCheckUnderConsiderationDelete(id) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/underConsideration/checkDelete/${id}`,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error checking underConsideration: ${err}`);
    mixpanelErrorTracker.trackError('server error - handleCheckUnderConsiderationDelete', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'handleCheckUnderConsiderationDelete',
      id: id,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Error checking underConsideration');
  }
}

// get All leads by status

export async function getLeadsByStatus(status, pstatus, page = 1, limit = 200) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/leads?status=${status}&pstatus=${pstatus}&page=${page}&limit=${limit}`,
      headers
    );
    return data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - getLeadsByStatus', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getLeadsByStatus',
      status: status,
      pstatus: pstatus,
      page: page,
      limit: limit,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('getLeadsByStatus data not loaded');
  }
}

export async function getLeadsByStatusAndProject(
  id,
  status,
  pstatus,
  page = 1,
  limit = 200,
  search,
  sales,
  closureDate,
  lastFollowUp,
  nextFollowUp,
  createdOn,
  source = null,
  qualificationTags = null,
  createdFrom = null,
  createdTo = null
) {
  try {
    const headers = await getHeaders();

    let url = `${APPLICATION_API_BASE_URL}/leads?`;

    if (id) {
      url += `project_id=${id}&`;
    }

    if (search) {
      url += `&search=${search}&`;
    }

    if (sales) {
      url += `&sales_id=${sales}&`;
    }

    if (closureDate) {
      url += `&sort=${closureDate}&`;
    }

    if (lastFollowUp) {
      url += `&sort=${lastFollowUp}&`;
    }

    const isNextFollowUpDateFilter = nextFollowUp === 'today';

    if (nextFollowUp) {
      if (isNextFollowUpDateFilter) {
        url += `&next_follow_up=${nextFollowUp}&`;
      } else {
        url += `&sort=${nextFollowUp}&`;
      }
    }

    if (createdOn && createdOn !== 'custom') {
      url += `&sort=${createdOn}&`;
    }

    if (createdFrom) {
      url += `&created_from=${encodeURIComponent(createdFrom)}&`;
    }

    if (createdTo) {
      url += `&created_to=${encodeURIComponent(createdTo)}&`;
    }

    if (source) {
      url += `&source=${encodeURIComponent(source)}&`;
    }

    const tagsParam = Array.isArray(qualificationTags)
      ? qualificationTags.filter(Boolean).join(',')
      : typeof qualificationTags === 'string'
        ? qualificationTags
        : '';
    if (tagsParam) {
      url += `&qualification_tags=${encodeURIComponent(tagsParam)}&`;
    }

    const hasColumnSort = Boolean(
      closureDate ||
        lastFollowUp ||
        (nextFollowUp && !isNextFollowUpDateFilter) ||
        (createdOn && createdOn !== 'custom')
    );
    if (!hasColumnSort) {
      // Default: created_at first, then last WhatsApp message (BE applies that priority)
      url += `&sort=created_on_desc&`;
      url += `&sort=last_whatsapp_message_desc&`;
    }

    const normalizedPstatus = Array.isArray(pstatus)
      ? pstatus.filter((statusValue) => statusValue && statusValue !== 'all').join(',')
      : typeof pstatus === 'string'
        ? pstatus
            .split(',')
            .map((statusValue) => statusValue.trim())
            .filter((statusValue) => statusValue && statusValue !== 'all')
            .join(',')
        : '';

    if (normalizedPstatus) {
      url += `&pstatus=${encodeURIComponent(normalizedPstatus)}&`;
    }

    // url += `status=${status}&page=${page}&limit=${limit}`;
    url += `page=${page}&limit=${limit}`;
    // SalesList shows WA columns — opt into WA hydrate so PERF_LEADS_SKIP_WA_HYDRATE is safe.
    url += `&include_wa=1`;

    const data = await axiosInstance.get(url, headers);
    return data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - getLeadsByStatusAndProject', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getLeadsByStatusAndProject',
      id: id,
      status: status,
      pstatus: pstatus,
      closureDate: closureDate,
      lastFollowUp: lastFollowUp,
      nextFollowUp: nextFollowUp,
      createdOn: createdOn,
      page: page,
      limit: limit,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err; // throw new Error('getLeadsByStatus data not loaded');
  }
}

export async function getLeadCardsStatsPerUser(projectId, salesId) {
  try {
    const headers = await getHeaders();
    const params = new URLSearchParams();
    if (projectId) params.set('project_id', String(projectId));
    if (salesId) params.set('sales_id', String(salesId));
    const qs = params.toString() ? `?${params.toString()}` : '';
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/leads/cards/statsPerUser${qs}`,
      headers
    );
    return data.data;
  } catch (err) {
    console.error(`Error loading lead cards stats per user: ${err}`);
    mixpanelErrorTracker.trackError('server error - getLeadCardsStatsPerUser', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getLeadCardsStatsPerUser',
      project_id: projectId,
      sales_id: salesId || null,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function getLeadsByDate({ date, projectId }) {
  try {
    const headers = await getHeaders();
    const { data } = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/leads/by-date?date=${encodeURIComponent(date)}&project_id=${projectId}`,
      headers
    );
    return data?.data ?? { total: 0, bySource: [], leads: [] };
  } catch (err) {
    console.error(`Error loading leads by date: ${err}`);
    mixpanelErrorTracker.trackError('server error - getLeadsByDate', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getLeadsByDate',
      date,
      project_id: projectId,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function getLeadByID(id, { full = false } = {}) {
  try {
    const headers = await getHeaders();
    const qs = full ? '?full=1' : '';
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/leads/${id}${qs}`,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - getLeadByID', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getLeadByID',
      lead_id: id,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err; // throw new Error('Lead data not loaded');
  }
}

export async function handleCheckLeadDelete(id) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/leads/checkDelete/${id}`,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error checking lead: ${err}`);
    mixpanelErrorTracker.trackError('server error - handleCheckLeadDelete', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'handleCheckLeadDelete',
      id: id,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Error checking lead');
  }
}

export async function getLogsByID(id) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/saleslogs?lead_id=${id}`,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - getLogsByID', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getLogsByID',
      id: id,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Lead data not loaded');
  }
}

export async function updateStage(payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.post(`${APPLICATION_API_BASE_URL}/activity`, payload, headers);
    return data.data.data;
  } catch (err) {
    console.error(`Error adding log: ${err}`);
    mixpanelErrorTracker.trackError('server error - updateStage', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'updateStage',
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Log not added');
  }
}

export async function addLog(payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/saleslogs`,
      payload,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error adding log: ${err}`);
    mixpanelErrorTracker.trackError('server error - addLog', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'addLog',
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Log not added');
  }
}

export async function addLogComment(payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/logComment`,
      payload,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error adding comment: ${err}`);
    mixpanelErrorTracker.trackError('server error - addLogComment', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'addLogComment',
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Comment not added');
  }
}

export async function getActivityByID(id) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/activity?lead_id=${id}&limit=100`,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - getActivityByID', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getActivityByID',
      id: id,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Activity data not loaded');
  }
}
export async function approveActivity(id, payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.put(
      `${APPLICATION_API_BASE_URL}/activity/${id}`,
      payload,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - approveActivity', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'approveActivity',
      id: id,
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Activity data not loaded');
  }
}

export async function addActivity(payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.post(`${APPLICATION_API_BASE_URL}/activity`, payload, headers);
    return data.data.data;
  } catch (err) {
    console.error(`Error adding activity: ${err}`);
    mixpanelErrorTracker.trackError('server error - addActivity', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'addActivity',
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export async function getEvent(id) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/event?lead_id=${id}`,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - getEvent', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getEvent',
      id: id,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Event data not loaded');
  }
}

/////////////////////////////////////////////////////
// PARTNERS APIs

export async function getMyPartners(page = 1, limit = 20000) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/partner/my?page=1&limit=${limit}`,
      headers
    );
    return data.data;
  } catch (err) {
    console.log(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - getMyPartners', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getMyPartners',
      page: page,
      limit: limit,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Partner data not loaded');
  }
}

export async function createPartner(payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.post(`${APPLICATION_API_BASE_URL}/partner`, payload, headers);
    return data.data.data;
  } catch (err) {
    console.error(`Error creating partner: ${err}`);
    mixpanelErrorTracker.trackError('server error - createPartner', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'createPartner',
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('New partner not created');
  }
}

export async function findPartnerByNumber(payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/partner/byPhone/${payload.phone_number}`,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error finding partner: ${err}`);
    mixpanelErrorTracker.trackError('server error - findPartnerByNumber', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'findPartnerByNumber',
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Error finding partner');
  }
}

//////////////////////////////////
// HOLIDAY APIs

export async function getAllHoliday() {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/holiday?page=1&limit=10000`,
      headers
    );
    return data.data;
  } catch (err) {
    console.error(`Error fetching holiday: ${err}`);
    mixpanelErrorTracker.trackError('server error - getAllHoliday', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getAllHoliday',
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('New holiday not fetched');
  }
}
export async function createHoliday(payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.post(`${APPLICATION_API_BASE_URL}/holiday`, payload, headers);
    return data.data.data;
  } catch (err) {
    console.error(`Error creating holiday: ${err}`);
    mixpanelErrorTracker.trackError('server error - createHoliday', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'createHoliday',
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('New holiday not created');
  }
}

export async function updateHoliday(id, payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.put(
      `${APPLICATION_API_BASE_URL}/holiday/${id}`,
      payload,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error updating holiday: ${err}`);
    mixpanelErrorTracker.trackError('server error - updateHoliday', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'updateHoliday',
      id: id,
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('New holiday not updated');
  }
}

//////////////////////////////////////
// TEMPLATE TASKS APIS

export async function getAllCommonTaskTemplates(projectId, templateId, worktypeId) {
  try {
    const headers = await getHeaders();
    let url = `${APPLICATION_API_BASE_URL}/taskTemplate/common?page=1&limit=10000`;

    // Add project ID if provided
    if (projectId) {
      url += `&project_id=${encodeURIComponent(projectId)}`;
    }

    // Add template ID if provided (encode: names may contain +, &, # e.g. "G+12 Tower")
    if (templateId) {
      url += `&name=${encodeURIComponent(templateId)}`;
    }

    // Add worktype filter if provided
    if (worktypeId) {
      url += `&workType_id=${encodeURIComponent(worktypeId)}`;
    }

    const data = await axiosInstance.get(url, headers);
    return data.data;
  } catch (err) {
    console.error(`Error fetching tasks: ${err}`);
    mixpanelErrorTracker.trackError('server error - getAllCommonTaskTemplates', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getAllCommonTaskTemplates',
      project_id: projectId,
      template_id: templateId,
      worktype_id: worktypeId,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('New tasks not fetched');
  }
}

export async function createTaskTemplate(payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/taskTemplate/create`,
      payload,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error creating task: ${err}`);
    mixpanelErrorTracker.trackError('server error - createTaskTemplate', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'createTaskTemplate',
      payload: payload,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    mixpanelErrorTracker.trackError('server error - createTaskTemplate', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'createTaskTemplate',
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('New task not created');
  }
}

export async function updateTaskTemplate(id, payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.put(
      `${APPLICATION_API_BASE_URL}/taskTemplate/${id}`,
      payload,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error updating task: ${err}`);
    mixpanelErrorTracker.trackError('server error - updateTaskTemplate', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'updateTaskTemplate',
      template_id: id,
      payload: payload,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    mixpanelErrorTracker.trackError('server error - updateTaskTemplate', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'updateTaskTemplate',
      template_id: id,
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Task not updated');
  }
}

export async function getAllAccommodationTaskTemplates(type, projectId, templateId, worktypeId) {
  try {
    const headers = await getHeaders();
    let url = `${APPLICATION_API_BASE_URL}/taskTemplate/accomodation?accomodationType=${encodeURIComponent(type)}`;

    // Add project ID if provided
    if (projectId) {
      url += `&project_id=${encodeURIComponent(projectId)}`;
    }

    // Add template ID if provided (encode: names may contain +, &, # e.g. "G+12 Tower")
    if (templateId) {
      url += `&name=${encodeURIComponent(templateId)}`;
    }

    // Add worktype filter if provided
    if (worktypeId) {
      url += `&workType_id=${encodeURIComponent(worktypeId)}`;
    }

    const data = await axiosInstance.get(url, headers);
    return data.data;
  } catch (err) {
    console.error(`Error fetching tasks: ${err}`);
    mixpanelErrorTracker.trackError('server error - getAllAccommodationTaskTemplates', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getAllAccommodationTaskTemplates',
      type: type,
      project_id: projectId,
      template_id: templateId,
      worktype_id: worktypeId,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('New tasks not fetched');
  }
}

/////////////////////////////////////////
/// VENDOR API's
export async function createVendor(payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.post(`${APPLICATION_API_BASE_URL}/vendor`, payload, headers);
    return data.data.data;
  } catch (err) {
    console.error(`Error creating vendor: ${err}`);
    mixpanelErrorTracker.trackError('server error - createVendor', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'createVendor',
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('New vendor not created');
  }
}

export async function updateVendor(id, payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.put(
      `${APPLICATION_API_BASE_URL}/vendor/${id}`,
      payload,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - updateVendor', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'updateVendor',
      id: id,
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Vendor data not loaded');
  }
}

export async function getMyVendors(page = 1, limit = 200, city = '', category_id = '') {
  try {
    const headers = await getHeaders();
    let query = `page=${page}&limit=${limit}`;
    if (city) {
      query += `&city=${city}`;
    }
    if (category_id) {
      query += `&category_id=${category_id}`;
    }
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/vendor/myVendor?${query}`,
      headers
    );
    return data.data;
  } catch (err) {
    console.log(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - getMyVendors', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getMyVendors',
      page: page,
      limit: limit,
      city: city,
      category_id: category_id,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Vendor data not loaded');
  }
}

export async function importVendor(payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.put(
      `${APPLICATION_API_BASE_URL}/vendor/import`,
      payload,
      headers
    );
    return data.data;
  } catch (err) {
    console.log(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - importVendor', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'importVendor',
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Vendor not imported');
  }
}

export async function getMarketPlaceVendors(page = 1, limit = 200, city = '', category_id = '') {
  try {
    const headers = await getHeaders();
    let query = `page=${page}&limit=${limit}`;
    if (city) {
      query += `&city=${city}`;
    }
    if (category_id) {
      query += `&category_id=${category_id}`;
    }
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/vendor/marketPlace?${query}`,
      headers
    );
    return data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - getMarketPlaceVendors', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getMarketPlaceVendors',
      page: page,
      limit: limit,
      city: city,
      category_id: category_id,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Vendor data not loaded');
  }
}

export async function getAllVendor(page = 1, limit = 200) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/vendor?page=${page}&limit=${limit}`,
      headers
    );
    return data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - getAllVendor', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getAllVendor',
      page: page,
      limit: limit,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Vendor data not loaded');
  }
}

export async function getVendorById(Id) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(`${APPLICATION_API_BASE_URL}/vendor/${Id}`, headers);
    return data.data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - getVendorById', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getVendorById',
      id: Id,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Vendor data not loaded');
  }
}

export async function getVendorDeleteId(Id) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.delete(`${APPLICATION_API_BASE_URL}/vendor/${Id}`, headers);
    return data.data.data;
  } catch (err) {
    console.error(`Error deleting vendor: ${err}`);
    mixpanelErrorTracker.trackError('server error - getVendorDeleteId', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getVendorDeleteId',
      id: Id,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Vendor not deleted');
  }
}

export async function handleCheckVendorDelete(id) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/vendor/checkDelete/${id}`,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error checking vendor: ${err}`);
    mixpanelErrorTracker.trackError('server error - handleCheckVendorDelete', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'handleCheckVendorDelete',
      id: id,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Error checking vendor');
  }
}

export async function deleteVendor(payload) {
  try {
    const headers = await getHeaders(); // contains { headers: { Authorization: '...' } }

    const response = await axiosInstance.delete(`${APPLICATION_API_BASE_URL}/vendor/delete`, {
      ...headers,
      data: payload
    });

    return response.data.data;
  } catch (err) {
    console.error('Error deleting vendor:', err?.response || err);
    mixpanelErrorTracker.trackError('server error - deleteVendor', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'deleteVendor',
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Error deleting vendor');
  }
}

// Deactivate Vendor
export async function deactivateVendor(payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.patch(
      `${APPLICATION_API_BASE_URL}/vendor/deactivate`,
      payload,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error deactivating vendor: ${err}`);
    mixpanelErrorTracker.trackError('server error - deactivateVendor', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'deactivateVendor',
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Vendor status not updated');
  }
}

/////////////////////////////////////////
/// SERVICE PROVIDER API's
export async function createServiceProvider(payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/serviceprovider`,
      payload,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error creating service provider: ${err}`);
    mixpanelErrorTracker.trackError('server error - createServiceProvider', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'createServiceProvider',
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Service Provider not created');
  }
}

export async function updateServiceProvider(id, payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.put(
      `${APPLICATION_API_BASE_URL}/serviceprovider/${id}`,
      payload,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error updating service provider: ${err}`);
    mixpanelErrorTracker.trackError('server error - updateServiceProvider', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'updateServiceProvider',
      id: id,
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Service Provider not updated');
  }
}

export async function getAllServiceProvider(page = 1, limit = 200) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/serviceprovider?page=${page}&limit=${limit}`,
      headers
    );
    return data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - getAllServiceProvider', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getAllServiceProvider',
      page: page,
      limit: limit,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Service Providers data not loaded');
  }
}

export async function getNotifications() {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/notification?limit=100`,
      headers
    );
    return data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - getNotifications', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getNotifications',
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Notifications not loaded');
  }
}

export async function getCustomerChangeRequests(page, limit, projectId) {
  try {
    const headers = await getHeaders();
    let url = `${APPLICATION_API_BASE_URL}/customerChangeRequest?page=${page}&limit=${limit}`;
    if (projectId) {
      url += `&project_id=${projectId}`;
    }
    const data = await axiosInstance.get(url, headers);
    return data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - getCustomerChangeRequests', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getCustomerChangeRequests',
      page: page,
      limit: limit,
      project_id: projectId || 'N/A',
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Change Requests not loaded');
  }
}

export async function assignEngineer(id, payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.put(
      `${APPLICATION_API_BASE_URL}/customerChangeRequest/${id}`,
      payload,
      headers
    );
    return data.data;
  } catch (err) {
    console.error(`Error Assigning Engineer: ${err}`);
    mixpanelErrorTracker.trackError('server error - assignEngineer', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'assignEngineer',
      id: id,
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Error Assigning Engineer');
  }
}

export async function getCustomerChangeRequestTasks(id, page, limit) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/customerChangeRequest/item/${id}?page=${page}&limit=${limit}`,
      headers
    );
    return data.data;
  } catch (err) {
    console.error(`Error loading change request tasks data: ${err}`);
    mixpanelErrorTracker.trackError('server error - getCustomerChangeRequestTasks', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getCustomerChangeRequestTasks',
      id: id,
      page: page,
      limit: limit,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Change Requests Tasks');
  }
}

export async function updateCustomerChangeRequeItem(id, payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.put(
      `${APPLICATION_API_BASE_URL}/customerChangeRequest/item/${id}`,
      payload,
      headers
    );
    return data.data;
  } catch (err) {
    console.error(`Error Updating Item: ${err}`);
    mixpanelErrorTracker.trackError('server error - updateCustomerChangeRequeItem', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'updateCustomerChangeRequeItem',
      id: id,
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Error Updating Item');
  }
}

export async function getMyServiceProvider(page = 1, limit = 200, city = '') {
  try {
    const headers = await getHeaders();
    let query = `page=${page}&limit=${limit}`;
    if (city) {
      query += `&city=${city}`;
    }
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/serviceprovider/mySp?${query}`,
      headers
    );
    return data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - getMyServiceProvider', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getMyServiceProvider',
      page: page,
      limit: limit,
      city: city,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Service Providers data not loaded');
  }
}

export async function getContractorAndArchitect(id) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/serviceprovider/mySp?category_id=${id}&page=1&limit=10000`,
      headers
    );
    return data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - getContractorAndArchitect', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getContractorAndArchitect',
      id: id,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Contractor and Architect are not loaded');
  }
}

export async function importSP(payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.put(
      `${APPLICATION_API_BASE_URL}/serviceprovider/import`,
      payload,
      headers
    );
    return data.data;
  } catch (err) {
    console.error(`Error Importing Service Provider: ${err}`);
    mixpanelErrorTracker.trackError('server error - importSP', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'importSP',
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Service Providers Not Imported');
  }
}

export async function handleCheckServiceProviderDelete(id) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/serviceprovider/checkDelete/${id}`,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error checking serviceprovider: ${err}`);
    mixpanelErrorTracker.trackError('server error - handleCheckServiceProviderDelete', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'handleCheckServiceProviderDelete',
      id: id,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Error checking serviceprovider');
  }
}

export async function deleteServiceProvider(payload) {
  try {
    const headers = await getHeaders(); // contains { headers: { Authorization: '...' } }

    const response = await axiosInstance.delete(
      `${APPLICATION_API_BASE_URL}/serviceprovider/delete`,
      {
        ...headers,
        data: payload
      }
    );

    return response.data.data;
  } catch (err) {
    console.error('Error deleting serviceprovider:', err?.response || err);
    mixpanelErrorTracker.trackError('server error - deleteServiceProvider', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'deleteServiceProvider',
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Error deleting serviceprovider');
  }
}

export async function getMarketPlaceServiceProvider(page = 1, limit = 200, city = '') {
  try {
    const headers = await getHeaders();
    let query = `page=${page}&limit=${limit}`;
    if (city) {
      query += `&city=${city}`;
    }
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/serviceprovider/marketPlace?${query}`,
      headers
    );
    return data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - getMarketPlaceServiceProvider', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getMarketPlaceServiceProvider',
      page: page,
      limit: limit,
      city: city,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Service Providers data not loaded');
  }
}

//write api for get all categories
export async function getAllCategoriesForServiceProvider() {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(`${APPLICATION_API_BASE_URL}/categoryprovider`, headers);
    return data.data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - getAllCategoriesForServiceProvider', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getAllCategoriesForServiceProvider',
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Categories data not loaded');
  }
}

/////////////////////////////////////////
/// MATERIALS API's
export async function createMaterial(payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.post(`${APPLICATION_API_BASE_URL}/items`, payload, headers);
    return data.data.data;
  } catch (err) {
    console.error(`Error creating material: ${err}`);
    mixpanelErrorTracker.trackError('server error - createMaterial', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'createMaterial',
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Material not created');
  }
}
export async function updateMaterial(payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.put(`${APPLICATION_API_BASE_URL}/items`, payload, headers);
    return data.data.data;
  } catch (err) {
    console.error(`Error creating material: ${err}`);
    mixpanelErrorTracker.trackError('server error - updateMaterial', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'updateMaterial',
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Material not created');
  }
}

export async function getAllMaterials() {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(`${APPLICATION_API_BASE_URL}/material/material`, headers);
    return data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - getAllMaterials', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getAllMaterials',
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Materials data not loaded');
  }
}

export async function getAllCategories(page = 1, limit = 20000) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/category?page=${page}&limit=${limit}`,
      headers
    );
    return data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - getAllCategories', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getAllCategories',
      page: page,
      limit: limit,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Categories data not loaded');
  }
}

export async function getAllBuilderCategories(id, page = 1, limit = 20000) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/category?builder_id=${id}&page=${page}&limit=${limit}`,
      headers
    );
    return data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - getAllBuilderCategories', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getAllBuilderCategories',
      id: id,
      page: page,
      limit: limit,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Categories data not loaded');
  }
}

export async function addCategory(payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.post(`${APPLICATION_API_BASE_URL}/category`, payload, headers);
    return data.data.data;
  } catch (err) {
    console.error(`Error adding category: ${err}`);
    mixpanelErrorTracker.trackError('server error - addCategory', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'addCategory',
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Category not added');
  }
}

export async function handleCheckCategoryDelete(id) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/category/checkDelete/${id}`,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error checking category: ${err}`);
    mixpanelErrorTracker.trackError('server error - handleCheckCategoryDelete', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'handleCheckCategoryDelete',
      id: id,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Error checking category');
  }
}

export async function deleteCategory(payload) {
  try {
    const headers = await getHeaders(); // contains { headers: { Authorization: '...' } }

    const response = await axiosInstance.delete(`${APPLICATION_API_BASE_URL}/category/delete`, {
      ...headers,
      data: payload
    });

    return response.data.data;
  } catch (err) {
    console.error('Error deleting category:', err?.response || err);
    mixpanelErrorTracker.trackError('server error - deleteCategory', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'deleteCategory',
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Error deleting category');
  }
}

export async function addBrand(payload) {
  console.log({ payload });

  try {
    const headers = await getHeaders();
    const data = await axiosInstance.post(`${APPLICATION_API_BASE_URL}/brand`, payload, headers);
    return data.data.data;
  } catch (err) {
    console.error(`Error adding brand: ${err}`);
    mixpanelErrorTracker.trackError('server error - addBrand', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'addBrand',
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Brand not added');
  }
}

export async function getBrandsByCategory(categoryId) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/brand?category_id=${categoryId}`,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - getBrandsByCategory', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getBrandsByCategory',
      categoryId: categoryId,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Brands data not loaded');
  }
}

/// Payment Stages API
export async function createPaymentStages(blockId, payload) {
  // Handle bulk payment stages
  if (payload.block_ids) {
    try {
      const headers = await getHeaders();
      const data = await axiosInstance.post(
        `${APPLICATION_API_BASE_URL}/payment`,
        payload,
        headers
      );
      return data.data.data;
    } catch (err) {
      console.error(`Error creating bulk payment stages: ${err}`);
      mixpanelErrorTracker.trackError('server error - createPaymentStages', {
        error_message: err?.response?.data?.message || err?.message || 'Unknown error',
        function_name: 'createPaymentStages',
        blockId: blockId,
        payload: payload,
        http_status: err?.response?.status || 'N/A'
      });
      throw err; // throw new Error('Bulk Payment Stages not created');
    }
  }

  // Handle single block payment stages
  let newArr = [];
  for (let i = 0; i < payload.payment.length; i++) {
    const percentage = parseInt(payload.payment[i].percentage);
    if (!isNaN(percentage)) {
      newArr.push({
        name: payload.payment[i].name,
        percentage: percentage,
        unitwise: payload.payment[i].unitwise || false
      });
    }
  }
  let newpayload = {
    block_id: blockId,
    stages: newArr
  };

  try {
    const headers = await getHeaders();
    const data = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/payment`,
      newpayload,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error creating payment stages: ${err}`);
    mixpanelErrorTracker.trackError('server error - createPaymentStages', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'createPaymentStages',
      blockId: blockId,
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Payment Stage not created');
  }
}

export async function createIndependentPaymentStages(blockId, payload) {
  // Handle bulk payment stages
  if (payload.unit_ids) {
    try {
      const headers = await getHeaders();
      const data = await axiosInstance.post(
        `${APPLICATION_API_BASE_URL}/payment/independent`,
        payload,
        headers
      );
      return data.data.data;
    } catch (err) {
      console.error(`Error creating bulk independent payment stages: ${err}`);
      mixpanelErrorTracker.trackError('server error - createIndependentPaymentStages', {
        error_message: err?.response?.data?.message || err?.message || 'Unknown error',
        function_name: 'createIndependentPaymentStages',
        blockId: blockId,
        payload: payload,
        http_status: err?.response?.status || 'N/A'
      });
      throw err; // throw new Error('Bulk Independent Payment Stages not created');
    }
  }

  // Handle single block payment stages
  let newArr = [];
  for (let i = 0; i < payload.payment.length; i++) {
    const percentage = parseInt(payload.payment[i].percentage);
    if (!isNaN(percentage)) {
      newArr.push({
        name: payload.payment[i].name,
        percentage: percentage,
        unitwise: payload.payment[i].unitwise || false
      });
    }
  }
  let newpayload = {
    ...(payload.unit_id ? { unit_id: payload.unit_id } : { block_id: blockId }),
    stages: newArr
  };

  try {
    const headers = await getHeaders();
    const data = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/payment/independent`,
      newpayload,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error creating independent payment stages: ${err}`);
    mixpanelErrorTracker.trackError('server error - createIndependentPaymentStages', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'createIndependentPaymentStages',
      blockId: blockId,
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Independent Payment Stage not created');
  }
}

export async function createPaymentStagesBulk(blockId, payload) {
  // Handle bulk payment stages
  if (payload.block_ids) {
    try {
      const headers = await getHeaders();
      const data = await axiosInstance.post(
        `${APPLICATION_API_BASE_URL}/payment/bulk`,
        payload,
        headers
      );
      return data.data.data;
    } catch (err) {
      console.error(`Error creating bulk payment stages: ${err}`);
      mixpanelErrorTracker.trackError('server error - createPaymentStagesBulk', {
        error_message: err?.response?.data?.message || err?.message || 'Unknown error',
        function_name: 'createPaymentStagesBulk',
        blockId: blockId,
        payload: payload,
        http_status: err?.response?.status || 'N/A'
      });
      throw err; // throw new Error('Bulk Payment Stages not created');
    }
  }

  // Handle single block payment stages
  let newArr = [];
  for (let i = 0; i < payload.payment.length; i++) {
    const percentage = parseInt(payload.payment[i].percentage);
    if (!isNaN(percentage)) {
      newArr.push({
        name: payload.payment[i].name,
        percentage: percentage,
        unitwise: payload.payment[i].unitwise || false
      });
    }
  }
  let newpayload = {
    block_id: blockId,
    stages: newArr
  };

  try {
    const headers = await getHeaders();
    const data = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/payment`,
      newpayload,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error creating payment stages: ${err}`);
    mixpanelErrorTracker.trackError('server error - createPaymentStagesBulk', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'createPaymentStagesBulk',
      blockId: blockId,
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Payment Stage not created');
  }
}

export async function getPaymentStages(id) {
  if (id == null) {
    return;
  }

  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/payment?block_id=${id}&limit=10000`,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error fetching payment stages: ${err}`);
    mixpanelErrorTracker.trackError('server error - getPaymentStages', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getPaymentStages',
      id: id,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Payment Stages not fetched');
  }
}

export async function getIndependentPaymentStages(id) {
  if (id == null) {
    return;
  }

  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/payment/independent?unit_id=${id}&limit=10000`,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error fetching independent payment stages: ${err}`);
    mixpanelErrorTracker.trackError('server error - getIndependentPaymentStages', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getIndependentPaymentStages',
      id: id,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Independent Payment Stages not fetched');
  }
}

export async function getByIdPaymentStages(id) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(`${APPLICATION_API_BASE_URL}/payment/${id}`, headers);
    return data.data.data;
  } catch (err) {
    console.error(`Error fetching payment stage: ${err}`);
    mixpanelErrorTracker.trackError('server error - getByIdPaymentStages', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getByIdPaymentStages',
      id: id,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Payment Stage not fetched');
  }
}

export async function updatePaymentStages(payload, id) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.put(
      `${APPLICATION_API_BASE_URL}/payment/${id}`,
      payload,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error updating payment stage: ${err}`);
    mixpanelErrorTracker.trackError('server error - updatePaymentStages', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'updatePaymentStages',
      id: id,
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Payment Stage not updated');
  }
}

export async function updateIndependentPaymentStages(payload, id) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.put(
      `${APPLICATION_API_BASE_URL}/payment/independent/${id}`,
      payload,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error updating independent payment stage: ${err}`);
    mixpanelErrorTracker.trackError('server error - updateIndependentPaymentStages', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'updateIndependentPaymentStages',
      id: id,
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Independent Payment Stage not updated');
  }
}

export async function updateUnitPaymentStage(payload, id) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.put(
      `${APPLICATION_API_BASE_URL}/payment/updateUnitMapping/${id}`,
      payload,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error updating unit payment stage: ${err}`);
    mixpanelErrorTracker.trackError('server error - updateUnitPaymentStage', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'updateUnitPaymentStage',
      id: id,
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Unit Payment Stage not updated');
  }
}

export async function handleCheckPaymentStageDelete(id) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/payment/checkDelete/${id}`,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error checking deletePaymentStages to delete: ${err}`);
    mixpanelErrorTracker.trackError('server error - handleCheckPaymentStageDelete', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'handleCheckPaymentStageDelete',
      id: id,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Error checking deletePaymentStages to delete');
  }
}

export async function handleCheckIndepdendentPaymentStageDelete(id) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/payment/checkDeleteIndependent/${id}`,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error checking deletePaymentStages to delete: ${err}`);
    mixpanelErrorTracker.trackError('server error - handleCheckPaymentStageDelete', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'handleCheckPaymentStageDelete',
      id: id,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Error checking deletePaymentStages to delete');
  }
}

export async function deletePaymentStages(payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.delete(`${APPLICATION_API_BASE_URL}/payment/delete/`, {
      ...headers,
      data: payload
    });

    return data.data.data;
  } catch (err) {
    console.error(`Error deleting deletePaymentStages: ${err}`);
    mixpanelErrorTracker.trackError('server error - deletePaymentStages', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'deletePaymentStages',
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Error deleting deletePaymentStages');
  }
}

export async function deleteIndependentPaymentStages(payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.delete(
      `${APPLICATION_API_BASE_URL}/payment/deleteIndependent`,
      {
        ...headers,
        data: payload
      }
    );

    return data.data.data;
  } catch (err) {
    console.error(`Error deleting deleteIndependentPaymentStages: ${err}`);
    mixpanelErrorTracker.trackError('server error - deleteIndependentPaymentStages', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'deleteIndependentPaymentStages',
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Error deleting deleteIndependentPaymentStages');
  }
}

// Requirement API's

export async function getRequirements(page = 1, limit = 200, activeTab) {
  let url = `${APPLICATION_API_BASE_URL}/requirement?approved=true&page=${page}&limit=${limit}`;
  if (activeTab === 'emergency') {
    url += `&type=emergency`;
  } else {
    url += `&type=normal`;
  }

  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(url, headers); // Using APPLICATION_API_BASE_URL constant
    const res = data.data;
    return res;
  } catch (err) {
    console.error(`Error Get in Requiremnt : ${err}`);
    mixpanelErrorTracker.trackError('server error - getRequirements', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getRequirements',
      page: page,
      limit: limit,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Error Get in Requiremnt');
  }
}

export async function handleCheckRequirementDelete(id) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/requirement/checkDelete/${id}`,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error checking requirement: ${err}`);
    mixpanelErrorTracker.trackError('server error - handleCheckRequirementDelete', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'handleCheckRequirementDelete',
      id: id,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Error checking requirement');
  }
}

export async function deleteRequirement(payload) {
  try {
    const headers = await getHeaders(); // contains { headers: { Authorization: '...' } }

    const response = await axiosInstance.delete(`${APPLICATION_API_BASE_URL}/requirement/delete`, {
      ...headers,
      data: payload
    });

    return response.data.data;
  } catch (err) {
    console.error('Error deleting requirement:', err?.response || err);
    mixpanelErrorTracker.trackError('server error - deleteRequirement', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'deleteRequirement',
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Error deleting requirement');
  }
}

export async function getByIdRequirements(id) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/requirement/${id}?approved=true`,
      headers
    ); // Using APPLICATION_API_BASE_URL constant
    const res = data.data.data;
    return res;
  } catch (err) {
    console.error(`Error Get in Requiremnt : ${err}`);
    mixpanelErrorTracker.trackError('server error - getByIdRequirements', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getByIdRequirements',
      id: id,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Error in Get in requirement BY Id');
  }
}

export async function editrequirementQuantity(payload, id) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.put(
      `${APPLICATION_API_BASE_URL}/requirmentmapping/${id}`,
      payload,
      headers
    ); // Using APPLICATION_API_BASE_URL constant
    const res = data.data.data;
    return res;
  } catch (err) {
    console.error(`Error Update in Requiremnt: ${err}`);
    mixpanelErrorTracker.trackError('server error - editrequirementQuantity', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'editrequirementQuantity',
      id: id,
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Error Update in Requiremnt');
  }
}

export async function updateStatusRequirement(payload, id) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.put(
      `${APPLICATION_API_BASE_URL}/requirement/${id}`,
      payload,
      headers
    ); // Using APPLICATION_API_BASE_URL constant
    const res = data.data.data;
    return res;
  } catch (err) {
    console.error(`Error Update in Requiremnt: ${err}`);
    mixpanelErrorTracker.trackError('server error - updateStatusRequirement', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'updateStatusRequirement',
      id: id,
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Error Update in Requiremnt');
  }
}

// Close Deals

export async function createClosedDeal(payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/closeddeal`,
      payload,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error creating closed deal: ${err}`);
    mixpanelErrorTracker.trackError('server error - createClosedDeal', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'createClosedDeal',
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export async function getCloseDeals(
  id,
  page = 1,
  limit = 200,
  searchQuery,
  blockID,
  sortDirection = '',
  dueAmountSort = '',
  status = ''
) {
  try {
    const headers = await getHeaders();

    let url = `${APPLICATION_API_BASE_URL}/closeddeal?`;

    if (id) {
      url += `project_id=${id}&`;
    }

    url += `page=${page}&limit=${limit}`;
    console.log('blockID', blockID);
    if (searchQuery) {
      url += `&search=${searchQuery}`;
    }

    if (blockID) {
      url += `&blockId=${blockID}`;
    }

    if (sortDirection) {
      url += `&pendingPercentSort=${sortDirection}`;
    }

    if (dueAmountSort) {
      url += `&dueAmountSort=${dueAmountSort}`;
    }

    // Filter by deal status on the server so pagination/totals stay correct
    // (e.g. Invoices list should only page over Approved deals).
    if (status && status !== 'All') {
      url += `&status=${encodeURIComponent(status)}`;
    }

    const data = await axiosInstance.get(url, headers);
    return data.data;
  } catch (err) {
    console.error(`Error Get in Closed Deals : ${err}`);
    mixpanelErrorTracker.trackError('server error - getCloseDeals', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getCloseDeals',
      id: id,
      page: page,
      limit: limit,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Error Get in Closed Deals');
  }
}
export async function getCloseDealsByFilters(id, page = 1, limit = 200, searchQuery, filters = '') {
  try {
    const headers = await getHeaders();

    let url = `${APPLICATION_API_BASE_URL}/closeddeal?`;

    if (id) {
      url += `project_id=${id}&`;
    }

    url += `page=${page}&limit=${limit}`;
    if (searchQuery) {
      url += `&search=${searchQuery}`;
    }

    if (filters && filters !== 'All') {
      url += `&status=${filters}`;
    }

    const data = await axiosInstance.get(url, headers);
    return data.data;
  } catch (err) {
    console.error(`Error Get in Closed Deals : ${err}`);
    mixpanelErrorTracker.trackError('server error - getCloseDeals', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getCloseDeals',
      id: id,
      page: page,
      limit: limit,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Error Get in Closed Deals');
  }
}

export async function cancelCloseDeal(body) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.post(`${APPLICATION_API_BASE_URL}/activity?`, body, headers);
    return data.data;
  } catch (err) {
    console.error(`Error cancelling Closed Deal : ${err}`);
    mixpanelErrorTracker.trackError('server error - cancelCloseDeal', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'cancelCloseDeal',
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Error Get in Closed Deals');
  }
}

export async function handleCheckClosedDealsDelete(id) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/closeddeal/checkDelete/${id}`,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error checking closed deals: ${err}`);
    mixpanelErrorTracker.trackError('server error - handleCheckClosedDealsDelete', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'handleCheckClosedDealsDelete',
      id: id,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Error checking closed deals');
  }
}

export async function deleteClosedDeals(payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.delete(`${APPLICATION_API_BASE_URL}/closeddeal/delete`, {
      ...headers,
      data: payload
    });
    return data.data.data;
  } catch (err) {
    console.error(`Error deleting closed deals: ${err}`);
    mixpanelErrorTracker.trackError('server error - deleteClosedDeals', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'deleteClosedDeals',
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

// get closed deals by project id
export async function getClosedDealsByProjectId(projectId) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/closeddeal?project_id=${projectId}&limit=500`,
      headers
    );
    return data.data;
  } catch (err) {
    console.error(`Error loading closed deals by project id: ${err}`);
    mixpanelErrorTracker.trackError('server error - getClosedDealsByProjectId', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getClosedDealsByProjectId',
      project_id: projectId,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function updateDealTransaction(id, payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.put(
      `${APPLICATION_API_BASE_URL}/closeddeal/update/dealTransaction/${id}`,
      payload,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error updating deal transaction: ${err}`);
    mixpanelErrorTracker.trackError('server error - updateDealTransaction', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'updateDealTransaction',
      id: id,
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}


export async function getCloseDealsById(id) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(`${APPLICATION_API_BASE_URL}/closeddeal/${id}`, headers); // Using APPLICATION_API_BASE_URL constant
    const res = data.data.data;
    return res;
  } catch (err) {
    console.error(`Error Get in Closed Deals : ${err}`);
    mixpanelErrorTracker.trackError('server error - getCloseDealsById', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getCloseDealsById',
      id: id,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Error Get in Closed Deals');
  }
}

/** Fetch closed deal(s) for a lead — includes Pending (pre–management approval). */
export async function getCloseDealsByLeadId(leadId) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/closeddeal?lead_id=${leadId}&limit=5`,
      headers
    );
    return data.data;
  } catch (err) {
    console.error(`Error Get Closed Deal by lead: ${err}`);
    mixpanelErrorTracker.trackError('server error - getCloseDealsByLeadId', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getCloseDealsByLeadId',
      leadId,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

//writw thw api call for getConsolidatedUnitList
export async function getConsolidatedUnitList(
  projectId = null,
  statusId = null,
  page = 1,
  limit = 500
) {
  try {
    const headers = await getHeaders();
    let url = `${APPLICATION_API_BASE_URL}/closeddeal/orderlist?page=${page}&limit=${limit}`;

    // Add filter parameters if provided
    if (projectId) {
      url += `&project_id=${projectId}`;
    }
    if (statusId) {
      url += `&status=${statusId}`;
    }

    const data = await axiosInstance.get(url, headers);
    const rows = data.data?.data ?? [];
    const meta = data.data?.meta ?? {};
    warnIfListTruncated('getConsolidatedUnitList', rows, meta, { page, limit });
    // Preserve meta so UI can page / show "X of Y" (Leads-style)
    return { data: rows, meta };
  } catch (err) {
    console.error(`Error Get in Closed Deals : ${err}`);
    mixpanelErrorTracker.trackError('server error - getConsolidatedUnitList', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getConsolidatedUnitList',
      page: page,
      limit: limit,
      projectId: projectId,
      statusId: statusId,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Error Get in Closed Deals');
  }
}

// Request Quatation api

export async function requestQuatation(payload) {
  console.log({ payload });

  try {
    const headers = await getHeaders();
    const data = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/quotationrequest`,
      payload,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`quotationrequest adding brand: ${err}`);
    mixpanelErrorTracker.trackError('server error - requestQuatation', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'requestQuatation',
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('quotationrequest not added');
  }
}

export async function getQuatationByRequirement(id) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/quotation?requirement_id=${id}&limit=100`,
      headers
    ); // Using APPLICATION_API_BASE_URL constant
    const res = data.data.data;
    return res;
  } catch (err) {
    console.error(`Error Get in Quatation  : ${err}`);
    mixpanelErrorTracker.trackError('server error - getQuatationByRequirement', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getQuatationByRequirement',
      id: id,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Error Quatation get');
  }
}

export async function handleCheckQuotationDelete(id) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/quotation/checkDelete/${id}`,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error checking quotation: ${err}`);
    mixpanelErrorTracker.trackError('server error - handleCheckQuotationDelete', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'handleCheckQuotationDelete',
      id: id,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Error checking quotation');
  }
}

export async function deleteQuotation(payload) {
  try {
    const headers = await getHeaders(); // contains { headers: { Authorization: '...' } }

    const response = await axiosInstance.delete(`${APPLICATION_API_BASE_URL}/quotation/delete`, {
      ...headers,
      data: payload
    });

    return response.data.data;
  } catch (err) {
    console.error('Error deleting quotation:', err?.response || err);
    mixpanelErrorTracker.trackError('server error - deleteQuotation', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'deleteQuotation',
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Error deleting quotation');
  }
}

// Orders API

export async function getOrders(page = 1, limit = 20000, projectID) {
  try {
    const headers = await getHeaders();
    let url = `${APPLICATION_API_BASE_URL}/orders?page=${page}&limit=${limit}`;
    if (projectID) {
      url += `&project_id=${projectID}`;
    }
    const data = await axiosInstance.get(url, headers); // Using APPLICATION_API_BASE_URL constant
    const res = data.data;
    return res;
  } catch (err) {
    console.error(`Error Get in Orders  : ${err}`);
    mixpanelErrorTracker.trackError('server error - getOrders', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getOrders',
      page: page,
      limit: limit,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Error Orders get');
  }
}

export async function getOrderByOrderId(id) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(`${APPLICATION_API_BASE_URL}/orders/${id}`, headers);
    return data.data.data;
  } catch (err) {
    console.error(`Error Get in Orders  : ${err}`);
    mixpanelErrorTracker.trackError('server error - getOrderByOrderId', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getOrderByOrderId',
      id: id,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Error Orders get');
  }
}

// Assuming getHeaders and APPLICATION_API_BASE_URL are defined elsewhere
export async function updateOrdersStatus(id, payload) {
  const headers = await getHeaders();
  const response = await axiosInstance.put(
    `${APPLICATION_API_BASE_URL}/orders/${id}`,
    payload,
    headers
  ); // Using APPLICATION_API_BASE_URL constant
  const res = response.data.data;
  return res;
}

//write api for downloaidng invoice for order
export async function downloadInvoiceForOrder(id) {
  try {
    const headers = await getFileHeaders();
    console.log(headers);
    const response = await axiosInstance.get(`${APPLICATION_API_BASE_URL}/orders/invoice/${id}`, {
      ...headers,
      responseType: 'arraybuffer'
    });
    console.log(response, 'response');
    return response.data;
  } catch (err) {
    console.error(`Error Getting invoice: ${err}`);
    mixpanelErrorTracker.trackError('server error - downloadInvoiceForOrder', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'downloadInvoiceForOrder',
      id: id,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Error fetching invoice');
  }
}

//write api for downloaidng bill for order
export async function downloadBillForOrder(id) {
  try {
    const headers = await getFileHeaders();
    console.log(headers);
    const response = await axiosInstance.get(`${APPLICATION_API_BASE_URL}/orders/bill/${id}`, {
      ...headers,
      responseType: 'arraybuffer'
    });
    console.log(response, 'response');
    return response.data;
  } catch (err) {
    console.error(`Error Getting bill: ${err}`);
    mixpanelErrorTracker.trackError('server error - downloadBillForOrder', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'downloadBillForOrder',
      id: id,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Error fetching bill');
  }
}

// Allotment Letter
export async function getallotmentLetter(id) {
  try {
    const headers = await getFileHeaders();
    console.log(headers);
    const response = await axiosInstance.get(`${DOCGENERATION_API_BASE_URL}/allotment/${id}`, {
      ...headers,
      responseType: 'arraybuffer'
    });
    console.log(response, 'response');
    return response.data;
  } catch (err) {
    console.error(`Error Getting Allotment Letter: ${err}`);
    mixpanelErrorTracker.trackError('server error - getallotmentLetter', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getallotmentLetter',
      id: id,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Error fetching allotment letter');
  }
}

export async function uploadAllotmentLetter(id, payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.post(
      `${DOCGENERATION_API_BASE_URL}/allotment/${id}`,
      payload,
      headers
    ); // Using API_BASE_URL constant
    const res = data.data.data;
    return res;
  } catch (err) {
    console.error(`Error Post Allotment  : ${err}`);
    mixpanelErrorTracker.trackError('server error - uploadAllotmentLetter', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'uploadAllotmentLetter',
      id: id,
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Error Post Allotment');
  }
}

// Download signed allotment letter
export async function downloadAllotment(id) {
  try {
    const headers = await getFileHeaders();
    console.log(headers);
    const response = await axiosInstance.get(
      `${DOCGENERATION_API_BASE_URL}/allotment/signedcopy/${id}`,
      {
        ...headers,
        responseType: 'arraybuffer'
      }
    );
    console.log(response, 'response');
    return response.data;
  } catch (err) {
    console.error(`Error Getting Allotment Letter: ${err}`);
    mixpanelErrorTracker.trackError('server error - downloadAllotment', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'downloadAllotment',
      id: id,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Error fetching allotment letter');
  }
}

//agreement letter
export async function getAgreementLetter(id) {
  try {
    const headers = await getFileHeaders();
    console.log(headers);
    const response = await axiosInstance.get(`${DOCGENERATION_API_BASE_URL}/agreement/${id}`, {
      ...headers,
      responseType: 'arraybuffer'
    });
    console.log(response, 'response');
    return response.data;
  } catch (err) {
    console.error(`Error Getting agreement Letter: ${err}`);
    mixpanelErrorTracker.trackError('server error - getAgreementLetter', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getAgreementLetter',
      id: id,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Error fetching agreement letter');
  }
}

// upload Agreement letter

export async function uploadAgreementLetter(id, payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.post(
      `${DOCGENERATION_API_BASE_URL}/agreement/${id}`,
      payload,
      headers
    ); // Using API_BASE_URL constant
    const res = data.data.data;
    return res;
  } catch (err) {
    console.error(`Error Post Allotment  : ${err}`);
    mixpanelErrorTracker.trackError('server error - uploadAgreementLetter', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'uploadAgreementLetter',
      id: id,
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Error Post Allotment');
  }
}

// Signed download Agreement Letter

export async function downloadAgreement(id) {
  try {
    const headers = await getFileHeaders();
    console.log(headers);
    const response = await axiosInstance.get(
      `${DOCGENERATION_API_BASE_URL}/agreement/signedcopy/${id}`,
      {
        ...headers,
        responseType: 'arraybuffer'
      }
    );
    console.log(response, 'response');
    return response.data;
  } catch (err) {
    console.error(`Error Getting agreement Letter: ${err}`);
    mixpanelErrorTracker.trackError('server error - downloadAgreement', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'downloadAgreement',
      id: id,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Error fetching agreement letter');
  }
}

//get Performa Invoice by id
export async function getPerformaInvoiceById(id) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(`${DOCGENERATION_API_BASE_URL}/pi/${id}`, headers);
    return data.data.data;
  } catch (err) {
    console.error(`Error Getting Performa Invoice: ${err}`);
    mixpanelErrorTracker.trackError('server error - getPerformaInvoiceById', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getPerformaInvoiceById',
      id: id,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Error fetching Performa Invoice');
  }
}

//write api for download invoice
export async function downloadInvoice(id) {
  try {
    const headers = await getFileHeaders();
    console.log(headers);
    const response = await axiosInstance.get(
      `${DOCGENERATION_API_BASE_URL}/invoices/invoice/${id}?source=Advance`,
      {
        ...headers,
        responseType: 'arraybuffer'
      }
    );
    console.log(response, 'response');
    return response.data;
  } catch (err) {
    console.error(`Error Getting invoice: ${err}`);
    mixpanelErrorTracker.trackError('server error - downloadInvoice', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'downloadInvoice',
      id: id,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Error fetching invoice');
  }
}
export async function downloadInvoiceForPaymentStages(id, sourceName) {
  console.log(id, sourceName);
  try {
    const headers = await getFileHeaders();
    console.log(headers);
    const response = await axiosInstance.get(
      `${DOCGENERATION_API_BASE_URL}/invoices/invoice/${id}?source=${sourceName}&limit=500`,
      {
        ...headers,
        responseType: 'arraybuffer'
      }
    );
    return response.data;
  } catch (err) {
    console.error(`Error Getting invoice: ${err}`);
    mixpanelErrorTracker.trackError('server error - downloadInvoiceForPaymentStages', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'downloadInvoiceForPaymentStages',
      id: id,
      sourceName: sourceName,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Error fetching invoice');
  }
}

// Invoices API's

export async function getInvoicesList(
  page = 1,
  limit = 200,
  sortDirection = 'none',
  blockID = null,
  projectID = null
) {
  try {
    const headers = await getHeaders();
    let sortDirectionQuery = `?page=${page}&limit=${limit}`;
    if (sortDirection === 'asc') {
      sortDirectionQuery += `&sort=${sortDirection}`;
    } else if (sortDirection === 'desc') {
      sortDirectionQuery += `&sort=${sortDirection}`;
    }
    if (projectID) {
      sortDirectionQuery += `&projectId=${projectID}`;
    }

    if (blockID) {
      sortDirectionQuery += `&blockId=${blockID}`;
    }

    const data = await axiosInstance.get(
      `${DOCGENERATION_API_BASE_URL}/invoices${sortDirectionQuery}`,
      headers
    ); // Using API_BASE_URL constant
    const res = data.data;
    return res;
  } catch (err) {
    console.error(`Error Get in Invoices  : ${err}`);
    mixpanelErrorTracker.trackError('server error - getInvoicesList', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getInvoicesList',
      page: page,
      limit: limit,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Error Invoice get');
  }
}

export async function getInvoiceByDealId(
  dealId = null,
  page = 1,
  limit = 200,
  sortDirection = 'none'
) {
  try {
    const headers = await getHeaders();
    let sortDirectionQuery = `&page=${page}&limit=${limit}`;
    if (sortDirection === 'asc') {
      sortDirectionQuery += `&dueAmountSort=${sortDirection}`;
    } else if (sortDirection === 'desc') {
      sortDirectionQuery += `&dueAmountSort=${sortDirection}`;
    }
    const data = await axiosInstance.get(
      `${DOCGENERATION_API_BASE_URL}/invoices?deal_id=${dealId}${sortDirectionQuery}`,
      headers
    ); // Using API_BASE_URL constant
    const res = data.data;
    return res;
  } catch (err) {
    console.error(`Error Get in Invoices  : ${err}`);
    mixpanelErrorTracker.trackError('server error - getInvoiceByDealId', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getInvoiceByDealId',
      page: page,
      limit: limit,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Error Invoice get');
  }
}

export async function handleCheckInvoiceDelete(id) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/invoices/checkDelete/${id}`,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error checking invoice: ${err}`);
    mixpanelErrorTracker.trackError('server error - handleCheckInvoiceDelete', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'handleCheckInvoiceDelete',
      id: id,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Error checking invoice');
  }
}

export async function deleteInvoice(payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.delete(`${APPLICATION_API_BASE_URL}/invoices/delete`, {
      ...headers,
      data: payload
    });
    return data.data.data;
  } catch (err) {
    console.error(`Error deleting invoice: ${err}`);
    mixpanelErrorTracker.trackError('server error - deleteInvoice', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'deleteInvoice',
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export async function updateInvoiceStatus(id, payload) {
  console.log({ payload });

  try {
    const headers = await getHeaders();
    const data = await axiosInstance.put(
      `${DOCGENERATION_API_BASE_URL}/invoices/${id}`,
      payload,
      headers
    ); // Using API_BASE_URL constant
    const res = data.data.data;
    return res;
  } catch (err) {
    console.error(`Error Get in update Status invoice  : ${err}`);
    mixpanelErrorTracker.trackError('server error - updateInvoiceStatus', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'updateInvoiceStatus',
      id: id,
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Error update Status invoice get');
  }
}

export async function updateBulkInvoiceStatus(id, payload) {
  console.log({ payload });

  try {
    const headers = await getHeaders();
    const data = await axiosInstance.put(
      `${DOCGENERATION_API_BASE_URL}/invoices/bulk/${id}`,
      payload,
      headers
    ); // Using API_BASE_URL constant
    const res = data.data.data;
    return res;
  } catch (err) {
    console.error(`Error Get in update Status invoice  : ${err}`);
    mixpanelErrorTracker.trackError('server error - updateBulkInvoiceStatus', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'updateBulkInvoiceStatus',
      id: id,
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Error update Status invoice get');
  }
}

export async function getAllPaymentHistoryForDeals(id, page = 1, limit = 20000) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${DOCGENERATION_API_BASE_URL}/invoices/invoice/payment/history/get?deal_id=${id}&page=${page}&limit=${limit}`,
      headers
    ); // Using API_BASE_URL constant
    const res = data.data;
    return res;
  } catch (err) {
    console.error(`Error Get in Payment History  : ${err}`);
    mixpanelErrorTracker.trackError('server error - getAllPaymentHistoryForDeals', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getAllPaymentHistoryForDeals',
      page: page,
      limit: limit,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Error Payment History get');
  }
}

/** GET /invoices/payment/receipt/:id — payment receipt PDF */
export async function downloadPaymentReceipt(paymentHistoryId) {
  try {
    const headers = await getFileHeaders();
    const response = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/invoices/payment/receipt/${encodeURIComponent(paymentHistoryId)}`,
      {
        ...headers,
        responseType: 'arraybuffer'
      }
    );
    return response.data;
  } catch (err) {
    console.error(`Error downloading payment receipt: ${err}`);
    mixpanelErrorTracker.trackError('server error - downloadPaymentReceipt', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'downloadPaymentReceipt',
      payment_history_id: paymentHistoryId,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function deleteInvoicePayment(id) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.delete(
      `${APPLICATION_API_BASE_URL}/invoices/invoice/history/${id}`,
      {
        ...headers
      }
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error deleting payments: ${err}`);
    mixpanelErrorTracker.trackError('server error - deleteInvoicePayment', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'deleteInvoicePayment',
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // Properly throw the error for React Query to handle
  }
}

//late fee apis
export async function addLateFeeConfig(payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.post(`${APPLICATION_API_BASE_URL}/latefee`, payload, headers);
    return data.data.data;
  } catch (err) {
    console.error(`Error adding late fee config:${err}`);
    mixpanelErrorTracker.trackError('server error - addLateFeeConfig', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'addLateFeeConfig',
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Late fee config not added');
  }
}

export async function updateLateFeeConfig(id, payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.put(
      `${APPLICATION_API_BASE_URL}/latefee/${id}`,
      payload,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error adding late fee config:${err}`);
    mixpanelErrorTracker.trackError('server error - updateLateFeeConfig', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'updateLateFeeConfig',
      id: id,
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Late fee config not added');
  }
}

export async function getlatefeebyId(id) {
  // if (isNaN(id)) {
  //   return;
  // }
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/latefee?project_id=${id}&limit=10000`,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error adding late fee config: ${err}`);
    mixpanelErrorTracker.trackError('server error - getlatefeebyId', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getlatefeebyId',
      id: id,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Late fee config not getting');
  }
}

export async function getBuildingsByProjectId(id) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/building?project_id=${id}&limit=500`,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - getBuildingsByProjectId', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getBuildingsByProjectId',
      id: id,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Project data not loaded');
  }
}

//application api
export async function getAllApplication(payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/application?limit=500`,
      payload,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error adding application:${err}`);
    mixpanelErrorTracker.trackError('server error - getAllApplication', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getAllApplication',
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Application not added');
  }
}

//get application by deal id
export async function getApplicationByDealId(id) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/application?deal_id=${id}&limit=500`,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - getApplicationByDealId', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getApplicationByDealId',
      id: id,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Application data not loaded');
  }
}

//update application api
export async function updateApplication(id, payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.put(
      `${APPLICATION_API_BASE_URL}/application/${id}`,
      payload,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error updating application:${err}`);
    mixpanelErrorTracker.trackError('server error - updateApplication', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'updateApplication',
      id: id,
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Application not updated');
  }
}
// Live Feed APIs
//wrote api for get all posts
export async function getPosts(page = 1, limit = 50) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${LIVEFEED_API_BASE_URL}/post?page=${page}&limit=${limit}`,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - getPosts', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getPosts',
      page: page,
      limit: limit,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Posts data not loaded');
  }
}

//wrote api for get single post
export async function getPostById(id) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(`${LIVEFEED_API_BASE_URL}/post/${id}`, headers);
    return data.data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - getPostById', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getPostById',
      id: id,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Posts data not loaded');
  }
}
//wrioet api to create post
export async function createPost(payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.post(`${LIVEFEED_API_BASE_URL}/post/create`, payload, headers);
    return data.data.data;
  } catch (err) {
    console.error(`Error creating post: ${err}`);
    mixpanelErrorTracker.trackError('server error - createPost', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'createPost',
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Post not created');
  }
}

//wite api to edit post
export async function editPost(payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.post(`${LIVEFEED_API_BASE_URL}/post/update`, payload, headers);
    return data.data.data;
  } catch (err) {
    console.error(`Error updating post: ${err}`);
    mixpanelErrorTracker.trackError('server error - editPost', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'editPost',
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Post not updated');
  }
}

//write api to get allcomments based on post id
export async function getCommentsByPostId(id) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(`${LIVEFEED_API_BASE_URL}/comment/${id}`, headers);
    return data.data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - getCommentsByPostId', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getCommentsByPostId',
      id: id,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Comments data not loaded');
  }
}

//write api to create comment
export async function createComment(payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.post(
      `${LIVEFEED_API_BASE_URL}/comment/create`,
      payload,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error creating comment: ${err}`);
    mixpanelErrorTracker.trackError('server error - createComment', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'createComment',
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Comment not created');
  }
}

//write api to Create Reply
export async function createReply(payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.post(
      `${LIVEFEED_API_BASE_URL}/reply/create`,
      payload,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error creating reply: ${err}`);
    mixpanelErrorTracker.trackError('server error - createReply', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'createReply',
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Reply not created');
  }
}

//write api to Create Like
export async function createLike(payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.post(`${LIVEFEED_API_BASE_URL}/like`, payload, headers);
    return data.data.data;
  } catch (err) {
    console.error(`Error creating reply: ${err}`);
    mixpanelErrorTracker.trackError('server error - createLike', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'createLike',
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Reply not created');
  }
}

//write api to delete Like
export async function deleteLike(id) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.delete(`${LIVEFEED_API_BASE_URL}/like/${id}`, headers);
    return data.data.data;
  } catch (err) {
    console.error(`Error creating reply: ${err}`);
    mixpanelErrorTracker.trackError('server error - deleteLike', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'deleteLike',
      id: id,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Reply not created');
  }
}

export async function getUsersByChar(text) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/users/getusers?name=${text}`,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error fetching Users: ${err}`);
    mixpanelErrorTracker.trackError('server error - getUsersByChar', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getUsersByChar',
      text: text,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('users not fetched');
  }
}

//write api to get all replies based on comment id
export async function getRepliesByCommentId(id) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(`${LIVEFEED_API_BASE_URL}/reply/${id}`, headers);
    return data.data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - getRepliesByCommentId', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getRepliesByCommentId',
      id: id,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Replies data not loaded');
  }
}

// Reports API

export const getBuilderReport = async () => {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(`${APPLICATION_API_BASE_URL}/reports?limit=500`, {
      ...headers,
      responseType: 'arraybuffer'
    });
    console.log(data);

    return data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - getBuilderReport', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getBuilderReport',
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Application data not loaded');
  }
};

export const getReportSuperAdmin = async (builderId) => {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/reports?builderId=${builderId}&limit=500`,
      {
        ...headers,
        responseType: 'arraybuffer'
      }
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - getReportSuperAdmin', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getReportSuperAdmin',
      builderId: builderId,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Super-Admin Reports data not loaded');
  }
};

// Leads Reports

export const getReportLeads = async () => {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(`${APPLICATION_API_BASE_URL}/reports/leads?limit=500`, {
      ...headers,
      responseType: 'arraybuffer'
    });
    return data.data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - getReportLeads', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getReportLeads',
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Leads data not loaded');
  }
};

export const getReportSuperAdminLeads = async (builderId) => {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/reports/leads?builderId=${builderId}&limit=500`,
      {
        ...headers,
        responseType: 'arraybuffer'
      }
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - getReportSuperAdminLeads', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getReportSuperAdminLeads',
      builderId: builderId,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Reports Admin leads data not loaded');
  }
};

//write zoho api for post API
export async function addZohoIntegration(payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.post(`${APPLICATION_API_BASE_URL}/zoho`, payload, headers);
    return data.data.data;
  } catch (err) {
    console.error(`Error connecting: ${err}`);
    mixpanelErrorTracker.trackError('server error - addZohoIntegration', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'addZohoIntegration',
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Zoho not connected');
  }
}

//write api for get all zoho
export async function getZohoIntegration() {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(`${APPLICATION_API_BASE_URL}/zoho?limit=300`, headers);
    return data.data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - getZohoIntegration', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getZohoIntegration',
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Zoho data not loaded');
  }
}

export async function getZohoStatusByCompany(companyId) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/zoho/?company_id=${companyId}`,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error loading Zoho status: ${err}`);
    mixpanelErrorTracker.trackError('server error - getZohoStatusByCompany', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getZohoStatusByCompany',
      company_id: companyId,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export async function getZohoOAuthUrl(companyId) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/zoho/oauth/url?company_id=${companyId}`,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error getting Zoho OAuth URL: ${err}`);
    mixpanelErrorTracker.trackError('server error - getZohoOAuthUrl', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getZohoOAuthUrl',
      company_id: companyId,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export async function exchangeZohoOAuthToken(payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/zoho/oauth/token`,
      payload,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error exchanging Zoho OAuth token: ${err}`);
    mixpanelErrorTracker.trackError('server error - exchangeZohoOAuthToken', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'exchangeZohoOAuthToken',
      payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export async function getGoogleAdsConfigCheck() {
  try {
    const headers = await getHeaders();
    const { data } = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/googleAds/config/check`,
      headers
    );
    return data?.data ?? data;
  } catch (err) {
    console.error(`Error checking Google Ads config: ${err}`);
    throw err;
  }
}

export async function getGoogleAdsStatusByCompany(companyId) {
  try {
    const headers = await getHeaders();
    const { data } = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/googleAds/status?company_id=${companyId}`,
      headers
    );
    return data?.data;
  } catch (err) {
    console.error(`Error loading Google Ads status: ${err}`);
    throw err;
  }
}

export async function getGoogleAdsOAuthUrl(companyId, redirectUri) {
  try {
    const headers = await getHeaders();
    const params = new URLSearchParams({
      company_id: String(companyId)
    });
    if (redirectUri) {
      params.set('redirect_uri', redirectUri);
    }
    const { data } = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/googleAds/oauth/url?${params.toString()}`,
      headers
    );
    return data?.data;
  } catch (err) {
    console.error(`Error getting Google Ads OAuth URL: ${err}`);
    throw err;
  }
}

export async function exchangeGoogleAdsOAuthToken(payload) {
  try {
    const headers = await getHeaders();
    const { data } = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/googleAds/oauth/token`,
      payload,
      headers
    );
    return data?.data;
  } catch (err) {
    console.error(`Error exchanging Google Ads OAuth token: ${err}`);
    throw err;
  }
}

export async function getGoogleAdsAccounts(companyId) {
  try {
    const headers = await getHeaders();
    const { data } = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/googleAds/accounts/${companyId}`,
      headers
    );
    return data?.data;
  } catch (err) {
    console.error(`Error loading Google Ads accounts: ${err}`);
    throw err;
  }
}

export async function connectGoogleAdsAccount(payload) {
  try {
    const headers = await getHeaders();
    const { data } = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/googleAds/connect`,
      payload,
      headers
    );
    return data?.data;
  } catch (err) {
    console.error(`Error connecting Google Ads account: ${err}`);
    throw err;
  }
}

export async function disconnectGoogleAds(companyId) {
  try {
    const headers = await getHeaders();
    const { data } = await axiosInstance.delete(
      `${APPLICATION_API_BASE_URL}/googleAds/disconnect/${companyId}`,
      headers
    );
    return data?.data;
  } catch (err) {
    console.error(`Error disconnecting Google Ads: ${err}`);
    throw err;
  }
}

export async function syncGoogleAdsLeadSources(companyId) {
  try {
    const headers = await getHeaders();
    const { data } = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/googleAds/lead-sources/sync`,
      { company_id: companyId },
      headers
    );
    return data?.data;
  } catch (err) {
    console.error(`Error syncing Google Ads lead sources: ${err}`);
    throw err;
  }
}

export async function getGoogleAdsLeadSources(companyId, sourceType) {
  try {
    const headers = await getHeaders();
    const params = new URLSearchParams();
    if (sourceType) {
      params.set('source_type', sourceType);
    }
    const query = params.toString();
    const { data } = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/googleAds/lead-sources/${companyId}${query ? `?${query}` : ''}`,
      headers
    );
    return data?.data;
  } catch (err) {
    console.error(`Error loading Google Ads lead sources: ${err}`);
    throw err;
  }
}

export async function updateGoogleAdsLeadSource(id, body) {
  try {
    const headers = await getHeaders();
    const { data } = await axiosInstance.put(
      `${APPLICATION_API_BASE_URL}/googleAds/lead-sources/${id}`,
      body,
      headers
    );
    return data?.data;
  } catch (err) {
    console.error(`Error updating Google Ads lead source: ${err}`);
    throw err;
  }
}

export async function createWebsiteFormSource(payload) {
  try {
    const headers = await getHeaders();
    const { data } = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/websiteForms`,
      payload,
      headers
    );
    return data?.data;
  } catch (err) {
    console.error(`Error creating website form: ${err}`);
    throw err;
  }
}

export async function getWebsiteFormSources(companyId) {
  try {
    const headers = await getHeaders();
    const { data } = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/websiteForms/${companyId}`,
      headers
    );
    return data?.data;
  } catch (err) {
    console.error(`Error loading website forms: ${err}`);
    throw err;
  }
}

export async function updateWebsiteFormSource(id, body) {
  try {
    const headers = await getHeaders();
    const { data } = await axiosInstance.put(
      `${APPLICATION_API_BASE_URL}/websiteForms/${id}`,
      body,
      headers
    );
    return data?.data;
  } catch (err) {
    console.error(`Error updating website form: ${err}`);
    throw err;
  }
}

/**
 * Proxy to Zoho Books: customer unused credits receivable (GET /contacts/{id}).
 * Backend should return { unused_credits_receivable_amount } (or nest under contact).
 */
export async function getZohoBooksUnusedCreditsForContact(contactId) {
  try {
    const headers = await getHeaders();
    const { data } = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/zoho/books/contacts/${encodeURIComponent(contactId)}/unused-credits`,
      headers
    );
    return data?.data ?? data;
  } catch (err) {
    console.error(`Error loading Zoho unused credits: ${err}`);
    mixpanelErrorTracker.trackError('server error - getZohoBooksUnusedCreditsForContact', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getZohoBooksUnusedCreditsForContact',
      contact_id: contactId,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

/**
 * Proxy to Zoho Books POST /customerpayments — apply unused customer balance to invoice(s).
 * Body aligns with Zoho: customer_id, amount, payment_mode, date, invoices[{ invoice_id, amount_applied }], optional reference_number, description.
 */
export async function applyZohoBooksUnusedCredit(payload) {
  try {
    const headers = await getHeaders();
    const { data } = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/zoho/books/customer-payments/apply-unused-credit`,
      payload,
      headers
    );
    return data?.data ?? data;
  } catch (err) {
    console.error(`Error applying Zoho unused credit: ${err}`);
    mixpanelErrorTracker.trackError('server error - applyZohoBooksUnusedCredit', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'applyZohoBooksUnusedCredit',
      payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export async function getBuilderWhatsapp() {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(`${APPLICATION_API_BASE_URL}/builderWhatsapp`, headers);
    return data.data.data;
  } catch (err) {
    console.error(`Error loading builder WhatsApp: ${err}`);
    mixpanelErrorTracker.trackError('server error - getBuilderWhatsapp', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getBuilderWhatsapp',
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function getWhatsappChatMessages(userId, { size = 10, cursor } = {}) {
  try {
    const headers = await getHeaders();
    const params = { user_id: userId, size };
    if (cursor) params.cursor = cursor;
    const { data } = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/builderWhatsapp/chat-messages`,
      { ...headers, params }
    );
    return data?.data ?? { items: [], nextCursor: null };
  } catch (err) {
    console.error(`Error loading WhatsApp chat messages: ${err}`);
    mixpanelErrorTracker.trackError('server error - getWhatsappChatMessages', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getWhatsappChatMessages',
      user_id: userId,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

//wriet api for resend email invites
export async function resendEmailInvites(payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/auth/invite`,
      payload,
      headers
    );
    return data.data;
  } catch (err) {
    console.error(`Error connecting: ${err}`);
    mixpanelErrorTracker.trackError('server error - resendEmailInvites', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'resendEmailInvites',
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Email not connected');
  }
}

//write api call for buildreports/receivables-reports
export async function getReceivablesReports(page = 1, limit = 200, projectId = null) {
  try {
    const headers = await getHeaders();
    const projectQuery =
      projectId !== null && projectId !== undefined && String(projectId) !== ''
        ? `&project_id=${projectId}`
        : '';
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/buildreports/receivables-reports?page=${page}&limit=${limit}${projectQuery}`,
      headers
    );
    console.log(data.data, 'api call data');
    return data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - getReceivablesReports', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getReceivablesReports',
      page: page,
      limit: limit,
      project_id: projectId,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Receivables reports data not loaded');
  }
}

//write api call for /buildreports/inventory/Report
export async function getInventoryReports(page = 1, limit = 200) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/buildreports/inventory/Report?page=${page}&limit=${limit}`,
      headers
    );
    console.log(data.data, 'api call data');
    return data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - getInventoryReports', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getInventoryReports',
      page: page,
      limit: limit,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Inventory reports data not loaded');
  }
}

//write api call for /buildreports/inventory/Report/Details
export async function getInventoryReportDetails(page = 1, limit = 200) {
  try {
    const headers = await getHeaders();
    let url = `${APPLICATION_API_BASE_URL}/buildreports/inventory/Report/Details`;
    const data = await axiosInstance.get(url, headers);
    console.log(data.data, 'api call data');
    return data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - getInventoryReportDetails', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getInventoryReportDetails',
      page: page,
      limit: limit,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

//write api call for /buildreports/target-reports
export async function getTargetReports(page = 1, limit = 200, selectedMonth, selectedYear) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/buildreports/target-reports?month=${selectedMonth}&year=${selectedYear}&page=${page}&limit=${limit}`,
      headers
    );
    console.log(data.data, 'api call data');
    return data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - getTargetReports', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getTargetReports',
      page: page,
      limit: limit,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Target reports data not loaded');
  }
}

//write api call for /buildreports/revenue-reports
export async function getBlockWiseRevenueReports(page = 1, limit = 200) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/buildreports/revenue-reports?page=${page}&limit=${limit}`,
      headers
    );
    console.log(data.data, 'api call data');
    return data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - getBlockWiseRevenueReports', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getBlockWiseRevenueReports',
      page: page,
      limit: limit,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Revenue reports data not loaded');
  }
}

// write api call for /buildreports/unitwiserevenue-reports
export async function getUnitWiseRevenueReports(page = 1, limit = 200) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/buildreports/unitwiserevenue-reports?page=${page}&limit=${limit}`,
      headers
    );
    console.log(data.data, 'api call data');
    return data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - getUnitWiseRevenueReports', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getUnitWiseRevenueReports',
      page: page,
      limit: limit,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Unit wise revenue reports data not loaded');
  }
}

//accounts reort apis
//write api call for accountreports/project-expenditures
export async function getProjectExpendituresReports(page = 1, limit = 200) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/accountreports/project-expenditures?page=${page}&limit=${limit}`,
      headers
    );
    console.log(data.data, 'api call data');
    return data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - getProjectExpendituresReports', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getProjectExpendituresReports',
      page: page,
      limit: limit,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Project Expenditures reports data not loaded');
  }
}

//write api call for /accountReports/account-gst
export async function getAccountGstReports(page = 1, limit = 200) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/accountReports/account-gst?page=${page}&limit=${limit}`,
      headers
    );
    console.log(data.data, 'api call data');
    return data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - getAccountGstReports', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getAccountGstReports',
      page: page,
      limit: limit,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('GST Account reports data not loaded');
  }
}

//writw api call for accountreports/account-tds
export async function getAccountTdsReports(page = 1, limit = 200) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/accountReports/account-tds?page=${page}&limit=${limit}`,
      headers
    );
    console.log(data.data, 'api call data');
    return data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - getAccountTdsReports', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getAccountTdsReports',
      page: page,
      limit: limit,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('TDS Account reports data not loaded');
  }
}

export async function getAccountPaidBillsReports(page = 1, limit = 200) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/accountReports/account-paidbills?page=${page}&limit=${limit}`,
      headers
    );
    console.log(data.data, 'api call data');
    return data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - getAccountPaidBillsReports', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getAccountPaidBillsReports',
      page: page,
      limit: limit,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Paid Bills reports data not loaded');
  }
}

export async function getAccountPendingBillsReports(page = 1, limit = 200) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/accountReports/account-pending-bills?page=${page}&limit=${limit}`,
      headers
    );
    console.log(data.data, 'api call data');
    return data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - getAccountPendingBillsReports', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getAccountPendingBillsReports',
      page: page,
      limit: limit,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Pending Bills reports data not loaded');
  }
}

//get all management users
export async function getAllManagementUsers(page = 1, limit = 500) {
  try {
    const headers = await getHeaders();
    let url = `${USERMANAGEMENT_API_BASE_URL}/users?vertical=Management&page=${page}&limit=${limit}`;
    if (limit > 500) {
      url += `&export=1`;
    }
    const data = await axiosInstance.get(url, headers);
    return data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - getAllManagementUsers', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getAllManagementUsers',
      page: page,
      limit: limit,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

//get all sales user
export async function getAllSalesUsers(page = 1, limit = 500) {
  try {
    const headers = await getHeaders();
    let url = `${USERMANAGEMENT_API_BASE_URL}/users?vertical=Sales&page=${page}&limit=${limit}`;
    if (limit > 500) {
      url += `&export=1`;
    }
    const data = await axiosInstance.get(url, headers);
    const payload = data.data;
    warnIfListTruncated('getAllSalesUsers', payload?.data, payload?.meta, {
      page,
      limit
    });
    return payload;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - getAllSalesUsers', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getAllSalesUsers',
      page: page,
      limit: limit,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Sales data not loaded');
  }
}

// Sales users with vertical=Sales and manager levels for Sales Manager dropdown
export async function getSalesManagerUsers(
  page = 1,
  limit = 500,
  projectId = null,
  companyId = null
) {
  try {
    const headers = await getHeaders();
    let url = `${USERMANAGEMENT_API_BASE_URL}/users?vertical=Sales&level=Medium,High&page=${page}&limit=${limit}`;

    const normalizedProjectId = Number(projectId);
    if (normalizedProjectId && !Number.isNaN(normalizedProjectId)) {
      url += `&project_ids=${normalizedProjectId}`;
    }

    const normalizedCompanyId = Number(companyId);
    if (normalizedCompanyId && !Number.isNaN(normalizedCompanyId)) {
      url += `&company_ids=${normalizedCompanyId}`;
    }

    const data = await axiosInstance.get(url, headers);
    return data.data;
  } catch (err) {
    console.error(`Error loading sales manager users: ${err}`);
    mixpanelErrorTracker.trackError('server error - getSalesManagerUsers', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getSalesManagerUsers',
      page: page,
      limit: limit,
      projectId: projectId,
      companyId: companyId,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export function getSalesManagersForProject(salesManagers, projectId) {
  if (!Array.isArray(salesManagers) || projectId == null) {
    return [];
  }
  const targetProjectId = Number(projectId);
  return salesManagers.filter((user) =>
    (user.userProjectMapping ?? []).some(
      (mapping) => Number(mapping.project_id ?? mapping.project?.id) === targetProjectId
    )
  );
}

export async function getAllSalesUsersByProjectId(id, page = 1, limit = 500) {
  try {
    const headers = await getHeaders();
    let url = `${USERMANAGEMENT_API_BASE_URL}/users?vertical=Sales&project_ids=${id},&page=${page}&limit=${limit}`;
    if (limit > 500) {
      url += `&export=1`;
    }
    const data = await axiosInstance.get(url, headers);
    return data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - getAllSalesUsersByProjectId', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getAllSalesUsersByProjectId',
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Sales data not loaded');
  }
}

export async function getAllActiveSalesUsersByProjectId(id, page = 1, limit = 500) {
  try {
    const headers = await getHeaders();
    let url = `${USERMANAGEMENT_API_BASE_URL}/users?vertical=Sales&is_active=true&project_ids=${id},&page=${page}&limit=${limit}`;
    if (limit > 500) {
      url += `&export=1`;
    }
    const data = await axiosInstance.get(url, headers);
    return data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - getAllSalesUsersByProjectId', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getAllSalesUsersByProjectId',
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Sales data not loaded');
  }
}

export async function getAllSalesArsByProjectId(id, monthNumber) {
  try {
    const headers = await getHeaders();
    const monthStartDate = getFormattedMonthStart(monthNumber);
    const data = await axiosInstance.get(
      `${USERMANAGEMENT_API_BASE_URL}/targets/ar?project_id=${id}&month_date=${monthStartDate}`,
      headers
    );
    return data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - getAllSalesArsByProjectId', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getAllSalesArsByProjectId',
      id: id,
      monthNumber: monthNumber,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Sales data not loaded');
  }
}

export async function getFunnelStatsByProjectId(id) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${USERMANAGEMENT_API_BASE_URL}/targets/funnelStats?project_id=${id}`,
      headers
    );
    return data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - getFunnelStatsByProjectId', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getFunnelStatsByProjectId',
      id: id,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Sales data not loaded');
  }
}

export async function getManagementDashboardStats(projectID) {
  try {
    const headers = await getHeaders();
    const hasProjectFilter = projectID !== null && projectID !== undefined && String(projectID) !== '';
    const url = hasProjectFilter
      ? `${USERMANAGEMENT_API_BASE_URL}/management/dashboardStats?project_id=${projectID}`
      : `${USERMANAGEMENT_API_BASE_URL}/management/dashboardStats`;
    const data = await axiosInstance.get(url, headers);
    return data.data;
  } catch (err) {
    console.error(`Error loading management dashboard stats: ${err}`);
    mixpanelErrorTracker.trackError('server error - getManagementDashboardStats', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getManagementDashboardStats',
      projectID: projectID,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export async function getVerticalHealthOverview(projectId) {
  try {
    const headers = await getHeaders();
    const url = `${USERMANAGEMENT_API_BASE_URL}/management/verticalHealthOverview?project_id=${projectId}`;
    const data = await axiosInstance.get(url, headers);
    return data.data;
  } catch (err) {
    console.error(`Error loading vertical health overview: ${err}`);
    mixpanelErrorTracker.trackError('server error - getVerticalHealthOverview', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getVerticalHealthOverview',
      project_id: projectId,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export async function getTodaysSalesActivity(projectId, limit = 30) {
  try {
    const headers = await getHeaders();
    let url = `${USERMANAGEMENT_API_BASE_URL}/management/todaysSalesActivity?project_id=${projectId}`;
    if (limit) {
      url += `&limit=${limit}`;
    }
    const data = await axiosInstance.get(url, headers);
    return data.data;
  } catch (err) {
    console.error(`Error loading today's sales activity: ${err}`);
    mixpanelErrorTracker.trackError('server error - getTodaysSalesActivity', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getTodaysSalesActivity',
      project_id: projectId,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

/**
 * Today's sales activity across multiple projects.
 * Prefers `project_ids` (single request). Falls back to parallel `project_id`
 * calls when the API only accepts the singular param (older backends).
 */
export async function getTodaysSalesActivityForProjects(projectIds = [], limit = 30) {
  const ids = (projectIds || []).filter((id) => id !== undefined && id !== null && id !== '');
  if (ids.length === 0) {
    return { data: { date: null, activities: [], project_ids: [] } };
  }

  try {
    const headers = await getHeaders();
    let url = `${USERMANAGEMENT_API_BASE_URL}/management/todaysSalesActivity?project_ids=${ids.join(',')}`;
    if (limit) {
      url += `&limit=${limit}`;
    }
    const data = await axiosInstance.get(url, headers);
    return data.data;
  } catch (err) {
    const status = err?.response?.status;
    const message = err?.response?.data?.message || err?.message || '';
    const shouldFallback =
      status === 400 && /project_id is required/i.test(String(message));

    if (!shouldFallback) {
      console.error(`Error loading multi-project today's sales activity: ${err}`);
      mixpanelErrorTracker.trackError('server error - getTodaysSalesActivityForProjects', {
        error_message: message || 'Unknown error',
        function_name: 'getTodaysSalesActivityForProjects',
        project_ids: projectIds,
        http_status: status || 'N/A'
      });
      throw err;
    }

    // Older BE: fan out with project_id and merge client-side
    const results = await Promise.all(
      ids.map(async (projectId) => {
        try {
          return await getTodaysSalesActivity(projectId, limit);
        } catch (singleErr) {
          console.warn(
            `todaysSalesActivity failed for project_id=${projectId}:`,
            singleErr?.response?.data?.message || singleErr?.message
          );
          return null;
        }
      })
    );

    const byId = new Map();
    let date = null;
    results.forEach((response, index) => {
      const payload = response?.data ?? response ?? {};
      if (!date && payload.date) date = payload.date;
      const activities = Array.isArray(payload.activities) ? payload.activities : [];
      const projectId = Number(ids[index]);
      activities.forEach((activity) => {
        if (!activity?.id || byId.has(activity.id)) return;
        byId.set(activity.id, {
          ...activity,
          project_id: activity.project_id ?? projectId,
          project_name: activity.project_name
        });
      });
    });

    const activities = Array.from(byId.values()).sort(
      (a, b) => new Date(b.occurredAt || 0).getTime() - new Date(a.occurredAt || 0).getTime()
    );

    return {
      data: {
        date,
        syncedAt: new Date().toISOString(),
        project_ids: ids.map(Number).filter((n) => Number.isFinite(n)),
        activities
      }
    };
  }
}

export async function getSalesCycleLengthByProjectId(id) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${USERMANAGEMENT_API_BASE_URL}/targets/salescycle?project_id=${id}`,
      headers
    );
    return data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - getSalesCycleLengthByProjectId', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getSalesCycleLengthByProjectId',
      id: id,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Sales data not loaded');
  }
}

export async function getFollowUpsByProjectId(id, type, options = {}) {
  try {
    const headers = await getHeaders();
    const {
      page = 1,
      limit = 200,
      status = 'Active',
      sales_id,
      escalated,
      window: dateWindow
    } = options;
    let url = `${USERMANAGEMENT_API_BASE_URL}/followup?project_id=${id}&page=${page}&limit=${limit}`;
    if (type) {
      url += `&type=${type}`;
    }
    if (status) {
      url += `&status=${encodeURIComponent(status)}`;
    }
    if (sales_id) {
      url += `&sales_id=${sales_id}`;
    }
    if (escalated) {
      url += `&escalated=true`;
    }
    if (dateWindow) {
      url += `&window=${encodeURIComponent(dateWindow)}`;
    }
    const data = await axiosInstance.get(url, headers);
    return data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - getFollowUpsByProjectId', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getFollowUpsByProjectId',
      id: id,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Sales data not loaded');
  }
}

export async function getSalesDashboardShell(projectId) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${USERMANAGEMENT_API_BASE_URL}/salesDashboard?project_id=${projectId}`,
      headers
    );
    return data.data;
  } catch (err) {
    console.error(`Error loading sales dashboard shell: ${err}`);
    mixpanelErrorTracker.trackError('server error - getSalesDashboardShell', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getSalesDashboardShell',
      project_id: projectId,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

/** GET /salesDashboard/todaysActivity?project_id=&sales_user_id=&preset=&from=&to= */
export async function getSalesTodaysActivity(
  projectId,
  { salesUserId, preset, from, to } = {}
) {
  try {
    const headers = await getHeaders();
    let url = `${USERMANAGEMENT_API_BASE_URL}/salesDashboard/todaysActivity?project_id=${projectId}`;
    if (salesUserId != null && salesUserId !== '') {
      url += `&sales_user_id=${encodeURIComponent(salesUserId)}`;
    }
    if (preset != null && preset !== '') {
      url += `&preset=${encodeURIComponent(preset)}`;
    }
    if (from != null && from !== '') {
      url += `&from=${encodeURIComponent(from)}`;
    }
    if (to != null && to !== '') {
      url += `&to=${encodeURIComponent(to)}`;
    }
    const data = await axiosInstance.get(url, headers);
    return data.data?.data ?? data.data;
  } catch (err) {
    console.error(`Error loading sales today's activity: ${err}`);
    mixpanelErrorTracker.trackError('server error - getSalesTodaysActivity', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getSalesTodaysActivity',
      project_id: projectId,
      sales_user_id: salesUserId,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

/** GET /salesDashboard/activityMetrics?project_id=&sales_user_id=&preset=&from=&to= */
export async function getSalesActivityMetrics(
  projectId,
  { salesUserId, preset, from, to } = {}
) {
  try {
    const headers = await getHeaders();
    let url = `${USERMANAGEMENT_API_BASE_URL}/salesDashboard/activityMetrics?project_id=${projectId}`;
    if (salesUserId != null && salesUserId !== '') {
      url += `&sales_user_id=${encodeURIComponent(salesUserId)}`;
    }
    if (preset != null && preset !== '') {
      url += `&preset=${encodeURIComponent(preset)}`;
    }
    if (from != null && from !== '') {
      url += `&from=${encodeURIComponent(from)}`;
    }
    if (to != null && to !== '') {
      url += `&to=${encodeURIComponent(to)}`;
    }
    const data = await axiosInstance.get(url, headers);
    return data.data?.data ?? data.data;
  } catch (err) {
    console.error(`Error loading sales activity metrics: ${err}`);
    mixpanelErrorTracker.trackError('server error - getSalesActivityMetrics', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getSalesActivityMetrics',
      project_id: projectId,
      sales_user_id: salesUserId,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

/** GET /salesDashboard/activityMetrics/:key/items?... */
export async function getSalesActivityMetricItems(
  projectId,
  metricKey,
  { salesUserId, preset, from, to } = {}
) {
  try {
    const headers = await getHeaders();
    let url = `${USERMANAGEMENT_API_BASE_URL}/salesDashboard/activityMetrics/${encodeURIComponent(
      metricKey
    )}/items?project_id=${projectId}`;
    if (salesUserId != null && salesUserId !== '') {
      url += `&sales_user_id=${encodeURIComponent(salesUserId)}`;
    }
    if (preset != null && preset !== '') {
      url += `&preset=${encodeURIComponent(preset)}`;
    }
    if (from != null && from !== '') {
      url += `&from=${encodeURIComponent(from)}`;
    }
    if (to != null && to !== '') {
      url += `&to=${encodeURIComponent(to)}`;
    }
    const data = await axiosInstance.get(url, headers);
    return data.data?.data ?? data.data;
  } catch (err) {
    console.error(`Error loading sales activity metric items: ${err}`);
    mixpanelErrorTracker.trackError('server error - getSalesActivityMetricItems', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getSalesActivityMetricItems',
      project_id: projectId,
      metric_key: metricKey,
      sales_user_id: salesUserId,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export async function getManagementDashboardShell(projectId = null) {
  try {
    const headers = await getHeaders();
    let url = `${USERMANAGEMENT_API_BASE_URL}/management/dashboard`;
    if (projectId != null && projectId !== '') {
      url += `?project_id=${projectId}`;
    }
    const data = await axiosInstance.get(url, headers);
    return data.data;
  } catch (err) {
    console.error(`Error loading management dashboard shell: ${err}`);
    mixpanelErrorTracker.trackError('server error - getManagementDashboardShell', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getManagementDashboardShell',
      project_id: projectId,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export async function addFollowUp(payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.post(
      `${USERMANAGEMENT_API_BASE_URL}/followup`,
      payload,
      headers
    );
    return data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - addFollowUp', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'addFollowUp',
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('FollowUp data not loaded');
  }
}

export async function updateFollowUp(id, payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.put(
      `${USERMANAGEMENT_API_BASE_URL}/followup/${id}`,
      payload,
      headers
    );
    return data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - updateFollowUp', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'updateFollowUp',
      id: id,
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('FollowUp data not loaded');
  }
}

export async function addTargets(payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.post(
      `${USERMANAGEMENT_API_BASE_URL}/targets`,
      payload,
      headers
    );
    return data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - addTargets', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'addTargets',
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export async function updateTargets(payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.put(
      `${USERMANAGEMENT_API_BASE_URL}/targets`,
      payload,
      headers
    );
    return data.data;
  } catch (err) {
    console.error(`Error updating data: ${err}`);
    mixpanelErrorTracker.trackError('server error - updateTargets', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'updateTargets',
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export async function addIncentives(payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.post(
      `${USERMANAGEMENT_API_BASE_URL}/incentives`,
      payload,
      headers
    );
    return data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - addIncentives', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'addIncentives',
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Targets data not loaded');
  }
}

export async function getIncentives(id) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${USERMANAGEMENT_API_BASE_URL}/incentives?project_id=${id}`,
      headers
    );
    return data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - getIncentives', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getIncentives',
      id: id,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Targets data not loaded');
  }
}

export async function updateIncentives(id, payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.put(
      `${USERMANAGEMENT_API_BASE_URL}/incentives/${id}`,
      payload,
      headers
    );
    return data.data;
  } catch (err) {
    console.error(`Error updating data: ${err}`);
    mixpanelErrorTracker.trackError('server error - updateIncentives', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'updateIncentives',
      id: id,
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Incentives data not updated');
  }
}

const getFormattedMonthStart = (monthNumber) => {
  const currentYear = new Date().getFullYear();
  const paddedMonth = String(monthNumber).padStart(2, '0');
  // Start of the month with timestamp at 00:00:00
  return `${currentYear}-${paddedMonth}-01T00:00:00Z`;
};

export async function getAllSalesTargetsByProjectId(id, monthNumber) {
  try {
    const headers = await getHeaders();
    const monthStartDate = getFormattedMonthStart(monthNumber); // e.g., "2025-03-01"

    const data = await axiosInstance.get(
      `${USERMANAGEMENT_API_BASE_URL}/targets?project_id=${id}&month_date=${monthStartDate}`,
      headers
    );

    return data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - getAllSalesTargetsByProjectId', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getAllSalesTargetsByProjectId',
      id: id,
      monthNumber: monthNumber,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Sales data not loaded');
  }
}

export async function getSalesCallsStatsByProjectId(id, week_nos) {
  try {
    const headers = await getHeaders();
    let url = `${USERMANAGEMENT_API_BASE_URL}/targets/completedCalls/graphs?filter=week&project_id=${id}`;
    if (week_nos) {
      url += `&week=${week_nos}`;
    }

    const data = await axiosInstance.get(url, headers);

    return data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - getSalesCompletedCallsStatsByProjectId', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getSalesCompletedCallsStatsByProjectId',
      id: id,
      week_nos: week_nos,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Sales data not loaded');
  }
}

export async function getEngineerStatsByProjectId(id, month) {
  try {
    const now = new Date();
    const year = now.getFullYear();
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${USERMANAGEMENT_API_BASE_URL}/operationStats/opStats?month=${month}&year=${year}&project_id=${id}`,
      headers
    );

    return data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - getEngineerStatsByProjectId', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getEngineerStatsByProjectId',
      id: id,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Sales data not loaded');
  }
}

export async function getEngineerPrioritiesByProjectId(id, date) {
  try {
    const headers = await getHeaders();
    let url = `${USERMANAGEMENT_API_BASE_URL}/dailyTask?project_id=${id}&limit=500`;
    if (date) {
      url += `&date=${date}`;
    }
    const data = await axiosInstance.get(url, headers);
    return data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - getEngineerPrioritiesByProjectId', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getEngineerPrioritiesByProjectId',
      id: id,
      date: date,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Sales data not loaded');
  }
}

// Fetch all daily tasks for a given date (across all projects)
// Then caller can group/filter by project_id.
export async function getEngineerPrioritiesByDate(date) {
  try {
    const headers = await getHeaders();
    let url = `${USERMANAGEMENT_API_BASE_URL}/dailyTask?limit=500`;
    if (date) {
      url += `&date=${date}`;
    }
    const data = await axiosInstance.get(url, headers);
    return data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - getEngineerPrioritiesByDate', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getEngineerPrioritiesByDate',
      date: date,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export async function getEngineerPrioritiesByProjectAndUserId(
  id,
  date,
  userId,
  taskType,
  type = '',
  blockId = '',
  unitId = ''
) {
  try {
    const headers = await getHeaders();
    let url = `?date=${date}&project_id=${id}&limit=500&user_id=${userId}`;
    if (taskType === 'Escalated') {
      url += `&isEscalated=true`;
    }
    if (taskType === 'Review') {
      url += `&isReview=true`;
    }

    if (taskType === 'Possession Date') {
      url += `&type=Posession Date`;
    }

    if (taskType === 'Employees Allocation') {
      url += `&type=Employees Allocation`;
    }

    if (type !== '' && type === 'Date') {
      url += `&type=${type}`;
    }
    if (type !== '' && type === 'Kickstart') {
      url += `&type=${type}`;
    }

    if (type !== '' && type === 'Posession Date') {
      url += `&type=${type}`;
    }
    if (type !== '' && type === 'default') {
      url += `&type=${type}`;
    }

    if (type !== '' && type === 'Employees Allocation') {
      url += `&type=${type}`;
    }

    if (taskType !== '' && taskType === 'Kickstart') {
      url += `&type=${taskType}`;
    }
    if (taskType && isOperationsDashboardPriorityType(taskType)) {
      url += `&type=${encodeURIComponent(taskType)}`;
    }
    if (type !== '' && type === 'Escalated') {
      url += `&isEscalated=true`;
    }
    if (type !== '' && type === 'Review') {
      url += `&isReview=true`;
    }
    if (unitId !== '') {
      url += `&unit_id=${unitId}`;
    }
    if (blockId !== '') {
      url += `&block_id=${blockId}`;
    }
    const data = await axiosInstance.get(`${USERMANAGEMENT_API_BASE_URL}/dailyTask${url}`, headers);
    return data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - getEngineerPrioritiesByProjectId', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getEngineerPrioritiesByProjectId',
      id: id,
      date: date,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Sales data not loaded');
  }
}

export async function getEngineerPendingApprovals(id) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${USERMANAGEMENT_API_BASE_URL}/dailyRequirement?project_id=${id}&approved=false`,
      headers
    );

    return data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - getEngineerPendingApprovals', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getEngineerPendingApprovals',
      id: id,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Sales data not loaded');
  }
}

export async function getEngTeamStatsByProjectId(id, month) {
  try {
    const headers = await getHeaders();
    const year = new Date().getFullYear();
    const data = await axiosInstance.get(
      `${USERMANAGEMENT_API_BASE_URL}/operationStats/ops/Performance?month=${month}&year=${year}&project_id=${id}`,
      headers
    );

    return data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - getEngTeamStatsByProjectId', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getEngTeamStatsByProjectId',
      id: id,
      month: month,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Sales data not loaded');
  }
}

export async function acceptRejectApproval(payload, id) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.put(
      `${USERMANAGEMENT_API_BASE_URL}/dailyRequirement/${id}`,
      payload,
      headers
    );

    return data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - acceptRejectApproval', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'acceptRejectApproval',
      id: id,
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Sales data not loaded');
  }
}

export async function setQualityScoreByTaskID(id, payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.put(
      `${USERMANAGEMENT_API_BASE_URL}/liveTask/${id}`,
      payload,
      headers
    );

    return data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - setQualityScoreByTaskID', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'setQualityScoreByTaskID',
      id: id,
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Sales data not loaded');
  }
}

export async function getConversionStatsByProjectId(
  id,
  monthName,
  year = new Date().getFullYear()
) {
  try {
    const headers = await getHeaders();

    // Convert month name to number (1-12)
    const monthNumber = new Date(`${monthName} 1, ${year}`).getMonth() + 1;

    const data = await axiosInstance.get(
      `${USERMANAGEMENT_API_BASE_URL}/targets/conversionStats?project_id=${id}&month=${monthNumber}&year=${year}`,
      headers
    );

    return data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - getConversionStatsByProjectId', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getConversionStatsByProjectId',
      id: id,
      monthName: monthName,
      year: year,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Sales data not loaded');
  }
}

export async function getYearlyConversionStatsByProjectId(
  id,
  monthName,
  year = new Date().getFullYear()
) {
  try {
    const headers = await getHeaders();

    // Convert month name to number (1-12)
    const monthNumber = new Date(`${monthName} 1, ${year}`).getMonth() + 1;

    const data = await axiosInstance.get(
      `${USERMANAGEMENT_API_BASE_URL}/targets/yearlyConversionStats?project_id=${id}&month=${monthNumber}&year=${year}`,
      headers
    );

    return data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - getYearlyConversionStatsByProjectId', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getYearlyConversionStatsByProjectId',
      id: id,
      monthName: monthName,
      year: year,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Sales data not loaded');
  }
}

export async function getAvailability(id, { limit = 10000, page = 1 } = {}) {
  try {
    const headers = await getHeaders();

    const data = await axiosInstance.get(
      `${USERMANAGEMENT_API_BASE_URL}/availability?project_id=${id}&limit=${limit}&page=${page}`,
      headers
    );

    return data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - getAvailability', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getAvailability',
      id: id,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Sales data not loaded');
  }
}
export async function acceptRejectLeave(payload, id) {
  try {
    const headers = await getHeaders();

    const data = await axiosInstance.put(
      `${USERMANAGEMENT_API_BASE_URL}/availability/${id}`,
      payload,
      headers
    );

    return data.data;
  } catch (err) {
    console.error(`Error acceptin/rejecting leave: ${err}`);
    mixpanelErrorTracker.trackError('server error - acceptRejectLeave', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'acceptRejectLeave',
      payload: payload,
      id: id,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Sales data not accepted/rejected');
  }
}

export async function getAllSalesStatsByProjectId(id) {
  try {
    const headers = await getHeaders();
    // const monthStartDate = getFormattedMonthStart(monthNumber); // e.g., "2025-03-01"

    const data = await axiosInstance.get(
      `${USERMANAGEMENT_API_BASE_URL}/targets/mystats?project_id=${id}`,
      headers
    );

    return data.data;
  } catch (err) {
    console.error(`Error loading stats: ${err}`);
    mixpanelErrorTracker.trackError('server error - getAllSalesStatsByProjectId', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getAllSalesStatsByProjectId',
      id: id,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Sales stats not loaded');
  }
}

export async function getSalesDashboardStatsByProjectId(id) {
  try {
    const headers = await getHeaders();

    const data = await axiosInstance.get(
      `${USERMANAGEMENT_API_BASE_URL}/targets/sales-stats/${id}`,
      headers
    );

    return data.data;
  } catch (err) {
    console.error(`Error loading dashboard sales card stats: ${err}`);
    mixpanelErrorTracker.trackError('server error - getSalesDashboardStatsByProjectId', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getSalesDashboardStatsByProjectId',
      id: id,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

// write put api for /target/bulk/update
export async function bulkUpdateTarget(payload, selectedMonth, selectedYear) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.put(
      `${APPLICATION_API_BASE_URL}/target/bulk/update?month=${selectedMonth}&year=${selectedYear}`,
      payload,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error updating target:${err}`);
    mixpanelErrorTracker.trackError('server error - bulkUpdateTarget', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'bulkUpdateTarget',
      payload: payload,
      selectedMonth: selectedMonth,
      selectedYear: selectedYear,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Target not updated');
  }
}

//write api call for getorderactivity by order id
export async function getOrderActivityByOrderId(id) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/orderactivity?order_id=${id}`,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - getOrderActivityByOrderId', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getOrderActivityByOrderId',
      id: id,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Order activity data not loaded');
  }
}

//write api call for createapplication /application
export async function createApplication(payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/application`,
      payload,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error creating application:${err}`);
    mixpanelErrorTracker.trackError('server error - createApplication', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'createApplication',
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

//write api call for get application
export async function getApplication() {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/application?limit=1000`,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - getApplication', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getApplication',
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Application data not loaded');
  }
}

//template creation

// write api call for template creation post api
export async function createTemplate(payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.post(`${APPLICATION_API_BASE_URL}/template`, payload, headers);
    return data.data.data;
  } catch (err) {
    console.error(`Error creating template: ${err}`);
    mixpanelErrorTracker.trackError('server error - createTemplate', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'createTemplate',
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Template not created');
  }
}

//write api call for get template
export async function getTemplate(projectId) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/template?project_id=${projectId}&limit=1000`,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - getTemplate', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getTemplate',
      projectId: projectId,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Template data not loaded');
  }
}

export async function handleCheckTemplateDelete(id) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/template/checkDelete/${id}`,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error checking template: ${err}`);
    mixpanelErrorTracker.trackError('server error - handleCheckTemplateDelete', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'handleCheckTemplateDelete',
      id: id,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Error checking template');
  }
}

export async function deleteTemplate(payload) {
  try {
    const headers = await getHeaders(); // contains { headers: { Authorization: '...' } }

    const response = await axiosInstance.delete(`${APPLICATION_API_BASE_URL}/template/delete`, {
      ...headers,
      data: payload
    });

    return response.data.data;
  } catch (err) {
    console.error('Error deleting template:', err?.response || err);
    mixpanelErrorTracker.trackError('server error - deleteTemplate', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'deleteTemplate',
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Error deleting template');
  }
}

//write api call for get annexure
export async function getAnnexures() {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/annexure?limit=1000`,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - getAnnexures', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getAnnexures',
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Annexure data not loaded');
  }
}

//writw api call for get dynamicfields
export async function getDynamicFields() {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/dynamicfield?limit=1000`,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - getDynamicFields', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getDynamicFields',
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Dynamic fields data not loaded');
  }
}

async function getDynamicFieldsForSubroute(subroute, functionName) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/dynamicfield/${subroute}?limit=1000`,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - getDynamicFieldsForSubroute', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: functionName,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export async function getDynamicFieldsProject() {
  return getDynamicFieldsForSubroute('project', 'getDynamicFieldsProject');
}

export async function getDynamicFieldsUnit() {
  return getDynamicFieldsForSubroute('unit', 'getDynamicFieldsUnit');
}

export async function getDynamicFieldsUnitPricing() {
  return getDynamicFieldsForSubroute('unit-pricing', 'getDynamicFieldsUnitPricing');
}

//write api to get documents by template id
export async function getDocumentsByTemplateId(id) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/document?template_id=${id}&limit=1000`,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - getDocumentsByTemplateId', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getDocumentsByTemplateId',
      id: id,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Documents data not loaded');
  }
}

export async function handleCheckDocumentDelete(id) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/document/checkDelete/${id}`,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error checking document: ${err}`);
    mixpanelErrorTracker.trackError('server error - handleCheckDocumentDelete', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'handleCheckDocumentDelete',
      id: id,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Error checking document');
  }
}

export async function deleteDocument(payload) {
  try {
    const headers = await getHeaders(); // contains { headers: { Authorization: '...' } }

    const response = await axiosInstance.delete(`${APPLICATION_API_BASE_URL}/document/delete`, {
      ...headers,
      data: payload
    });

    return response.data.data;
  } catch (err) {
    console.error('Error deleting document:', err?.response || err);
    mixpanelErrorTracker.trackError('server error - deleteDocument', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'deleteDocument',
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Error deleting document');
  }
}

//write api to generate document
export async function generateDocument(payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.post(`${APPLICATION_API_BASE_URL}/document`, payload, headers);
    return data.data.data;
  } catch (err) {
    console.error(`Error generating document: ${err}`);
    mixpanelErrorTracker.trackError('server error - generateDocument', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'generateDocument',
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Document not generated');
  }
}

//write api to download document
export async function downloadDocument(documentId) {
  try {
    const headers = await getFileHeaders();
    const response = await axiosInstance.get(
      `${DOCGENERATION_API_BASE_URL}/document/doc/${documentId}`,
      {
        ...headers,
        responseType: 'arraybuffer'
      }
    );
    return response.data;
  } catch (err) {
    console.error(`Error Getting document: ${err}`);
    mixpanelErrorTracker.trackError('server error - downloadDocument', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'downloadDocument',
      documentId: documentId,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Error fetching document');
  }
}

//write api to upload document
export async function uploadDocument(documentId, payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/document/${documentId}`,
      payload,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error uploading document: ${err}`);
    mixpanelErrorTracker.trackError('server error - uploadDocument', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'uploadDocument',
      documentId: documentId,
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Document not uploaded');
  }
}

//write api to download signed document
export async function downloadSignedDocument(documentId) {
  try {
    const headers = await getFileHeaders();
    const response = await axiosInstance.get(
      `${DOCGENERATION_API_BASE_URL}/document/${documentId}`,
      {
        ...headers,
        responseType: 'arraybuffer'
      }
    );
    return response.data;
  } catch (err) {
    console.error(`Error Getting signed document: ${err}`);
    mixpanelErrorTracker.trackError('server error - downloadSignedDocument', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'downloadSignedDocument',
      documentId: documentId,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Error fetching signed document');
  }
}

//write spi for get document by id
export async function getDocumentById(id) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(`${APPLICATION_API_BASE_URL}/document/${id}`, headers);
    return data.data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - getDocumentById', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getDocumentById',
      id: id,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Document data not loaded');
  }
}

//writw get document by deal id
export async function getDocumentByDealId(id) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/document?deal_id=${id}&limit=1000`,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - getDocumentByDealId', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getDocumentByDealId',
      id: id,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Document data not loaded');
  }
}

//write api to update template
export async function updateTemplate(id, payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.put(
      `${APPLICATION_API_BASE_URL}/template/${id}`,
      payload,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error updating template: ${err}`);
    mixpanelErrorTracker.trackError('server error - updateTemplate', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'updateTemplate',
      id: id,
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Template not updated');
  }
}

//write api to get template by id
export async function getTemplateById(id) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(`${APPLICATION_API_BASE_URL}/template/${id}`, headers);
    return data.data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - getTemplateById', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getTemplateById',
      id: id,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Template data not loaded');
  }
}

// Add this function to your impl.js file

export async function downloadSampleDocument(documentId) {
  try {
    const headers = await getFileHeaders();
    const response = await axiosInstance.get(
      `${DOCGENERATION_API_BASE_URL}/document/preview/${documentId}`,
      {
        ...headers,
        responseType: 'arraybuffer'
      }
    );
    return response.data;
  } catch (err) {
    console.error(`Error downloading sample document: ${err}`);
    mixpanelErrorTracker.trackError('server error - downloadSampleDocument', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'downloadSampleDocument',
      documentId: documentId,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Error fetching sample document');
  }
}

export async function getServiceProviderById(id) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/serviceprovider/${id}`,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - getServiceProviderById', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getServiceProviderById',
      id: id,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Service Provider data not loaded');
  }
}

export async function deactivateServiceProvider(payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.patch(
      `${APPLICATION_API_BASE_URL}/serviceprovider/${payload.id}/status`,
      { status: payload.status },
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error updating status: ${err}`);
    mixpanelErrorTracker.trackError('server error - deactivateServiceProvider', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'deactivateServiceProvider',
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Failed to update service provider status');
  }
}

export async function uploadFilesToS3(files) {
  try {
    const headers = await getFileHeaders();
    const formData = new FormData();

    files.forEach((file) => {
      formData.append('files', file);
    });

    const response = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/s3/upload`,
      formData,
      headers
    );

    const getFileType = (originalName) => {
      const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'];
      const extension = originalName.split('.').pop().toLowerCase();

      if (imageExtensions.includes(extension)) {
        return `image/${extension}`;
      } else {
        return `document/${extension}`;
      }
    };

    const uploadedFiles = response.data.data.files.map((file) => ({
      name: file.originalName,
      url: file.presignedUrl,
      type: getFileType(file.originalName)
    }));

    return uploadedFiles;
  } catch (err) {
    console.error(`Error uploading files: ${err}`);
    mixpanelErrorTracker.trackError('server error - uploadFilesToS3', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'uploadFilesToS3',
      files_count: files?.length || 0,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

/**
 * Logged-in user profile. Default lite; pass { full: true } for heavy relations.
 */
export async function getMyData(options = {}) {
  try {
    const headers = await getHeaders();
    const full = options?.full === true;
    const url = full
      ? `${APPLICATION_API_BASE_URL}/users/me?full=1`
      : `${APPLICATION_API_BASE_URL}/users/me`;
    const data = await axiosInstance.get(url, headers);
    return data.data.data;
  } catch (err) {
    console.error(`Error getting my data: ${err}`);
    mixpanelErrorTracker.trackError('server error - getMyData', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getMyData',
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Failed to get my data');
  }
}

export async function addRequirement(payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/requirement`,
      payload,
      headers
    );
    const res = data.data.data;
    return res;
  } catch (err) {
    console.error(`Error adding requirement: ${err}`);
    mixpanelErrorTracker.trackError('server error - addRequirement', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'addRequirement',
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export async function addMachineryRequirement(payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/machineryRequirement`,
      payload,
      headers
    );
    const res = data.data.data;
    return res;
  } catch (err) {
    console.error(`Error adding machinery requirement: ${err}`);
    mixpanelErrorTracker.trackError('server error - addMachineryRequirement', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'addMachineryRequirement',
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export async function getAllItemsByProjectAndCategoryID(projectId, categoryId) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/inventory?project_id=${projectId}&parent_category_id=${categoryId}&limit=500`,
      headers
    );
    const res = data.data.data;
    return res;
  } catch (err) {
    console.error(`Error getting all items by project and category ID: ${err}`);
    mixpanelErrorTracker.trackError('server error - getAllItemsByProjectAndCategoryID', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getAllItemsByProjectAndCategoryID',
      projectId: projectId,
      categoryId: categoryId,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export async function getAllItemsByMulCategoryID(categoryId) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/inventory?category_ids=${categoryId}&limit=500`,
      headers
    );
    const res = data.data.data;
    return res;
  } catch (err) {
    console.error(`Error getting all items by mul category ID: ${err}`);
    mixpanelErrorTracker.trackError('server error - getAllItemsByMulCategoryID', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getAllItemsByMulCategoryID',
      categoryId: categoryId,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export async function deleteDailyTask(payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/dailyTask`,
      payload,
      headers
    );
    const res = data.data.data;
    return res;
  } catch (err) {
    console.error(`Error deleting daily task: ${err}`);
    mixpanelErrorTracker.trackError('server error - deleteDailyTask', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'deleteDailyTask',
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export async function getAllInventoryByProjectId(
  projectId,
  categoryId,
  filter = '',
  daysFilter = '90'
) {
  try {
    const headers = await getHeaders();
    let url = `${APPLICATION_API_BASE_URL}/inventory?project_id=${projectId}&limit=500`;
    if (categoryId) {
      url += `&parent_category_id=${categoryId}`;
    }
    if (filter) {
      url += `&stock_criticality_filter
=${filter}`;
    }

    if (daysFilter) {
      url += `&days_filter=${daysFilter}`;
    }

    const data = await axiosInstance.get(url, headers);
    const res = data.data.data;
    return res;
  } catch (err) {
    console.error(`Error getting all items by project ID: ${err}`);
    mixpanelErrorTracker.trackError('server error - getAllItemsByProjectId', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getAllItemsByProjectId',
      projectId: projectId,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export async function createInventory(payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/inventory`,
      payload,
      headers
    );
    const res = data.data.data;
    return res;
  } catch (err) {
    console.error(`Error creating inventory: ${err}`);
    mixpanelErrorTracker.trackError('server error - createInventory', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'createInventory',
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export async function updateInventory(id, payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.put(
      `${APPLICATION_API_BASE_URL}/inventory/${id}`,
      payload,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error updating inventory: ${err}`);
    mixpanelErrorTracker.trackError('server error - updateInventory', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'updateInventory',
      id: id,
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export async function createRFQ(payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/quotationrequest`,
      payload,
      headers
    );
    const res = data.data.data;
    return res;
  } catch (err) {
    console.error(`Error creating RFQ: ${err}`);
    mixpanelErrorTracker.trackError('server error - createRFQ', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'createRFQ',
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export async function getAllRFQs(page = 1, limit = 500, projectID) {
  try {
    const headers = await getHeaders();
    let url = `${APPLICATION_API_BASE_URL}/quotationrequest?page=${page}&limit=${limit}`;
    if (projectID) {
      url += `&project_id=${projectID}`;
    }
    const data = await axiosInstance.get(url, headers);
    const res = data.data;
    return res;
  } catch (err) {
    console.error(`Error getting all RFQs: ${err}`);
    mixpanelErrorTracker.trackError('server error - getAllRFQs', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getAllRFQs',
      page: page,
      limit: limit,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export async function updateRFQ(id, payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.put(
      `${APPLICATION_API_BASE_URL}/quotationRequest/${id}`,
      payload,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error updating RFQ: ${err}`);
    mixpanelErrorTracker.trackError('server error - updateRFQ', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'updateRFQ',
      id: id,
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export async function getRFQById(id) {
  try {
    const headers = await getHeaders();
    let url = `${APPLICATION_API_BASE_URL}/quotationrequest/${id}`;
    const data = await axiosInstance.get(url, headers);
    const res = data.data.data;
    return res;
  } catch (err) {
    console.error(`Error getting RFQ by id: ${err}`);
    mixpanelErrorTracker.trackError('server error - getRFQById', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getRFQById',
      id: id,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export async function getVendorQuatationItem(requirementId) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/quotation?rfq_id=${requirementId}`,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error getting vendor quotation item: ${err}`);
    mixpanelErrorTracker.trackError('server error - getVendorQuatationItem', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getVendorQuatationItem',
      requirementId: requirementId,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export async function createPO(payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/quotation/acceptQuotations`,
      payload,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error creating PO: ${err}`);
    mixpanelErrorTracker.trackError('server error - createPO', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'createPO',
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export async function updateQuotationStatus(id, payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.put(
      `${APPLICATION_API_BASE_URL}/quotation/${id}`,
      payload,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error updating quotation status: ${err}`);
    mixpanelErrorTracker.trackError('server error - updateQuotationStatus', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'updateQuotationStatus',
      id: id,
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export async function getSPBillsList(page, limit) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/spBills?page=${page}&limit=${limit}`,
      headers
    );
    return data.data;
  } catch (err) {
    console.error(`Error getting SP bills list: ${err}`);
    mixpanelErrorTracker.trackError('server error - getSPBillsList', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getSPBillsList',
      page: page,
      limit: limit,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export async function getSPBillById(id) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(`${APPLICATION_API_BASE_URL}/spBills/${id}`, headers);
    return data.data.data;
  } catch (err) {
    console.error(`Error getting SP bill by id: ${err}`);
    mixpanelErrorTracker.trackError('server error - getSPBillById', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getSPBillById',
      id: id,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export async function paySPBills(id, payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.put(
      `${APPLICATION_API_BASE_URL}/spBills/${id}`,
      payload,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error paying SP bills: ${err}`);
    mixpanelErrorTracker.trackError('server error - paySPBills', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'paySPBills',
      id: id,
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export async function getInventoryPerformanceStatsByProjectId(projectID, month) {
  const year = new Date().getFullYear();
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/inventoryStats/stats?month=${month}&year=${year}&project_id=${projectID}`,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error getting inventory stats by project ID: ${err}`);
    mixpanelErrorTracker.trackError('server error - getInventoryStatsByProjectId', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getInventoryStatsByProjectId',
      projectID: projectID,
      month: month,
      year: year,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export async function getInventoryStatsByProjectId(projectID, month) {
  const year = new Date().getFullYear();
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/inventoryStats/dashboard?project_id=${projectID}`,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error getting inventory stats by project ID: ${err}`);
    mixpanelErrorTracker.trackError('server error - getInventoryStatsByProjectId', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getInventoryStatsByProjectId',
      projectID: projectID,
      // month: month,
      // year: year,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export async function getInventoryDailyTasks(projectId, date) {
  try {
    const headers = await getHeaders();
    let url = `${APPLICATION_API_BASE_URL}/inventoryDailyTask?project_id=${projectId}&limit=500`;
    if (date) {
      url += `&date=${date}`;
    }
    const data = await axiosInstance.get(url, headers);
    return data.data.data;
  } catch (err) {
    console.error(`Error getting inventory daily tasks: ${err}`);
    mixpanelErrorTracker.trackError('server error - getInventoryDailyTasks', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getInventoryDailyTasks',
      projectId: projectId,
      date: date,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export async function getInventoryOnboardingMap(projectId) {
  try {
    const headers = await getHeaders();
    const url = `${APPLICATION_API_BASE_URL}/inventoryDailyTask/onboarding-map?project_id=${projectId}`;
    const data = await axiosInstance.get(url, headers);
    return data.data;
  } catch (err) {
    console.error(`Error loading inventory onboarding map: ${err}`);
    mixpanelErrorTracker.trackError('server error - getInventoryOnboardingMap', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getInventoryOnboardingMap',
      project_id: projectId,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export async function getOperationsOnboardingMap(projectId, operationsUserId) {
  try {
    const headers = await getHeaders();
    const url = `${APPLICATION_API_BASE_URL}/dailyTask/onboarding-map?project_id=${projectId}&operations_user_id=${operationsUserId}`;
    const data = await axiosInstance.get(url, headers);
    return data.data;
  } catch (err) {
    console.error(`Error loading operations onboarding map: ${err}`);
    mixpanelErrorTracker.trackError('server error - getOperationsOnboardingMap', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getOperationsOnboardingMap',
      project_id: projectId,
      operations_user_id: operationsUserId,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export async function getSalesOnboardingMap(projectId, salesManagerId) {
  try {
    const headers = await getHeaders();
    const url = `${APPLICATION_API_BASE_URL}/salesDailyTask/onboarding-map?project_id=${projectId}&sales_manager_id=${salesManagerId}`;
    const data = await axiosInstance.get(url, headers);
    return data.data;
  } catch (err) {
    console.error(`Error loading sales onboarding map: ${err}`);
    mixpanelErrorTracker.trackError('server error - getSalesOnboardingMap', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getSalesOnboardingMap',
      project_id: projectId,
      sales_manager_id: salesManagerId,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export async function getSalesOnboardingAccountability(projectId) {
  try {
    const headers = await getHeaders();
    const url = `${APPLICATION_API_BASE_URL}/salesDailyTask/onboarding-accountability?project_id=${projectId}`;
    const data = await axiosInstance.get(url, headers);
    return data.data;
  } catch (err) {
    console.error(`Error loading sales onboarding accountability: ${err}`);
    mixpanelErrorTracker.trackError('server error - getSalesOnboardingAccountability', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getSalesOnboardingAccountability',
      project_id: projectId,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export async function getOperationsOnboardingAccountability(projectId) {
  try {
    const headers = await getHeaders();
    const url = `${APPLICATION_API_BASE_URL}/dailyTask/onboarding-accountability?project_id=${projectId}`;
    const data = await axiosInstance.get(url, headers);
    return data.data;
  } catch (err) {
    console.error(`Error loading operations onboarding accountability: ${err}`);
    mixpanelErrorTracker.trackError('server error - getOperationsOnboardingAccountability', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getOperationsOnboardingAccountability',
      project_id: projectId,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export async function getInventoryOnboardingAccountability(projectId) {
  try {
    const headers = await getHeaders();
    const url = `${APPLICATION_API_BASE_URL}/inventoryDailyTask/onboarding-accountability?project_id=${projectId}`;
    const data = await axiosInstance.get(url, headers);
    return data.data;
  } catch (err) {
    console.error(`Error loading inventory onboarding accountability: ${err}`);
    mixpanelErrorTracker.trackError('server error - getInventoryOnboardingAccountability', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getInventoryOnboardingAccountability',
      project_id: projectId,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export async function getSalesDailyTasks(projectId) {
  try {
    const headers = await getHeaders();
    let url = `${APPLICATION_API_BASE_URL}/salesDailyTask?limit=500`;
    if (projectId) {
      url += `&project_id=${projectId}`;
    }
    const data = await axiosInstance.get(url, headers);
    return data.data?.data ?? data.data;
  } catch (err) {
    console.error(`Error getting sales daily tasks: ${err}`);
    mixpanelErrorTracker.trackError('server error - getSalesDailyTasks', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getSalesDailyTasks',
      projectId: projectId,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export async function updateInventoryDailyTasks(id, payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.put(
      `${APPLICATION_API_BASE_URL}/inventoryDailyTask/${id}`,
      payload,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error updating inventory daily tasks: ${err}`);
    mixpanelErrorTracker.trackError('server error - updateInventoryDailyTasks', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'updateInventoryDailyTasks',
      id: id,
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export async function addReason(payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/inventory/reason`,
      payload,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error adding reason: ${err}`);
    mixpanelErrorTracker.trackError('server error - addReason', {
      function_name: 'addReason',
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export async function addAudit(payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/audit/update`,
      payload,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error adding audit: ${err}`);
    mixpanelErrorTracker.trackError('server error - addAudit', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'addAudit',
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export async function addScore(payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/inventoryStats/addPerformance`,
      payload,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error adding score: ${err}`);
    mixpanelErrorTracker.trackError('server error - addScore', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'addScore',
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export async function getSPBillsHistory(page, limit) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/spBills/payment?page=${page}&limit=${limit}`,
      headers
    );
    return data.data;
  } catch (err) {
    console.error(`Error getting SP bills history: ${err}`);
    mixpanelErrorTracker.trackError('server error - getSPBillsHistory', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getSPBillsHistory',
      page: page,
      limit: limit,
      http_status: err?.response?.status || 'N/A'
    });
    throw new Error('Error getting SP bills history');
  }
}

export async function downloadStockTemplate(id) {
  try {
    const headers = await getExcelHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/items/inventory/${id}/download`,
      {
        ...headers,
        responseType: 'blob'
      }
    );
    return data.data;
  } catch (err) {
    console.error(`Error downloading template: ${err}`);
    mixpanelErrorTracker.trackError('server error - downloadTemplate', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'downloadTemplate',
      id: id,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export async function uploadStockTemplate(id, payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/items/inventory/${id}/upload`,
      payload,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error uploading template: ${err}`);
    mixpanelErrorTracker.trackError('server error - uploadStockTemplate', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'uploadStockTemplate',
      id: id,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export async function getMachineryList(page, limit) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/machineList?page=${page}&limit=${limit}`,
      headers
    );
    return data.data;
  } catch (err) {
    console.error(`Error getting machinery list: ${err}`);
    mixpanelErrorTracker.trackError('server error - getMachineryList', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getMachineryList',
      page: page,
      limit: limit,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export async function addMachinery(payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/machineList`,
      payload,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error adding machinery: ${err}`);
    mixpanelErrorTracker.trackError('server error - addMachinery', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'addMachinery',
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export async function updateMachinery(id, payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.put(
      `${APPLICATION_API_BASE_URL}/machineList/${id}`,
      payload,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error updating machinery: ${err}`);
    mixpanelErrorTracker.trackError('server error - updateMachinery', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'updateMachinery',
      id: id,
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export async function handleCheckMachineDelete(id) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/machineList/checkDelete/${id}`,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error checking machine: ${err}`);
    mixpanelErrorTracker.trackError('server error - handleCheckMachineDelete', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'handleCheckMachineDelete',
      machine_id: id,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err; // throw new Error('Error checking machine');
  }
}

export async function deleteMachine(payload) {
  try {
    const headers = await getHeaders(); // contains { headers: { Authorization: '...' } }

    const response = await axiosInstance.delete(`${APPLICATION_API_BASE_URL}/machineList/delete`, {
      ...headers,
      data: payload
    });

    return response.data.data;
  } catch (err) {
    console.error('Error deleting machine:', err?.response || err);
    mixpanelErrorTracker.trackError('server error - deleteMachine', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'deleteMachine',
      payload: payload,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err; // throw new Error('Error deleting machine');
  }
}

export async function getTasksForAudit(id, date) {
  try {
    const headers = await getHeaders(); // contains { headers: { Authorization: '...' } }
    const year = new Date(date).getFullYear();
    const month = new Date(date).getMonth() + 1;
    const response = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/audit?project_id=${id}&year=${year}&month=${month}`,
      {
        ...headers
      }
    );

    return response.data.data;
  } catch (err) {
    console.error('Error getting tasks for audit:', err?.response || err);
    mixpanelErrorTracker.trackError('server error - getTasksForAudit', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getTasksForAudit',
      id: id,
      date: date,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err; // throw new Error('Error getting tasks for audit');
  }
}

export async function getCommonProjectProgress(payload) {
  try {
    const headers = await getHeaders(); // contains { headers: { Authorization: '...' } }
    const response = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/operationStats/projectProgress/common`,
      payload,
      headers
    );

    return response.data.data;
  } catch (err) {
    console.error('Error getting common project progress:', err?.response || err);
    mixpanelErrorTracker.trackError('server error - getCommonProjectProgress', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getCommonProjectProgress',
      payload: payload,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err; // throw new Error('Error getting common project progress');
  }
}

export async function getIndependentProjectProgress(payload) {
  try {
    const headers = await getHeaders(); // contains { headers: { Authorization: '...' } }
    const response = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/operationStats/projectProgress/independent`,
      payload,
      headers
    );

    return response.data.data;
  } catch (err) {
    console.error('Error getting independent project progress:', err?.response || err);
    mixpanelErrorTracker.trackError('server error - getIndependentProjectProgress', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getIndependentProjectProgress',
      payload: payload,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err; // throw new Error('Error getting independent project progress');
  }
}

export async function getGroupProjectProgress(payload) {
  try {
    const headers = await getHeaders(); // contains { headers: { Authorization: '...' } }
    const response = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/operationStats/projectProgress/group`,
      payload,
      headers
    );

    return response.data.data;
  } catch (err) {
    console.error('Error getting group project progress:', err?.response || err);
    mixpanelErrorTracker.trackError('server error - getGroupProjectProgress', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getGroupProjectProgress',
      payload: payload,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err; // throw new Error('Error getting group project progress');
  }
}

export async function getMoneyUtilizationStats(payload) {
  try {
    const headers = await getHeaders(); // contains { headers: { Authorization: '...' } }
    const response = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/operationStats/moneyUtilisation`,
      payload,
      headers
    );

    return response.data.data;
  } catch (err) {
    console.error('Error getting money utilization stats:', err?.response || err);
    mixpanelErrorTracker.trackError('server error - getMoneyUtilizationStats', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getMoneyUtilizationStats',
      payload: payload,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err; // throw new Error('Error getting money utilization stats');
  }
}

export async function getPerformaInvoice(page, limit) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/pi?page=${page}&limit=${limit}`,
      headers
    );
    return data.data;
  } catch (err) {
    console.error(`Error getting performa invoice: ${err}`);
    mixpanelErrorTracker.trackError('server error - getPerformaInvoice', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getPerformaInvoice',
      page: page,
      limit: limit,
      http_status: err?.response?.status || 'N/A'
    });
    throw new Error('Error getting performa invoice');
  }
}

export async function updatePerformaInvoice(id, payload) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.put(
      `${APPLICATION_API_BASE_URL}/pi/${id}`,
      payload,
      headers
    );
    return response.data.data;
  } catch (err) {
    console.error(`Error updating performa invoice: ${err}`);
    mixpanelErrorTracker.trackError('server error - updatePerformaInvoice', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'updatePerformaInvoice',
      form_id: id,
      payload: payload,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function getPerformaInvoiceHistory(page, limit) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/poPaymentRecords?page=${page}&limit=${limit}`,
      headers
    );
    return data.data;
  } catch (err) {
    console.error(`Error getting performa invoice history: ${err}`);
    mixpanelErrorTracker.trackError('server error - getPerformaInvoiceHistory', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getPerformaInvoiceHistory',
      page: page,
      limit: limit,
      http_status: err?.response?.status || 'N/A'
    });
    throw new Error('Error getting performa invoice history');
  }
}

export async function commonPayInvoice(id, payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/invoices/commonPay/${id}`,
      payload,
      headers
    );
    return data.data;
  } catch (err) {
    console.error(`Error common pay invoice: ${err}`);
    mixpanelErrorTracker.trackError('server error - commonPayInvoice', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'commonPayInvoice',
      id: id,
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw new Error('Error common pay invoice');
  }
}

export async function addNonWorkingDay(payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/holiday/addNonWorkingDays`,
      payload,
      headers
    );
    return data.data;
  } catch (err) {
    console.error(`Error Non working days: ${err}`);
    mixpanelErrorTracker.trackError('server error - addNonWorkingDay', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'addNonWorkingDay',
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw new Error('Error Non working days');
  }
}

export async function updatePaymentStatus(id, payload) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.put(
      `${APPLICATION_API_BASE_URL}/invoices/invoice/payment/history/${id}`,
      payload,
      headers
    );
    return response.data.data;
  } catch (err) {
    console.error(`Error updating payment status: ${err}`);
    mixpanelErrorTracker.trackError('server error - updatePaymentStatus', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'updatePaymentStatus',
      payment_id: id,
      payload: payload,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}
export async function cancelInvoice(id) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.put(
      `${APPLICATION_API_BASE_URL}/invoices/invoice/cancel/${id}`,
      {},
      headers
    );
    return response.data.data;
  } catch (err) {
    console.error(`Error cancel invoice: ${err}`);
    mixpanelErrorTracker.trackError('server error - cancelInvoice', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'cancelInvoice',
      invoice_id: id,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

/**
 * Prefer managementPriority routes (auth-only) so Management can approve
 * without invoices.can_update. Fall back to /invoices for older BE deploys.
 */
export async function approveCancelInvoice(id, payload = {}) {
  const headers = await getHeaders();
  const endpoints = [
    `${APPLICATION_API_BASE_URL}/managementPriority/invoice-cancel/approve/${id}`,
    `${APPLICATION_API_BASE_URL}/invoices/invoice/cancel/approve/${id}`,
  ];
  let lastErr;
  for (let i = 0; i < endpoints.length; i++) {
    try {
      const response = await axiosInstance.put(endpoints[i], payload, headers);
      return response.data.data;
    } catch (err) {
      lastErr = err;
      const status = err?.response?.status;
      // Retry invoices path on 403/404/5xx (and network errors with no status).
      // Do not retry auth expiry (401) or validation (400).
      const canFallback =
        i === 0 && (status == null || status === 403 || status === 404 || status === 405 || status >= 500);
      if (!canFallback) break;
    }
  }
  console.error(`Error approve cancel invoice: ${lastErr}`);
  mixpanelErrorTracker.trackError('server error - approveCancelInvoice', {
    error_message:
      lastErr?.response?.data?.message || lastErr?.message || 'Unknown error',
    function_name: 'approveCancelInvoice',
    invoice_id: id,
    http_status: lastErr?.response?.status || 'N/A',
    api_endpoint: lastErr?.config?.url || 'N/A',
    request_method: lastErr?.config?.method?.toUpperCase() || 'N/A',
    full_error_response: lastErr?.response?.data || lastErr?.message || 'No details'
  });
  throw lastErr;
}

export async function rejectCancelInvoice(id, payload = {}) {
  const headers = await getHeaders();
  const endpoints = [
    `${APPLICATION_API_BASE_URL}/managementPriority/invoice-cancel/reject/${id}`,
    `${APPLICATION_API_BASE_URL}/invoices/invoice/cancel/reject/${id}`,
  ];
  let lastErr;
  for (let i = 0; i < endpoints.length; i++) {
    try {
      const response = await axiosInstance.put(endpoints[i], payload, headers);
      return response.data.data;
    } catch (err) {
      lastErr = err;
      const status = err?.response?.status;
      const canFallback =
        i === 0 && (status == null || status === 403 || status === 404 || status === 405 || status >= 500);
      if (!canFallback) break;
    }
  }
  console.error(`Error reject cancel invoice: ${lastErr}`);
  mixpanelErrorTracker.trackError('server error - rejectCancelInvoice', {
    error_message:
      lastErr?.response?.data?.message || lastErr?.message || 'Unknown error',
    function_name: 'rejectCancelInvoice',
    invoice_id: id,
    http_status: lastErr?.response?.status || 'N/A',
    api_endpoint: lastErr?.config?.url || 'N/A',
    request_method: lastErr?.config?.method?.toUpperCase() || 'N/A',
    full_error_response: lastErr?.response?.data || lastErr?.message || 'No details'
  });
  throw lastErr;
}

export async function getEstimatedAmount(payload) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/closeddeal/estimatedAmount`,
      payload,
      headers
    );
    return response.data.data;
  } catch (err) {
    console.error(`Error get estimated amount: ${err}`);
    mixpanelErrorTracker.trackError('server error - getEstimatedAmount', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getEstimatedAmount',
      payload: payload,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function assignUsersByCheckbox(payload) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/liveTask/tasksAssigning`,
      payload,
      headers
    );
    return response.data.data;
  } catch (err) {
    console.error(`Error assign users by checkbox: ${err}`);
    mixpanelErrorTracker.trackError('server error - assignUsersByCheckbox', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'assignUsersByCheckbox',
      payload: payload,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function checkCampaignCreate(id) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/campaign/check/${id}`,
      headers
    );
    return response.data.data;
  } catch (err) {
    console.error(`Error check campaign create: ${err}`);
    mixpanelErrorTracker.trackError('server error - checkCampaignCreate', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'checkCampaignCreate',
      id: id,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function getCheque(id) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/invoices/invoice/cheque?deal_id=${id}`,
      headers
    );
    return response.data.data;
  } catch (err) {
    console.error(`Error get cheque: ${err}`);
    mixpanelErrorTracker.trackError('server error - getCheque', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getCheque',
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function addCheque(payload) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/invoices/cheque`,
      payload,
      headers
    );
    return response.data.data;
  } catch (err) {
    console.error(`Error add cheque: ${err}`);
    mixpanelErrorTracker.trackError('server error - addCheque', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'addCheque',
      payload: payload,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function getSocietyDetails(id) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/invoices/invoice/society?project_id=${id}`,
      headers
    );
    return response.data.data;
  } catch (err) {
    console.error(`Error get society details: ${err}`);
    mixpanelErrorTracker.trackError('server error - getSocietyDetails', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getSocietyDetails',
      project_id: id,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function claimExtraCharges(payload) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/invoices`,
      payload,
      headers
    );
    return response.data.data;
  } catch (err) {
    console.error(`Error claim extra charges: ${err}`);
    mixpanelErrorTracker.trackError('server error - claimExtraCharges', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'claimExtraCharges',
      payload: payload,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function getDealReconcile(dealId) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/invoices/reconcile/${encodeURIComponent(dealId)}`,
      headers
    );
    return response.data.data;
  } catch (err) {
    console.error(`Error get deal reconcile: ${err}`);
    throw err;
  }
}

export async function previewCommonPay(dealId, payload = {}) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/invoices/commonPay/preview/${dealId}`,
      payload,
      headers
    );
    return data.data;
  } catch (err) {
    console.error(`Error preview common pay: ${err}`);
    throw err;
  }
}

export async function retryInvoicePriorities(dealId) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/invoices/retry-priorities/${dealId}`,
      {},
      headers
    );
    return data.data;
  } catch (err) {
    console.error(`Error retry invoice priorities: ${err}`);
    throw err;
  }
}

export async function getStageUnlockState(dealId) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/invoices/stage-unlock/${dealId}`,
      headers
    );
    return data.data;
  } catch (err) {
    console.error(`Error get stage unlock: ${err}`);
    throw err;
  }
}

export async function getAllocationReport(dealId) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/invoices/allocation-report/${dealId}`,
      headers
    );
    return data.data;
  } catch (err) {
    console.error(`Error allocation report: ${err}`);
    throw err;
  }
}

export async function importTallyLedger(payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/invoices/tally-import`,
      payload,
      headers
    );
    return data.data;
  } catch (err) {
    console.error(`Error tally import: ${err}`);
    throw err;
  }
}

export async function verifyLegacyCredit(dealId, payload = {}) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/invoices/verify-legacy-credit/${dealId}`,
      payload,
      headers
    );
    return data.data;
  } catch (err) {
    console.error(`Error verify legacy credit: ${err}`);
    throw err;
  }
}

export async function applyDealCreditBalance(dealId, payload = {}) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/invoices/apply-credit/${encodeURIComponent(dealId)}`,
      payload,
      headers
    );
    return response.data.data;
  } catch (err) {
    console.error(`Error apply deal credit: ${err}`);
    throw err;
  }
}

export async function getTaskTemplates(id, activeTab, worktypName) {
  try {
    const headers = await getHeaders();
    let url = `${APPLICATION_API_BASE_URL}/taskTemplate/template/name?project_id=${encodeURIComponent(
      id
    )}&type=${encodeURIComponent(activeTab)}`;
    if (worktypName) {
      url += `&worktype=${encodeURIComponent(worktypName)}`;
    }
    const response = await axiosInstance.get(url, headers);
    return response.data.data;
  } catch (err) {
    console.error(`Error get task templates: ${err}`);
    mixpanelErrorTracker.trackError('server error - getTaskTemplates', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getTaskTemplates',
      project_id: id,
      type: activeTab,
      worktype_id: worktypName,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function getAllTaskTemplates(activeTab) {
  try {
    const headers = await getHeaders();
    let url = `${APPLICATION_API_BASE_URL}/taskTemplate/template/name?type=${encodeURIComponent(
      activeTab
    )}`;
    const response = await axiosInstance.get(url, headers);
    return response.data.data;
  } catch (err) {
    console.error(`Error get all task templates: ${err}`);
    mixpanelErrorTracker.trackError('server error - getAllTaskTemplates', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getAllTaskTemplates',
      type: activeTab,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function createTaskOtherTemplate(payload) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/taskTemplate/clone/byName`,
      payload,
      headers
    );
    return response.data.data;
  } catch (err) {
    console.error(`Error creating task template: ${err}`);
    mixpanelErrorTracker.trackError('server error - createTaskOtherTemplate', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'createTaskOtherTemplate',
      payload: payload,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function checkDuplicateTaskTemplateName(payload) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/taskTemplate/check`,
      payload,
      headers
    );
    return response.data.data;
  } catch (err) {
    console.error(`Error checking duplicate task template name: ${err}`);
    mixpanelErrorTracker.trackError('server error - checkDuplicateTaskTemplateName', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'checkDuplicateTaskTemplateName',
      payload: payload,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function downloadNoDue(id) {
  try {
    const headers = await getFileHeaders();
    console.log(headers);
    const response = await axiosInstance.get(
      `${DOCGENERATION_API_BASE_URL}/invoices/no-dues/${id}`,
      {
        ...headers,
        responseType: 'arraybuffer'
      }
    );
    return response.data;
  } catch (err) {
    console.error(`Error Getting invoice: ${err}`);
    mixpanelErrorTracker.trackError('server error - downloadNoDue', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'downloadNoDue',
      id: id,
      sourceName: 'No_Due',
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Error fetching invoice');
  }
}

export async function downloadLedger(id) {
  try {
    const headers = await getFileHeaders();
    console.log(headers);
    const response = await axiosInstance.get(
      `${DOCGENERATION_API_BASE_URL}/invoices/ledger/file?deal_id=${id}`,
      {
        ...headers,
        responseType: 'arraybuffer'
      }
    );
    return response.data;
  } catch (err) {
    console.error(`Error Getting invoice: ${err}`);
    mixpanelErrorTracker.trackError('server error - downloadLedger', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'downloadLedger',
      id: id,
      sourceName: 'Ledger',
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Error fetching invoice');
  }
}

export async function getAccountsPriorities(
  page = 1,
  limit = 500,
  projectId = '',
  status = '',
  search = '',
  stageName = ''
) {
  try {
    const headers = await getHeaders();
    let url = `${APPLICATION_API_BASE_URL}/accountPriorities?page=${page}&limit=${limit}`;

    // Add optional query parameters
    if (projectId) {
      url += `&project_id=${projectId}`;
    }
    if (status) {
      url += `&status=${status}`;
    }
    if (search) {
      url += `&search=${encodeURIComponent(search)}`;
    }
    if (stageName) {
      url += `&stageName=${encodeURIComponent(stageName)}`;
    }

    const data = await axiosInstance.get(url, headers);
    return data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - getAccountsPriorities', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getAccountsPriorities',
      page: page,
      limit: limit,
      project_id: projectId,
      status: status,
      search: search,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function updateAccountsPriorities(id, payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.put(
      `${APPLICATION_API_BASE_URL}/accountPriorities/${id}`,
      payload,
      headers
    );
    return data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - updateAccountsPriorities', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'updateAccountsPriorities',
      id: id,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function cancelCreatedLiveTask(payload) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/liveTask/cancel`,
      payload,
      headers
    );
    return response.data.data;
  } catch (err) {
    console.error(`Error canceling created live task: ${err}`);
    mixpanelErrorTracker.trackError('server error - cancelCreatedLiveTask', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'cancelCreatedLiveTask',
      payload: payload,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function downloadLeadTemplate(projectId, salesId, templateType = 'standard') {
  try {
    const headers = await getFileHeaders();
    console.log(headers);
    const url = `${DOCGENERATION_API_BASE_URL}/leads/download/template?project_id=${projectId}&sales_id=${salesId}&template_type=${encodeURIComponent(templateType)}`;
    const response = await axiosInstance.get(url, {
      ...headers,
      responseType: 'arraybuffer'
    });
    return response.data;
  } catch (err) {
    console.error(`Error downloading lead template: ${err}`);
    mixpanelErrorTracker.trackError('server error - downloadLeadTemplate', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'downloadLeadTemplate',
      projectId: projectId,
      salesId: salesId,
      templateType,
      sourceName: 'Lead',
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export const uploadLeadTemplate = async (formData) => {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/leads/upload/template`,
      formData,
      headers
    );
    return data.data;
  } catch (err) {
    console.error(`Error uploading lead template: ${err}`);
    mixpanelErrorTracker.trackError('server error - uploadLeadTemplate', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'uploadLeadTemplate',
      formData: formData,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
};

export async function updateInvoicePayment(id, payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.put(
      `${APPLICATION_API_BASE_URL}/invoices/invoice/history/${id}`,
      payload,
      headers
    );
    return data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - updateInvoicePayment', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown   error',
      function_name: 'updateInvoicePayment',
      id: id,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function uploadProjectAdditionalDocs(payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/project/add/docs`,
      payload,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - uploadProjectAdditionalDocs', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown   error',
      function_name: 'uploadProjectAdditionalDocs',
      payload: payload,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function updateLandAdditionalDocs(payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/land/add/docs`,
      payload,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - updateLandAdditionalDocs', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown   error',
      function_name: 'updateLandAdditionalDocs',
      payload: payload,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function getLandAdditionalDocs(landId) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/land/get/docs?land_id=${landId}`,
      headers
    );
    return response.data.data;
  } catch (err) {
    console.error(`Error downloading lead template: ${err}`);
    mixpanelErrorTracker.trackError('server error - getLandAdditionalDocs', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getLandAdditionalDocs',
      landId: landId,
      sourceName: 'Lead',
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function getProjectAdditionalDocs(projectId) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/project/get/docs?project_id=${projectId}`,
      headers
    );
    return response.data.data;
  } catch (err) {
    console.error(`Error downloading lead template: ${err}`);
    mixpanelErrorTracker.trackError('server error - getProjectAdditionalDocs', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getProjectAdditionalDocs',
      projectId: projectId,
      sourceName: 'Lead',
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function updateInvoiceWaveOff(id, payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.put(
      `${APPLICATION_API_BASE_URL}/invoices/update/${id}`,
      payload,
      headers
    );
    return data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - updateInvoiceWaveOff', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'updateInvoiceWaveOff',
      id: id,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function downloadAccomodationTemplate(projectId) {
  try {
    const headers = await getFileHeaders();
    console.log(headers);
    const url = `${DOCGENERATION_API_BASE_URL}/accomodation/template/download?project_id=${projectId}`;
    const response = await axiosInstance.get(url, {
      ...headers,
      responseType: 'arraybuffer'
    });
    return response.data;
  } catch (err) {
    console.error(`Error downloading accomodation template: ${err}`);
    mixpanelErrorTracker.trackError('server error - downloadAccomodationTemplate', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'downloadAccomodationTemplate',
      projectId: projectId,
      sourceName: 'Accomodation',
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export const uploadAccomodationTemplate = async (formData) => {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/accomodation/template/upload`,
      formData,
      headers
    );
    return data.data;
  } catch (err) {
    console.error(`Error uploading accomodation template: ${err}`);
    mixpanelErrorTracker.trackError('server error - uploadAccomodationTemplate', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'uploadAccomodationTemplate',
      formData: formData,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
};

export async function checkServiceProviderExists(num) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/serviceprovider/byPhone/${num}`,
      headers
    );
    return response.data;
  } catch (err) {
    console.error(`Error downloading lead template: ${err}`);
    mixpanelErrorTracker.trackError('server error - checkServiceProviderExists', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'checkServiceProviderExists',
      num: num,
      sourceName: 'Lead',
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function checkVendorExists(num) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/vendor/byPhone/${num}`,
      headers
    );
    return response.data;
  } catch (err) {
    console.error(`Error downloading lead template: ${err}`);
    mixpanelErrorTracker.trackError('server error - checkVendorExists', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'checkVendorExists',
      num: num,
      sourceName: 'Lead',
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function shareAdditionalDocuments(payload) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/document/email/docs`,
      payload,
      headers
    );
    return response.data.data;
  } catch (err) {
    console.error(`Error share additional documents: ${err}`);
    mixpanelErrorTracker.trackError('server error - shareAdditionalDocuments', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'shareAdditionalDocuments',
      payload: payload,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function createBulkTaskTemplates(payload) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/taskTemplate/create/bulk`,
      payload,
      headers
    );
    return response.data.data;
  } catch (err) {
    console.error(`Error share additional documents: ${err}`);
    mixpanelErrorTracker.trackError('server error - createBulkTaskTemplates', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'createBulkTaskTemplates',
      payload: payload,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function getLowLevelEngineersByProjectId(projectId) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${USERMANAGEMENT_API_BASE_URL}/users?vertical=Operations&project_ids=${projectId}&level=Low&limit=500`,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error getting low level engineers: ${err}`);
    mixpanelErrorTracker.trackError('server error - getLowLevelEngineersByProjectId', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getLowLevelEngineersByProjectId',
      projectId: projectId,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export async function createDuplicateLeads(payload) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/leads/create/duplicates`,
      payload,
      headers
    );
    return response.data.data;
  } catch (err) {
    console.error(`Error creating duplicate leads: ${err}`);
    mixpanelErrorTracker.trackError('server error - createDuplicateLeads', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'createDuplicateLeads',
      payload: payload,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function bulkBookUnits(payload) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/unit/status`,
      payload,
      headers
    );
    return response.data.data;
  } catch (err) {
    console.error(`Error bulk booking units: ${err}`);
    mixpanelErrorTracker.trackError('server error - bulkBookUnits', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'bulkBookUnits',
      payload: payload,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function getPaymentTemplatesByProjectId(projectId) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${USERMANAGEMENT_API_BASE_URL}/paymentTemplate?project_id=${projectId}&limit=500`,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error getting payment templates: ${err}`);
    mixpanelErrorTracker.trackError('server error - getPaymentTemplatesByProjectId', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getPaymentTemplatesByProjectId',
      projectId: projectId,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export async function createPaymentTemplates(payload) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/paymentTemplate`,
      payload,
      headers
    );
    return response.data.data;
  } catch (err) {
    console.error(`Error creating payment templates: ${err}`);
    mixpanelErrorTracker.trackError('server error - createPaymentTemplates', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'createPaymentTemplates',
      payload: payload,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function updatePaymentTemplates(payload, id) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.put(
      `${APPLICATION_API_BASE_URL}/paymentTemplate/${id}`,
      payload,
      headers
    );
    return response.data.data;
  } catch (err) {
    console.error(`Error updating payment templates: ${err}`);
    mixpanelErrorTracker.trackError('server error - updatePaymentTemplates', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'updatePaymentTemplates',
      payload: payload,
      id: id,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function clonePaymentStages(payload) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/payment/clone`,
      payload,
      headers
    );
    return response.data.data;
  } catch (err) {
    console.error(`Error cloning payment stages: ${err}`);
    mixpanelErrorTracker.trackError('server error - clonePaymentStages', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'clonePaymentStages',
      payload: payload,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function getBlocksWithAdvancePaymentStages(projectId) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/payment/fetchBlocks?project_id=${projectId}&limit=500`,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error getting blocks with advance payment stages: ${err}`);
    mixpanelErrorTracker.trackError('server error - getBlocksWithAdvancePaymentStages', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getBlocksWithAdvancePaymentStages',
      projectId: projectId,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export async function getUnitsWithAdvancePaymentStages(projectId) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/payment/fetchUnits?project_id=${projectId}&limit=500`,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error getting units with advance payment stages: ${err}`);
    mixpanelErrorTracker.trackError('server error - getUnitsWithAdvancePaymentStages', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getUnitsWithAdvancePaymentStages',
      projectId: projectId,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export async function fetchUnitsWithStages(projectId) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/payment/fetchUnitsWithStages?project_id=${projectId}&limit=500`,
      headers
    );
    return data.data.data;
  } catch (err) {
    console.error(`Error fetching units with stages: ${err}`);
    mixpanelErrorTracker.trackError('server error - fetchUnitsWithStages', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'fetchUnitsWithStages',
      projectId: projectId,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export async function getManagementOnboardingMap(projectId = null) {
  try {
    const headers = await getHeaders();
    let url = `${USERMANAGEMENT_API_BASE_URL}/managementPriority/onboarding-map`;

    if (projectId) {
      url += `?project_id=${projectId}`;
    }

    const data = await axiosInstance.get(url, headers);
    return data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - getManagementOnboardingMap', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getManagementOnboardingMap',
      project_id: projectId,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export async function getManagementPriorities(projectId = null, type = null, options = {}) {
  try {
    const headers = await getHeaders();
    const { page = 1, limit = 200 } = options;
    let url = `${USERMANAGEMENT_API_BASE_URL}/managementPriority?page=${page}&limit=${limit}`;

    if (projectId) {
      url += `&project_id=${projectId}`;
    }
    if (type) {
      url += `&type=${encodeURIComponent(type)}`;
    }

    const data = await axiosInstance.get(url, headers);
    const payload = data.data;
    warnIfListTruncated('getManagementPriorities', payload?.data, payload?.meta, {
      page,
      limit
    });
    return payload;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - getManagementPriorities', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getManagementPriorities',
      project_id: projectId,
      type: type,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Sales data not loaded');
  }
}

export async function updateManagementPriorities(id, payload) {
  try {
    const headers = await getHeaders();
    let url = `${USERMANAGEMENT_API_BASE_URL}/managementPriority/${id}`;

    const data = await axiosInstance.put(url, payload, headers);
    return data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - updateManagementPriorities', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'updateManagementPriorities',
      id: id,
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Sales data not loaded');
  }
}

/** Notify management to review completed project-structure setup (mid, else primary). */
export async function sendProjectStructureReview(payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.post(
      `${USERMANAGEMENT_API_BASE_URL}/managementPriority/project-structure/review`,
      payload,
      headers
    );
    return data.data;
  } catch (err) {
    console.error(`Error sending project structure review: ${err}`);
    mixpanelErrorTracker.trackError('server error - sendProjectStructureReview', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'sendProjectStructureReview',
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export async function getReportsTargetAchievement(projectId, month) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${USERMANAGEMENT_API_BASE_URL}/management/targetAchievement/${projectId}?month=${month}`,
      headers
    );
    return data.data;
  } catch (err) {
    console.error(`Error loading target achievement data: ${err}`);
    mixpanelErrorTracker.trackError('server error - getReportTargetAchievement', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getReportsTargetAchievement',
      project_id: projectId,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function getReportsDSO(projectId, month) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${USERMANAGEMENT_API_BASE_URL}/management/meetingStats/${projectId}?month=${month}`,
      headers
    );
    return data.data;
  } catch (err) {
    console.error(`Error loading target achievement data: ${err}`);
    mixpanelErrorTracker.trackError('server error - getReportsDSO', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getReportsDSO',
      project_id: projectId,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function getReportsOverdueAgingBucket(projectId, month) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${USERMANAGEMENT_API_BASE_URL}/management/overdueAging/${projectId}?month=${month}`,
      headers
    );
    return data.data;
  } catch (err) {
    console.error(`Error loading target achievement data: ${err}`);
    mixpanelErrorTracker.trackError('server error - getReportsOverdueAgingBucket', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getReportsOverdueAgingBucket',
      project_id: projectId,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function getReportsHelpRequests(projectId, month) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${USERMANAGEMENT_API_BASE_URL}/reason/helpRequest?project_id=${projectId}&month=${month}&limit=500`,
      headers
    );
    return data.data;
  } catch (err) {
    console.error(`Error loading target achievement data: ${err}`);
    mixpanelErrorTracker.trackError('server error - getReportsHelpRequests', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getReportsHelpRequests',
      project_id: projectId,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function addReportsHelpRequest(payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.post(
      `${USERMANAGEMENT_API_BASE_URL}/reason/helpRequest`,
      payload,
      headers
    );
    return data.data;
  } catch (err) {
    console.error(`Error adding help request: ${err}`);
    mixpanelErrorTracker.trackError('server error - addReportsHelpRequest', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'addReportsHelpRequest',
      payload: payload,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function getReportsHotLeadsNotConverted(projectId, month, salesId) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${USERMANAGEMENT_API_BASE_URL}/management/hotLeadsNotConverted/${projectId}?month=${month}&sales_id=${salesId}`,
      headers
    );
    return data.data;
  } catch (err) {
    console.error(`Error loading target achievement data: ${err}`);
    mixpanelErrorTracker.trackError('server error - getReportsHotLeadsNotConverted', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getReportsHotLeadsNotConverted',
      project_id: projectId,
      month: month,
      sales_id: salesId,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function addReportsReason(payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.post(
      `${USERMANAGEMENT_API_BASE_URL}/reason`,
      payload,
      headers
    );
    return data.data;
  } catch (err) {
    console.error(`Error adding reason: ${err}`);
    mixpanelErrorTracker.trackError('server error - addReportsReason', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'addReportsReason',
      payload: payload,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function getReportsReasons(projectId, month) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${USERMANAGEMENT_API_BASE_URL}/reason?project_id=${projectId}&month=${month}&limit=500`,
      headers
    );
    return data.data;
  } catch (err) {
    console.error(`Error loading reasons: ${err}`);
    mixpanelErrorTracker.trackError('server error - getReportsReasons', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getReportsReasons',
      project_id: projectId,
      month: month,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function uploadCloseDealAgreementLetter(id, payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.put(
      `${DOCGENERATION_API_BASE_URL}/closeddeal/addAgreement/${id}`,
      payload,
      headers
    ); // Using API_BASE_URL constant
    const res = data.data;
    return res;
  } catch (err) {
    console.error(`Error upload close deal agreement letter: ${err}`);
    mixpanelErrorTracker.trackError('server error - uploadCloseDealAgreementLetter', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'uploadCloseDealAgreementLetter',
      id: id,
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Error upload close deal agreement letter');
  }
}

export async function addCloseDealLoanDetails(payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.post(
      `${USERMANAGEMENT_API_BASE_URL}/closeddeal/addLoanDetails`,
      payload,
      headers
    );
    return data.data;
  } catch (err) {
    console.error(`Error adding reason: ${err}`);
    mixpanelErrorTracker.trackError('server error - addCloseDealLoanDetails', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'addCloseDealLoanDetails',
      payload: payload,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function getCloseDealLoanDetails(dealId) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/closeddeal/getLoanDetails/${dealId}`,
      headers
    );
    return data.data;
  } catch (err) {
    console.error(`Error loading close deal loan details: ${err}`);
    mixpanelErrorTracker.trackError('server error - getCloseDealLoanDetails', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getCloseDealLoanDetails',
      deal_id: dealId,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}
export async function approveCloseDealLoanDetails(id, payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.put(
      `${APPLICATION_API_BASE_URL}/closeddeal/updateLoanDetails/${id}`,
      payload,
      headers
    ); // Using API_BASE_URL constant
    const res = data.data;
    return res;
  } catch (err) {
    console.error(`Error approve close deal loan details: ${err}`);
    mixpanelErrorTracker.trackError('server error - approveCloseDealLoanDetails', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'approveCloseDealLoanDetails',
      id: id,
      payload: payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Error approve close deal loan details');
  }
}

export async function getClosedDealAttachmentsByDealId(dealId, page = 1, limit = 50) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/closedDealAttachment/deal/${dealId}?limit=${limit}&page=${page}`,
      headers
    );
    return {
      attachments: response.data?.data ?? [],
      meta: response.data?.meta ?? { total: 0, limit, page }
    };
  } catch (err) {
    console.error(`Error loading closed deal attachments: ${err}`);
    mixpanelErrorTracker.trackError('server error - getClosedDealAttachmentsByDealId', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getClosedDealAttachmentsByDealId',
      deal_id: dealId,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export async function getClosedDealAttachmentById(id) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/closedDealAttachment/${id}`,
      headers
    );
    return response.data?.data;
  } catch (err) {
    console.error(`Error loading closed deal attachment: ${err}`);
    mixpanelErrorTracker.trackError('server error - getClosedDealAttachmentById', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getClosedDealAttachmentById',
      id,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export async function createClosedDealAttachment(payload) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/closedDealAttachment`,
      payload,
      headers
    );
    return response.data?.data;
  } catch (err) {
    console.error(`Error creating closed deal attachment: ${err}`);
    mixpanelErrorTracker.trackError('server error - createClosedDealAttachment', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'createClosedDealAttachment',
      payload,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export async function getClosedDealKycStatus(dealId) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/closedDealAttachment/deal/${dealId}/kyc-status`,
      headers
    );
    return response.data?.data ?? response.data;
  } catch (err) {
    mixpanelErrorTracker.trackError('server error - getClosedDealKycStatus', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getClosedDealKycStatus',
      deal_id: dealId,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export async function reverifyClosedDealAttachmentKyc(attachmentId) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/closedDealAttachment/${attachmentId}/reverify`,
      {},
      headers
    );
    return response.data?.data ?? response.data;
  } catch (err) {
    mixpanelErrorTracker.trackError('server error - reverifyClosedDealAttachmentKyc', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'reverifyClosedDealAttachmentKyc',
      attachment_id: attachmentId,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export async function downloadClosedDealAttachment(id) {
  try {
    const headers = await getFileHeaders();
    const response = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/closedDealAttachment/${id}/download`,
      {
        ...headers,
        responseType: 'arraybuffer'
      }
    );
    const disposition = response.headers['content-disposition'] || '';
    let filename = 'attachment';
    const utf8Match = disposition.match(/filename\*=UTF-8''([^;\n]+)/i);
    const plainMatch = disposition.match(/filename="?([^";\n]+)"?/i);
    if (utf8Match) {
      filename = decodeURIComponent(utf8Match[1]);
    } else if (plainMatch) {
      filename = plainMatch[1];
    }
    return {
      data: response.data,
      filename,
      contentType: response.headers['content-type'] || 'application/octet-stream'
    };
  } catch (err) {
    console.error(`Error downloading closed deal attachment: ${err}`);
    mixpanelErrorTracker.trackError('server error - downloadClosedDealAttachment', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'downloadClosedDealAttachment',
      id,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

/* Doc Intelligence — smart upload / extract / map / apply */

function unwrapDocIntelResponse(response) {
  return response.data?.data ?? response.data;
}

export async function uploadDocIntelligenceFile(dealId, file, options = {}) {
  try {
    const headers = await getHeaders();
    const formData = new FormData();
    formData.append('file', file);
    if (dealId != null) {
      formData.append('deal_id', String(dealId));
    }
    if (options.project_id) {
      formData.append('project_id', String(options.project_id));
    }
    if (options.document_kind) {
      formData.append('document_kind', options.document_kind);
    }
    if (options.source_type) {
      formData.append('source_type', options.source_type);
    }
    const response = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/docIntelligence/uploads`,
      formData,
      headers
    );
    return unwrapDocIntelResponse(response);
  } catch (err) {
    mixpanelErrorTracker.trackError('server error - uploadDocIntelligenceFile', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'uploadDocIntelligenceFile',
      deal_id: dealId,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export async function uploadDocIntelligenceProjectFile(projectId, file, options = {}) {
  return uploadDocIntelligenceFile(null, file, {
    project_id: projectId,
    source_type: options.source_type || 'agreement_sample',
    document_kind: options.document_kind || 'sale_agreement',
    ...options
  });
}

export async function getDocIntelligenceProjectUploads(projectId, page = 1, limit = 50) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/docIntelligence/uploads?project_id=${projectId}&page=${page}&limit=${limit}`,
      headers
    );
    return {
      uploads: response.data?.data ?? [],
      meta: response.data?.meta ?? { total: 0, limit, page }
    };
  } catch (err) {
    mixpanelErrorTracker.trackError('server error - getDocIntelligenceProjectUploads', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getDocIntelligenceProjectUploads',
      project_id: projectId,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export async function getDocIntelligenceUploads(dealId, page = 1, limit = 50) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/docIntelligence/uploads?deal_id=${dealId}&page=${page}&limit=${limit}`,
      headers
    );
    return {
      uploads: response.data?.data ?? [],
      meta: response.data?.meta ?? { total: 0, limit, page }
    };
  } catch (err) {
    mixpanelErrorTracker.trackError('server error - getDocIntelligenceUploads', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getDocIntelligenceUploads',
      deal_id: dealId,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export async function getDocIntelligenceUpload(uploadId) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/docIntelligence/uploads/${uploadId}`,
      headers
    );
    return unwrapDocIntelResponse(response);
  } catch (err) {
    mixpanelErrorTracker.trackError('server error - getDocIntelligenceUpload', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getDocIntelligenceUpload',
      upload_id: uploadId,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export async function getDocIntelligenceUploadPreviewUrl(uploadId) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/docIntelligence/uploads/${uploadId}/preview-url`,
      headers
    );
    return unwrapDocIntelResponse(response);
  } catch (err) {
    mixpanelErrorTracker.trackError('server error - getDocIntelligenceUploadPreviewUrl', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getDocIntelligenceUploadPreviewUrl',
      upload_id: uploadId,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export async function reprocessDocIntelligenceUpload(uploadId) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/docIntelligence/uploads/${uploadId}/reprocess`,
      {},
      headers
    );
    return unwrapDocIntelResponse(response);
  } catch (err) {
    mixpanelErrorTracker.trackError('server error - reprocessDocIntelligenceUpload', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'reprocessDocIntelligenceUpload',
      upload_id: uploadId,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export async function discardDocIntelligenceUpload(uploadId, reason) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/docIntelligence/uploads/${uploadId}/discard`,
      reason ? { reason } : {},
      headers
    );
    return unwrapDocIntelResponse(response);
  } catch (err) {
    mixpanelErrorTracker.trackError('server error - discardDocIntelligenceUpload', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'discardDocIntelligenceUpload',
      upload_id: uploadId,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export async function getDocIntelligenceReview(sessionId) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/docIntelligence/reviews/${sessionId}`,
      headers
    );
    return unwrapDocIntelResponse(response);
  } catch (err) {
    mixpanelErrorTracker.trackError('server error - getDocIntelligenceReview', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getDocIntelligenceReview',
      session_id: sessionId,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export async function patchDocIntelligenceReviewFields(sessionId, payload) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.patch(
      `${APPLICATION_API_BASE_URL}/docIntelligence/reviews/${sessionId}/fields`,
      payload,
      headers
    );
    return unwrapDocIntelResponse(response);
  } catch (err) {
    mixpanelErrorTracker.trackError('server error - patchDocIntelligenceReviewFields', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'patchDocIntelligenceReviewFields',
      session_id: sessionId,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export async function approveDocIntelligenceReview(sessionId) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/docIntelligence/reviews/${sessionId}/approve`,
      {},
      headers
    );
    return unwrapDocIntelResponse(response);
  } catch (err) {
    mixpanelErrorTracker.trackError('server error - approveDocIntelligenceReview', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'approveDocIntelligenceReview',
      session_id: sessionId,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export async function rejectDocIntelligenceReview(sessionId, reason) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/docIntelligence/reviews/${sessionId}/reject`,
      reason ? { reason } : {},
      headers
    );
    return unwrapDocIntelResponse(response);
  } catch (err) {
    mixpanelErrorTracker.trackError('server error - rejectDocIntelligenceReview', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'rejectDocIntelligenceReview',
      session_id: sessionId,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export async function suggestDocIntelligenceMappings(sessionId, persist = false) {
  try {
    const headers = await getHeaders();
    const url = `${APPLICATION_API_BASE_URL}/docIntelligence/reviews/${sessionId}/mappings/suggest${
      persist ? '?persist=true' : ''
    }`;
    const response = await axiosInstance.post(url, {}, headers);
    return unwrapDocIntelResponse(response);
  } catch (err) {
    mixpanelErrorTracker.trackError('server error - suggestDocIntelligenceMappings', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'suggestDocIntelligenceMappings',
      session_id: sessionId,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export async function getDocIntelligenceMappings(sessionId) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/docIntelligence/reviews/${sessionId}/mappings`,
      headers
    );
    return unwrapDocIntelResponse(response);
  } catch (err) {
    mixpanelErrorTracker.trackError('server error - getDocIntelligenceMappings', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getDocIntelligenceMappings',
      session_id: sessionId,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export async function saveDocIntelligenceMappings(sessionId, mappings) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.put(
      `${APPLICATION_API_BASE_URL}/docIntelligence/reviews/${sessionId}/mappings`,
      { mappings },
      headers
    );
    return unwrapDocIntelResponse(response);
  } catch (err) {
    mixpanelErrorTracker.trackError('server error - saveDocIntelligenceMappings', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'saveDocIntelligenceMappings',
      session_id: sessionId,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export async function applyDocIntelligenceReview(sessionId) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/docIntelligence/reviews/${sessionId}/apply`,
      {},
      headers
    );
    return unwrapDocIntelResponse(response);
  } catch (err) {
    mixpanelErrorTracker.trackError('server error - applyDocIntelligenceReview', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'applyDocIntelligenceReview',
      session_id: sessionId,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export async function getDocIntelligenceMappingRegistry() {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/docIntelligence/registry/mapping-rules`,
      headers
    );
    return unwrapDocIntelResponse(response);
  } catch (err) {
    mixpanelErrorTracker.trackError('server error - getDocIntelligenceMappingRegistry', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getDocIntelligenceMappingRegistry',
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export async function getDocIntelligenceAgreementBlocks() {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/docIntelligence/registry/agreement-blocks`,
      headers
    );
    return unwrapDocIntelResponse(response);
  } catch (err) {
    mixpanelErrorTracker.trackError('server error - getDocIntelligenceAgreementBlocks', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getDocIntelligenceAgreementBlocks',
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export async function createDocIntelligenceTemplateFromReview(sessionId, name) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/docIntelligence/templates/from-review/${sessionId}`,
      { name },
      headers
    );
    return unwrapDocIntelResponse(response);
  } catch (err) {
    mixpanelErrorTracker.trackError('server error - createDocIntelligenceTemplateFromReview', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'createDocIntelligenceTemplateFromReview',
      session_id: sessionId,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export async function getDocIntelligenceTemplate(templateId) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/docIntelligence/templates/${templateId}`,
      headers
    );
    return unwrapDocIntelResponse(response);
  } catch (err) {
    mixpanelErrorTracker.trackError('server error - getDocIntelligenceTemplate', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getDocIntelligenceTemplate',
      template_id: templateId,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export async function updateDocIntelligenceTemplate(templateId, payload) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.patch(
      `${APPLICATION_API_BASE_URL}/docIntelligence/templates/${templateId}`,
      payload,
      headers
    );
    return unwrapDocIntelResponse(response);
  } catch (err) {
    mixpanelErrorTracker.trackError('server error - updateDocIntelligenceTemplate', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'updateDocIntelligenceTemplate',
      template_id: templateId,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export async function getDocIntelligenceTemplateVersions(templateId) {
  const headers = await getHeaders();
  const response = await axiosInstance.get(
    `${APPLICATION_API_BASE_URL}/docIntelligence/templates/${templateId}/versions`,
    headers
  );
  return unwrapDocIntelResponse(response);
}

export async function restoreDocIntelligenceTemplateVersion(templateId, revisionId) {
  const headers = await getHeaders();
  const response = await axiosInstance.post(
    `${APPLICATION_API_BASE_URL}/docIntelligence/templates/${templateId}/restore`,
    { revision_id: revisionId },
    headers
  );
  return unwrapDocIntelResponse(response);
}

export async function cloneDocIntelligenceTemplate(templateId, projectId, name) {
  const headers = await getHeaders();
  const response = await axiosInstance.post(
    `${APPLICATION_API_BASE_URL}/docIntelligence/templates/${templateId}/clone`,
    { project_id: projectId, ...(name ? { name } : {}) },
    headers
  );
  return unwrapDocIntelResponse(response);
}

export async function confirmDocIntelligenceProjectStatic(templateId, checklist) {
  const headers = await getHeaders();
  const response = await axiosInstance.post(
    `${APPLICATION_API_BASE_URL}/docIntelligence/templates/${templateId}/confirm-project-static`,
    { checklist },
    headers
  );
  return unwrapDocIntelResponse(response);
}

export async function rebuildDocIntelligenceTemplateContent(templateId) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/docIntelligence/templates/${templateId}/rebuild-content`,
      {},
      headers
    );
    return unwrapDocIntelResponse(response);
  } catch (err) {
    mixpanelErrorTracker.trackError('server error - rebuildDocIntelligenceTemplateContent', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'rebuildDocIntelligenceTemplateContent',
      template_id: templateId,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

/** Persist scrub of Katni/MP/stale ₹ leftovers into Tags-view content. */
export async function sanitizeDocIntelligenceTemplate(templateId) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/docIntelligence/templates/${templateId}/sanitize`,
      {},
      headers
    );
    return unwrapDocIntelResponse(response);
  } catch (err) {
    mixpanelErrorTracker.trackError('server error - sanitizeDocIntelligenceTemplate', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'sanitizeDocIntelligenceTemplate',
      template_id: templateId,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export async function previewDocIntelligenceTemplate(templateId, dealId, options = {}) {
  try {
    const headers = await getHeaders();
    const body =
      options.demo === true || !dealId
        ? { demo: true }
        : { deal_id: dealId, demo: false };
    const response = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/docIntelligence/templates/${templateId}/preview`,
      body,
      headers
    );
    return unwrapDocIntelResponse(response);
  } catch (err) {
    mixpanelErrorTracker.trackError('server error - previewDocIntelligenceTemplate', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'previewDocIntelligenceTemplate',
      template_id: templateId,
      deal_id: dealId,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export async function promoteDocIntelligenceTemplate(templateId, { force = false } = {}) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/docIntelligence/templates/${templateId}/promote`,
      { force },
      headers
    );
    return unwrapDocIntelResponse(response);
  } catch (err) {
    mixpanelErrorTracker.trackError('server error - promoteDocIntelligenceTemplate', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'promoteDocIntelligenceTemplate',
      template_id: templateId,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export async function getDocIntelligenceTemplateSampleLeaks(templateId) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/docIntelligence/templates/${templateId}/sample-leaks`,
      headers
    );
    return unwrapDocIntelResponse(response);
  } catch (err) {
    mixpanelErrorTracker.trackError('server error - getDocIntelligenceTemplateSampleLeaks', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getDocIntelligenceTemplateSampleLeaks',
      template_id: templateId,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export async function fixDocIntelligenceTemplateSampleLeaks(templateId, options = {}) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/docIntelligence/templates/${templateId}/fix-sample-leaks`,
      {
        only: options.only,
        skip: options.skip
      },
      headers
    );
    return unwrapDocIntelResponse(response);
  } catch (err) {
    mixpanelErrorTracker.trackError('server error - fixDocIntelligenceTemplateSampleLeaks', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'fixDocIntelligenceTemplateSampleLeaks',
      template_id: templateId,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export async function generateDocIntelligenceTemplate(templateId, dealId) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/docIntelligence/templates/${templateId}/generate`,
      { deal_id: dealId },
      headers
    );
    return unwrapDocIntelResponse(response);
  } catch (err) {
    mixpanelErrorTracker.trackError('server error - generateDocIntelligenceTemplate', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'generateDocIntelligenceTemplate',
      template_id: templateId,
      deal_id: dealId,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export async function listDocIntelligenceTemplates(projectId, page = 1, limit = 50) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/docIntelligence/templates?project_id=${projectId}&page=${page}&limit=${limit}`,
      headers
    );
    return {
      templates: response.data?.data ?? [],
      meta: response.data?.meta ?? { total: 0, limit, page }
    };
  } catch (err) {
    mixpanelErrorTracker.trackError('server error - listDocIntelligenceTemplates', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'listDocIntelligenceTemplates',
      project_id: projectId,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export async function deleteDocIntelligenceTemplate(templateId, options = {}) {
  try {
    const headers = await getHeaders();
    const keep = options.keepLinked ? '?keep_linked=true' : '';
    const response = await axiosInstance.delete(
      `${APPLICATION_API_BASE_URL}/docIntelligence/templates/${templateId}${keep}`,
      headers
    );
    return unwrapDocIntelResponse(response);
  } catch (err) {
    mixpanelErrorTracker.trackError('server error - deleteDocIntelligenceTemplate', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'deleteDocIntelligenceTemplate',
      template_id: templateId,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

export async function downloadCloseDealAgreementLetter(id) {
  try {
    const headers = await getFileHeaders();
    const response = await axiosInstance.get(
      `${DOCGENERATION_API_BASE_URL}/closeddeal/getAgreement/${id}`,
      {
        ...headers,
        responseType: 'arraybuffer'
      }
    );
    return response.data;
  } catch (err) {
    console.error(`Error downloading close deal agreement letter: ${err}`);
    mixpanelErrorTracker.trackError('server error - downloadCloseDealAgreementLetter', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'downloadCloseDealAgreementLetter',
      id: id,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function getAllUsersByProjectId(projectId = null, page = 1, limit = 500) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${USERMANAGEMENT_API_BASE_URL}/users?project_ids=${projectId},&page=${page}&limit=${limit}`,
      headers
    );
    return data.data;
  } catch (err) {
    console.error(`Error loading data: ${err}`);
    mixpanelErrorTracker.trackError('server error - getAllUsersByProjectId', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getAllUsersByProjectId',
      project_id: projectId,
      page: page,
      limit: limit,
      http_status: err?.response?.status || 'N/A'
    });
    throw err; // throw new Error('Sales data not loaded');
  }
}

export async function completeMeetingReport(payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.post(
      `${USERMANAGEMENT_API_BASE_URL}/reason/reviewMeeting`,
      payload,
      headers
    );
    return data.data;
  } catch (err) {
    console.error(`Error adding reason: ${err}`);
    mixpanelErrorTracker.trackError('server error - completeMeetingReport', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'completeMeetingReport',
      payload: payload,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function getMeetingReport(projectId, month) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${USERMANAGEMENT_API_BASE_URL}/reason/reviewMeeting?project_id=${projectId}&month=${month}`,
      headers
    );
    return data.data;
  } catch (err) {
    console.error(`Error adding reason: ${err}`);
    mixpanelErrorTracker.trackError('server error - getMeetingReport', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getMeetingReport',
      project_id: projectId,
      month: month,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function getInventoryAnalysis(projectId, month) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${USERMANAGEMENT_API_BASE_URL}/management/inventoryAnalysis/${projectId}&month=${month}`,
      headers
    );
    return data.data;
  } catch (err) {
    console.error(`Error adding reason: ${err}`);
    mixpanelErrorTracker.trackError('server error - getInventoryAnalysis', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getInventoryAnalysis',
      project_id: projectId,
      month: month,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function getSetTargetLeadData(projectId, month) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${USERMANAGEMENT_API_BASE_URL}/management/leadData/${projectId}&month=${month}`,
      headers
    );
    return data.data;
  } catch (err) {
    console.error(`Error adding reason: ${err}`);
    mixpanelErrorTracker.trackError('server error - getSetTargetLeadData', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getSetTargetLeadData',
      project_id: projectId,
      month: month,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function updateFollowUpDate(id, payload) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.put(
      `${APPLICATION_API_BASE_URL}/followup/update/${id}`,
      payload,
      headers
    );
    return response.data.data;
  } catch (err) {
    console.error(`Error updating follow up date: ${err}`);
    mixpanelErrorTracker.trackError('server error - updateFollowUpDate', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'updateFollowUpDate',
      follow_up_id: id,
      payload: payload,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function getOperationsDailyStats(projectId, reportRunDate) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/operationStats/today-stats?projectId=${projectId}&reportRunDate=${reportRunDate}`,
      headers
    );
    return response.data.data;
  } catch (err) {
    console.error(`Error loading operations daily stats: ${err}`);
    mixpanelErrorTracker.trackError('server error - getOperationsDailyStats', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getOperationsDailyStats',
      projectId: projectId,
      reportRunDate: reportRunDate,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function getOperationsWeeklyStats(projectId, reportRunDate) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/operationStats/weekly-stats?projectId=${projectId}&reportRunDate=${reportRunDate}`,
      headers
    );
    return response.data.data;
  } catch (err) {
    console.error(`Error loading operations weekly stats: ${err}`);
    mixpanelErrorTracker.trackError('server error - getOperationsWeeklyStats', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getOperationsWeeklyStats',
      projectId: projectId,
      reportRunDate: reportRunDate,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function getOperationsMonthlyStats(projectId, reportRunDate) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/operationStats/monthly-stats/?projectId=${projectId}&reportRunDate=${reportRunDate}`,
      headers
    );
    return response.data;
  } catch (err) {
    console.error(`Error loading operations monthly stats: ${err}`);
    mixpanelErrorTracker.trackError('server error - getOperationsMonthlyStats', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getOperationsMonthlyStats',
      projectId: projectId,
      reportRunDate: reportRunDate,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function getOperationsMonthlyInventoryStats(projectId, reportRunDate) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/operationStats/monthly-inventory-stats/?projectId=${projectId}&reportRunDate=${reportRunDate}`,
      headers
    );
    return response.data;
  } catch (err) {
    console.error(`Error loading operations monthly inventory stats: ${err}`);
    mixpanelErrorTracker.trackError('server error - getOperationsMonthlyInventoryStats', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getOperationsMonthlyInventoryStats',
      projectId: projectId,
      reportRunDate: reportRunDate,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function getUniversalMeasurement(companyId) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/universalMeasurement?company_id=${companyId}`,
      headers
    );
    return response?.data?.data || [];
  } catch (err) {
    console.error(`Error loading universal measurement: ${err}`);
    mixpanelErrorTracker.trackError('server error - getUniversalMeasurement', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getUniversalMeasurement',
      company_id: companyId,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function getUniversalMeasurementByProject(projectId) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/universalMeasurement/project/${projectId}`,
      headers
    );
    return response?.data?.data || [];
  } catch (err) {
    console.error(`Error loading universal measurement by project: ${err}`);
    mixpanelErrorTracker.trackError('server error - getUniversalMeasurementByProject', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getUniversalMeasurementByProject',
      project_id: projectId,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function addUniversalMeasurement(payload) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/universalMeasurement`,
      payload,
      headers
    );
    return response.data;
  } catch (err) {
    console.error(`Error adding universal measurement: ${err}`);
    mixpanelErrorTracker.trackError('server error - addUniversalMeasurement', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'addUniversalMeasurement',
      payload: payload,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function updateBoqOption(optionId, payload) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.put(
      `${APPLICATION_API_BASE_URL}/boq/option/${optionId}`,
      payload,
      headers
    );
    return response.data;
  } catch (err) {
    console.error(`Error updating BOQ option: ${err}`);
    mixpanelErrorTracker.trackError('server error - updateBoqOption', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'updateBoqOption',
      option_id: optionId,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function updateBoqQuestion(questionId, payload) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.put(
      `${APPLICATION_API_BASE_URL}/boq/question/${questionId}`,
      payload,
      headers
    );
    return response.data;
  } catch (err) {
    console.error(`Error updating BOQ question: ${err}`);
    mixpanelErrorTracker.trackError('server error - updateBoqQuestion', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'updateBoqQuestion',
      question_id: questionId,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function generateBom(accommodationId, boqId, combinationCount = 2, options = {}) {
  try {
    const headers = await getHeaders();
    const body = {
      accommodation_id: accommodationId,
      boq_id: boqId,
      combination_count: combinationCount
    };
    if (options.type) body.type = options.type;

    const response = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/boq/bom/generate`,
      body,
      headers
    );
    return response.data;
  } catch (err) {
    console.error(`Error generating BOM: ${err}`);
    mixpanelErrorTracker.trackError('server error - generateBom', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'generateBom',
      accommodation_id: accommodationId,
      boq_id: boqId,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function updateBomMaterial(materialRowId, patch) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.put(
      `${APPLICATION_API_BASE_URL}/boq/bom/material/${materialRowId}`,
      patch,
      headers
    );
    return response.data;
  } catch (err) {
    console.error(`Error updating BOM material: ${err}`);
    mixpanelErrorTracker.trackError('server error - updateBomMaterial', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'updateBomMaterial',
      material_row_id: materialRowId,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function syncBomWithTask(payload) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/boq/bom/sync`,
      payload,
      headers
    );
    return response.data;
  } catch (err) {
    console.error(`Error syncing BOM with task: ${err}`);
    mixpanelErrorTracker.trackError('server error - syncBomWithTask', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'syncBomWithTask',
      unit_id: payload?.unit_id,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function getBomSyncStatus(accommodationId) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/boq/bom/sync/status`,
      {
        ...headers,
        params: { accommodation_id: accommodationId }
      }
    );
    return response.data;
  } catch (err) {
    console.error(`Error fetching BOM sync status: ${err}`);
    mixpanelErrorTracker.trackError('server error - getBomSyncStatus', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getBomSyncStatus',
      accommodation_id: accommodationId,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function getSavedBom(accommodationId) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/boq/bom?accommodation_id=${accommodationId}`,
      headers
    );
    return response.data;
  } catch (err) {
    if (err?.response?.status === 404) {
      return null;
    }
    console.error(`Error fetching saved BOM: ${err}`);
    mixpanelErrorTracker.trackError('server error - getSavedBom', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getSavedBom',
      accommodation_id: accommodationId,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function applyBomCosting(payload) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/boq/bom/applyCosting`,
      payload,
      headers
    );
    return response.data;
  } catch (err) {
    console.error(`Error applying BOM costing: ${err}`);
    mixpanelErrorTracker.trackError('server error - applyBomCosting', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'applyBomCosting',
      accommodation_id: payload?.accommodation_id,
      boq_id: payload?.boq_id,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function getProjectCommonBoq(projectId) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/boq/project-common/boq`,
      {
        ...headers,
        params: { project_id: projectId }
      }
    );
    return response.data;
  } catch (err) {
    if (err?.response?.status === 404) {
      return null;
    }
    console.error(`Error fetching project common BOQ: ${err}`);
    mixpanelErrorTracker.trackError('server error - getProjectCommonBoq', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getProjectCommonBoq',
      project_id: projectId,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function getProjectCommonBom(projectId) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/boq/project-common/bom`,
      {
        ...headers,
        params: { project_id: projectId }
      }
    );
    return response.data;
  } catch (err) {
    if (err?.response?.status === 404) {
      return null;
    }
    console.error(`Error fetching project common BOM: ${err}`);
    mixpanelErrorTracker.trackError('server error - getProjectCommonBom', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getProjectCommonBom',
      project_id: projectId,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function getBoqBomPresence(projectId) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/boq/check/presence`,
      {
        ...headers,
        params: { project_id: projectId }
      }
    );
    return response.data?.data ?? null;
  } catch (err) {
    console.error(`Error fetching BOQ/BOM presence: ${err}`);
    mixpanelErrorTracker.trackError('server error - getBoqBomPresence', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getBoqBomPresence',
      project_id: projectId,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function checkBoqPresent(projectId) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/boq/check/boqPresent`,
      {
        ...headers,
        params: { project_id: projectId }
      }
    );
    return response.data?.data ?? [];
  } catch (err) {
    console.error(`Error checking BOQ presence: ${err}`);
    mixpanelErrorTracker.trackError('server error - checkBoqPresent', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'checkBoqPresent',
      project_id: projectId,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function checkBomPresent(projectId) {
  try {
    const headers = await getHeaders();
    const response = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/boq/check/bomPresent`,
      {
        ...headers,
        params: { project_id: projectId }
      }
    );
    return response.data?.data ?? [];
  } catch (err) {
    console.error(`Error checking BOM presence: ${err}`);
    mixpanelErrorTracker.trackError('server error - checkBomPresent', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'checkBomPresent',
      project_id: projectId,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function getBoq(accommodationId, options = {}) {
  try {
    const headers = await getHeaders();
    const params = { accommodation_id: accommodationId };
    if (options.type) params.type = options.type;

    const response = await axiosInstance.get(`${APPLICATION_API_BASE_URL}/boq`, {
      ...headers,
      params
    });
    return response.data;
  } catch (err) {
    if (err?.response?.status === 404) {
      return null;
    }
    console.error(`Error fetching BOQ: ${err}`);
    mixpanelErrorTracker.trackError('server error - getBoq', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getBoq',
      accommodation_id: accommodationId,
      boq_type: options?.type,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function generateBoq(accommodationId, options = {}) {
  try {
    const headers = await getHeaders();
    const body = {};

    if (options.projectId != null) {
      body.type = options.type ?? 'ProjectCommon';
      body.project_id = options.projectId;
      if (Array.isArray(options.workTypeIds)) {
        body.work_type_ids = options.workTypeIds;
      }
    } else {
      body.accommodation_id = accommodationId;
      if (options.type) body.type = options.type;
    }

    const response = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/boq/generate`,
      body,
      headers
    );
    return response.data;
  } catch (err) {
    console.error(`Error generating BOQ: ${err}`);
    mixpanelErrorTracker.trackError('server error - generateBoq', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'generateBoq',
      accommodation_id: accommodationId,
      project_id: options?.projectId,
      work_type_ids: options?.workTypeIds,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function getBoqQuestions(accommodationId, options = {}) {
  try {
    const headers = await getHeaders();
    const params = {};

    if (options.projectId != null) {
      params.project_id = options.projectId;
      if (options.intelligenceScope) params.intelligence_scope = options.intelligenceScope;
    } else {
      params.accommodation_id = accommodationId;
      if (options.intelligenceScope) params.intelligence_scope = options.intelligenceScope;
    }

    const response = await axiosInstance.get(`${APPLICATION_API_BASE_URL}/boq/questions`, {
      ...headers,
      params
    });
    return response.data;
  } catch (err) {
    console.error(`Error fetching BOQ questions: ${err}`);
    mixpanelErrorTracker.trackError('server error - getBoqQuestions', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getBoqQuestions',
      accommodation_id: accommodationId,
      project_id: options?.projectId,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function extractBoqData(accommodationId, files = [], options = {}) {
  try {
    const headers = await getHeaders();
    const formData = new FormData();

    (files ?? []).forEach((file) => {
      formData.append('files', file);
    });

    if (options.projectId != null) {
      formData.append('project_id', String(options.projectId));
      if (options.intelligenceScope) {
        formData.append('intelligence_scope', options.intelligenceScope);
      }
      if (Array.isArray(options.workTypeIds)) {
        options.workTypeIds.forEach((id) => {
          formData.append('work_type_ids[]', String(id));
        });
      }
    } else if (accommodationId != null) {
      formData.append('accommodation_id', String(accommodationId));
      if (options.intelligenceScope) {
        formData.append('intelligence_scope', options.intelligenceScope);
      }
    }

    if (options.useAllDrawings === true) {
      formData.append('use_all_drawings', 'true');
    } else if (options.useAllDrawings === false) {
      formData.append('use_all_drawings', 'false');
    }

    if (Array.isArray(options.drawingFileKeys) && options.drawingFileKeys.length > 0) {
      formData.append('drawing_file_keys', JSON.stringify(options.drawingFileKeys));
    }

    const response = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/boq/extractData`,
      formData,
      headers
    );

    if (response.status !== 202) {
      const message =
        response.data?.message || `Unexpected extract response status: ${response.status}`;
      throw new Error(message);
    }

    return response.data;
  } catch (err) {
    console.error(`Error extracting BOQ data: ${err}`);
    mixpanelErrorTracker.trackError('server error - extractBoqData', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'extractBoqData',
      accommodation_id: accommodationId,
      project_id: options?.projectId,
      work_type_ids: options?.workTypeIds,
      use_all_drawings: options?.useAllDrawings,
      drawing_file_keys_count: options?.drawingFileKeys?.length ?? 0,
      file_count: files?.length ?? 0,
      http_status: err?.response?.status || 'N/A',
      api_endpoint: err?.config?.url || 'N/A',
      request_method: err?.config?.method?.toUpperCase() || 'N/A',
      full_error_response: err?.response?.data || err?.message || 'No details'
    });
    throw err;
  }
}

export async function getBoqExtractDataStatus(jobId) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/boq/extractData/status/${jobId}`,
      headers
    );
    return data.data;
  } catch (err) {
    console.error(`Error loading BOQ extract job status: ${err}`);
    mixpanelErrorTracker.trackError('server error - getBoqExtractDataStatus', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getBoqExtractDataStatus',
      jobId,
      http_status: err?.response?.status || 'N/A'
    });
    throw err;
  }
}

// --- AI Insights ---

export async function getAiDashboardPulse(projectId = null, vertical = null, surface = null) {
  try {
    const headers = await getHeaders();
    const params = new URLSearchParams();
    const normalizedProjectId =
      projectId === null || projectId === undefined || String(projectId).trim() === ''
        ? null
        : projectId;
    if (normalizedProjectId) params.set('project_id', String(normalizedProjectId));
    if (vertical) params.set('vertical', vertical);
    if (surface) params.set('surface', surface);
    const qs = params.toString();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/aiInsights/pulse/dashboard${qs ? `?${qs}` : ''}`,
      headers
    );
    return data.data.data;
  } catch (err) {
    mixpanelErrorTracker.trackError('server error - getAiDashboardPulse', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getAiDashboardPulse',
      project_id: projectId
    });
    throw err;
  }
}

/** Housingram Brain chat — config-driven surfaces (ops_template_chat, …). */
export async function chatBrainAi({
  surface,
  vertical = null,
  projectId = null,
  messages = [],
  contextHints = null
}) {
  try {
    const headers = await getHeaders();
    const normalizedProjectId =
      projectId === null || projectId === undefined || String(projectId).trim() === ''
        ? null
        : Number(projectId);
    const data = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/aiInsights/brain/chat`,
      {
        surface,
        vertical,
        projectId: Number.isFinite(normalizedProjectId) ? normalizedProjectId : null,
        messages,
        contextHints: contextHints || undefined
      },
      headers
    );
    return data.data.data;
  } catch (err) {
    mixpanelErrorTracker.trackError('server error - chatBrainAi', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'chatBrainAi',
      surface,
      project_id: projectId
    });
    throw err;
  }
}

/** Persist SOP / project doc text into ai_embeddings (source_type = project_doc). */
export async function ingestBrainDocAi({
  content,
  fileName = 'document',
  projectId = null
}) {
  try {
    const headers = await getHeaders();
    const normalizedProjectId =
      projectId === null || projectId === undefined || String(projectId).trim() === ''
        ? null
        : Number(projectId);
    const data = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/aiInsights/brain/docs/ingest`,
      {
        content,
        fileName,
        projectId: Number.isFinite(normalizedProjectId) ? normalizedProjectId : null
      },
      headers
    );
    return data.data.data;
  } catch (err) {
    mixpanelErrorTracker.trackError('server error - ingestBrainDocAi', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'ingestBrainDocAi',
      project_id: projectId
    });
    throw err;
  }
}

export async function getAllAiLeadsSummaryRows(projectId = null) {
  const allRows = [];
  let page = 1;
  const limit = 100;
  while (page <= 50) {
    const data = await getAiLeadsSummary(projectId, page, limit);
    const rows = data?.rows || [];
    allRows.push(...rows);
    if (rows.length < limit) break;
    page += 1;
  }
  return allRows;
}

export async function getAiLeadsSummary(projectId = null, page = 1, limit = 50) {
  try {
    const headers = await getHeaders();
    const params = new URLSearchParams({ page: String(page), limit: String(limit) });
    const normalizedProjectId =
      projectId === null || projectId === undefined || String(projectId).trim() === ''
        ? null
        : projectId;
    if (normalizedProjectId) params.set('project_id', String(normalizedProjectId));
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/aiInsights/leads/summary?${params.toString()}`,
      headers
    );
    return data.data.data;
  } catch (err) {
    mixpanelErrorTracker.trackError('server error - getAiLeadsSummary', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getAiLeadsSummary',
      project_id: projectId
    });
    throw err;
  }
}

export async function validateStageQualificationAnswers(stageQualification) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/leadStageQualification/validate`,
      stageQualification,
      headers
    );
    return data.data.data;
  } catch (err) {
    mixpanelErrorTracker.trackError('server error - validateStageQualificationAnswers', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'validateStageQualificationAnswers'
    });
    throw err;
  }
}

export async function getStageQualificationHints(leadId, transition) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/leadStageQualification/hints?leadId=${leadId}&transition=${encodeURIComponent(transition)}`,
      headers
    );
    return data.data.data;
  } catch (err) {
    mixpanelErrorTracker.trackError('server error - getStageQualificationHints', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getStageQualificationHints',
      lead_id: leadId
    });
    throw err;
  }
}

export async function getStageQualificationRequired(leadId, targetStage) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/leadStageQualification/required?leadId=${leadId}&targetStage=${encodeURIComponent(targetStage)}`,
      headers
    );
    return data.data.data;
  } catch (err) {
    mixpanelErrorTracker.trackError('server error - getStageQualificationRequired', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getStageQualificationRequired',
      lead_id: leadId
    });
    throw err;
  }
}

export async function getStageQualificationSchema(transition, leadId = null) {
  try {
    const headers = await getHeaders();
    const leadQuery =
      leadId != null && leadId !== ''
        ? `?leadId=${encodeURIComponent(leadId)}`
        : '';
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/leadStageQualification/schema/${transition}${leadQuery}`,
      headers
    );
    return data.data.data;
  } catch (err) {
    mixpanelErrorTracker.trackError('server error - getStageQualificationSchema', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getStageQualificationSchema',
      transition
    });
    throw err;
  }
}

export async function getLatestStageQualification(leadId) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/leadStageQualification/latest?leadId=${leadId}`,
      headers
    );
    return data.data.data?.latest ?? null;
  } catch (err) {
    mixpanelErrorTracker.trackError('server error - getLatestStageQualification', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getLatestStageQualification',
      lead_id: leadId
    });
    throw err;
  }
}

export async function getLeadQualificationQuestions() {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/leadQualificationQuestions`,
      headers
    );
    return data.data.data;
  } catch (err) {
    mixpanelErrorTracker.trackError('server error - getLeadQualificationQuestions', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getLeadQualificationQuestions'
    });
    throw err;
  }
}

export async function createLeadQualificationQuestion(payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/leadQualificationQuestions`,
      payload,
      headers
    );
    return data.data.data;
  } catch (err) {
    mixpanelErrorTracker.trackError('server error - createLeadQualificationQuestion', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'createLeadQualificationQuestion'
    });
    throw err;
  }
}

export async function updateLeadQualificationQuestion(id, payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.patch(
      `${APPLICATION_API_BASE_URL}/leadQualificationQuestions/${id}`,
      payload,
      headers
    );
    return data.data.data;
  } catch (err) {
    mixpanelErrorTracker.trackError('server error - updateLeadQualificationQuestion', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'updateLeadQualificationQuestion',
      id
    });
    throw err;
  }
}

export async function deleteLeadQualificationQuestion(id) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.delete(
      `${APPLICATION_API_BASE_URL}/leadQualificationQuestions/${id}`,
      headers
    );
    return data.data.data;
  } catch (err) {
    mixpanelErrorTracker.trackError('server error - deleteLeadQualificationQuestion', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'deleteLeadQualificationQuestion',
      id
    });
    throw err;
  }
}

export async function seedLeadQualificationQuestionDefaults() {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/leadQualificationQuestions/seed-defaults`,
      {},
      headers
    );
    return data.data.data;
  } catch (err) {
    mixpanelErrorTracker.trackError('server error - seedLeadQualificationQuestionDefaults', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'seedLeadQualificationQuestionDefaults'
    });
    throw err;
  }
}

export async function getStageQualificationProfile(leadId) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/leadStageQualification/profile?leadId=${leadId}`,
      headers
    );
    return data.data.data ?? { cards: [], sections: [], latestFollowUpAt: null };
  } catch (err) {
    mixpanelErrorTracker.trackError('server error - getStageQualificationProfile', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getStageQualificationProfile',
      lead_id: leadId
    });
    throw err;
  }
}

export async function updateStageQualificationProfile(payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.patch(
      `${APPLICATION_API_BASE_URL}/leadStageQualification/profile`,
      payload,
      headers
    );
    return data.data.data ?? { cards: [], sections: [], latestFollowUpAt: null };
  } catch (err) {
    mixpanelErrorTracker.trackError('server error - updateStageQualificationProfile', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'updateStageQualificationProfile',
      lead_id: payload?.leadId
    });
    throw err;
  }
}

export async function buildStageQualificationJustificationDraft(leadId, transition, answers) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/leadStageQualification/justification-draft`,
      { leadId, transition, answers },
      headers
    );
    return data.data.data?.draft ?? '';
  } catch (err) {
    mixpanelErrorTracker.trackError('server error - buildStageQualificationJustificationDraft', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'buildStageQualificationJustificationDraft',
      lead_id: leadId
    });
    throw err;
  }
}

export async function submitKeepLeadActiveQualification(leadId, stageQualification) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/leadStageQualification/keep-active`,
      { leadId, stageQualification },
      headers
    );
    return data.data.data;
  } catch (err) {
    mixpanelErrorTracker.trackError('server error - submitKeepLeadActiveQualification', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'submitKeepLeadActiveQualification',
      lead_id: leadId
    });
    throw err;
  }
}

export async function getAiLeadInsight(leadId) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/aiInsights/leads/${leadId}`,
      headers
    );
    return data.data.data;
  } catch (err) {
    mixpanelErrorTracker.trackError('server error - getAiLeadInsight', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getAiLeadInsight',
      lead_id: leadId
    });
    throw err;
  }
}

export async function refreshAiLeadInsight(leadId) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/aiInsights/leads/${leadId}/refresh`,
      {},
      headers
    );
    return data.data.data;
  } catch (err) {
    mixpanelErrorTracker.trackError('server error - refreshAiLeadInsight', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'refreshAiLeadInsight',
      lead_id: leadId
    });
    throw err;
  }
}

export async function getAiLeadWhatsappTemplates(leadId) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/aiInsights/leads/${leadId}/whatsapp/templates`,
      headers
    );
    return data.data.data;
  } catch (err) {
    mixpanelErrorTracker.trackError('server error - getAiLeadWhatsappTemplates', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getAiLeadWhatsappTemplates',
      lead_id: leadId
    });
    throw err;
  }
}

export async function draftAiWhatsAppMessage(leadId, payload = {}) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/aiInsights/leads/${leadId}/whatsapp/draft`,
      payload,
      headers
    );
    return data.data.data;
  } catch (err) {
    mixpanelErrorTracker.trackError('server error - draftAiWhatsAppMessage', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'draftAiWhatsAppMessage',
      lead_id: leadId
    });
    throw err;
  }
}

export async function sendAiWhatsAppMessage(leadId, payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/aiInsights/leads/${leadId}/whatsapp/send`,
      payload,
      headers
    );
    return data.data.data;
  } catch (err) {
    mixpanelErrorTracker.trackError('server error - sendAiWhatsAppMessage', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'sendAiWhatsAppMessage',
      lead_id: leadId
    });
    throw err;
  }
}

export async function translateAiLeadContent(leadId, payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/aiInsights/leads/${leadId}/translate`,
      payload,
      headers
    );
    return data.data.data;
  } catch (err) {
    mixpanelErrorTracker.trackError('server error - translateAiLeadContent', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'translateAiLeadContent',
      lead_id: leadId
    });
    throw err;
  }
}

export async function getAiLeadTranslations(leadId, limit = 20) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/aiInsights/leads/${leadId}/translations?limit=${limit}`,
      headers
    );
    return data.data.data;
  } catch (err) {
    mixpanelErrorTracker.trackError('server error - getAiLeadTranslations', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getAiLeadTranslations',
      lead_id: leadId
    });
    throw err;
  }
}

export async function getAiSupportedLanguages() {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/aiInsights/languages`,
      headers
    );
    return data.data.data;
  } catch (err) {
    mixpanelErrorTracker.trackError('server error - getAiSupportedLanguages', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getAiSupportedLanguages'
    });
    throw err;
  }
}

export async function getMyAiCredits() {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/builderAiCredits/me`,
      headers
    );
    return data.data.data;
  } catch (err) {
    mixpanelErrorTracker.trackError('server error - getMyAiCredits', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getMyAiCredits'
    });
    throw err;
  }
}

export async function getAiProviderSettings() {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/builderAiCredits/provider`,
      headers
    );
    return data.data.data;
  } catch (err) {
    mixpanelErrorTracker.trackError('server error - getAiProviderSettings', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getAiProviderSettings'
    });
    throw err;
  }
}

export async function getAiProviderOptions() {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/builderAiCredits/providers`,
      headers
    );
    return data.data.data;
  } catch (err) {
    mixpanelErrorTracker.trackError('server error - getAiProviderOptions', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getAiProviderOptions'
    });
    throw err;
  }
}

export async function updateAiProviderSettings(payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.put(
      `${APPLICATION_API_BASE_URL}/builderAiCredits/provider`,
      payload,
      headers
    );
    return data.data.data;
  } catch (err) {
    mixpanelErrorTracker.trackError('server error - updateAiProviderSettings', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'updateAiProviderSettings'
    });
    throw err;
  }
}

export async function updateAiTranslationLanguages(languages) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.put(
      `${APPLICATION_API_BASE_URL}/builderAiCredits/translation-languages`,
      { languages },
      headers
    );
    return data.data.data;
  } catch (err) {
    mixpanelErrorTracker.trackError('server error - updateAiTranslationLanguages', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'updateAiTranslationLanguages'
    });
    throw err;
  }
}

export async function getAiTeamUserLimits() {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/builderAiCredits/user-limits`,
      headers
    );
    return data.data.data;
  } catch (err) {
    mixpanelErrorTracker.trackError('server error - getAiTeamUserLimits', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getAiTeamUserLimits'
    });
    throw err;
  }
}

export async function updateAiTeamUserLimit(userId, payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.put(
      `${APPLICATION_API_BASE_URL}/builderAiCredits/user-limits/${userId}`,
      payload,
      headers
    );
    return data.data.data;
  } catch (err) {
    mixpanelErrorTracker.trackError('server error - updateAiTeamUserLimit', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'updateAiTeamUserLimit',
      user_id: userId
    });
    throw err;
  }
}

export async function requestAiCreditsRecharge(payload = {}) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/builderAiCredits/request-recharge`,
      payload,
      headers
    );
    return data.data.data;
  } catch (err) {
    mixpanelErrorTracker.trackError('server error - requestAiCreditsRecharge', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'requestAiCreditsRecharge'
    });
    throw err;
  }
}

export async function draftAiEmailMessage(leadId, payload = {}) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/aiInsights/leads/${leadId}/email/draft`,
      payload,
      headers
    );
    return data.data.data;
  } catch (err) {
    mixpanelErrorTracker.trackError('server error - draftAiEmailMessage', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'draftAiEmailMessage',
      lead_id: leadId
    });
    throw err;
  }
}

export async function sendAiEmailMessage(leadId, payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/aiInsights/leads/${leadId}/email/send`,
      payload,
      headers
    );
    return data.data.data;
  } catch (err) {
    mixpanelErrorTracker.trackError('server error - sendAiEmailMessage', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'sendAiEmailMessage',
      lead_id: leadId
    });
    throw err;
  }
}

export async function scheduleAiOutboundMessage(leadId, payload) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.post(
      `${APPLICATION_API_BASE_URL}/aiInsights/leads/${leadId}/outbound/schedule`,
      payload,
      headers
    );
    return data.data.data;
  } catch (err) {
    mixpanelErrorTracker.trackError('server error - scheduleAiOutboundMessage', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'scheduleAiOutboundMessage',
      lead_id: leadId
    });
    throw err;
  }
}

export async function getAiScheduledOutbound(leadId) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.get(
      `${APPLICATION_API_BASE_URL}/aiInsights/leads/${leadId}/outbound/scheduled`,
      headers
    );
    return data.data.data;
  } catch (err) {
    mixpanelErrorTracker.trackError('server error - getAiScheduledOutbound', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'getAiScheduledOutbound',
      lead_id: leadId
    });
    throw err;
  }
}

export async function cancelAiScheduledOutbound(leadId, scheduleId) {
  try {
    const headers = await getHeaders();
    const data = await axiosInstance.delete(
      `${APPLICATION_API_BASE_URL}/aiInsights/leads/${leadId}/outbound/scheduled/${scheduleId}`,
      headers
    );
    return data.data.data;
  } catch (err) {
    mixpanelErrorTracker.trackError('server error - cancelAiScheduledOutbound', {
      error_message: err?.response?.data?.message || err?.message || 'Unknown error',
      function_name: 'cancelAiScheduledOutbound',
      lead_id: leadId
    });
    throw err;
  }
}

